import { JSONObject } from './src/types';
import { FileUpload } from './src/types';
import { FileUploadProgressCallback } from './src/types';
import { DocumentNode } from 'graphql';
import * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactHooks from '@apollo/react-hooks';
export type Maybe<T> = T | null;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string,
  String: string,
  Boolean: boolean,
  Int: number,
  Float: number,
  /** 
 * An object which contains unknown (user generated) keys and values. Should only be used in scenarios
   * where we cannot provide stricter typing, for example, the custom emoji data required to render
   * Trello Markdown
 **/
  JSONObject: JSONObject,
  /** An alias for the File type. Should be used for any mutation where we are uploading a file. */
  FileUpload: FileUpload,
  /** 
 * A callback function that takes in a number and does not return anything. Should be used if
   * we have a resolver that uploads a file and its progress needs to be tracked.
 **/
  FileUploadProgressCallback: FileUploadProgressCallback,
};


/** 
 * Actions are generated whenever an action occurs in Trello. For instance, when a user deletes a card, a
 * `deleteCard` action is generated and includes information about the deleted card.
 **/
export type Action = {
   __typename: 'Action',
  /** The ID of the Action */
  id: Scalars['ID'],
  /** The type of the Action */
  type: Action_Type,
  /** When the Action occurred */
  date: Scalars['String'],
  /** Relevant information regarding the Action */
  data: Scalars['JSONObject'],
  /** The ID of the Member who caused the Action */
  idMemberCreator: Scalars['String'],
  /** Relevant information for displaying the Action */
  display: Action_Display,
  /** The Member who caused the Action */
  memberCreator: Member,
  /** The Reactions on the Action */
  reactions: Array<Reaction>,
};

/** Relevant information for displaying the Action */
export type Action_Display = {
   __typename: 'Action_Display',
  /** The key used to translate the Action */
  translationKey?: Maybe<Scalars['String']>,
  /** Information about any Entities involved in the Action */
  entities: Scalars['JSONObject'],
};

/** The Types of Actions */
export enum Action_Type {
  AcceptEnterpriseJoinRequest = 'acceptEnterpriseJoinRequest',
  AddAttachmentToCard = 'addAttachmentToCard',
  AddChecklistToCard = 'addChecklistToCard',
  AddMemberToBoard = 'addMemberToBoard',
  AddMemberToCard = 'addMemberToCard',
  AddMemberToOrganization = 'addMemberToOrganization',
  AddOrganizationToEnterprise = 'addOrganizationToEnterprise',
  AddToEnterprisePluginWhitelist = 'addToEnterprisePluginWhitelist',
  AddToOrganizationBoard = 'addToOrganizationBoard',
  CommentCard = 'commentCard',
  ConvertToCardFromCheckItem = 'convertToCardFromCheckItem',
  CopyBoard = 'copyBoard',
  CopyCard = 'copyCard',
  CopyCommentCard = 'copyCommentCard',
  CreateBoard = 'createBoard',
  CreateCard = 'createCard',
  CreateCustomField = 'createCustomField',
  CreateList = 'createList',
  CreateOrganization = 'createOrganization',
  DeactivatedMemberInEnterprise = 'deactivatedMemberInEnterprise',
  DeactivatedMemberInOrganization = 'deactivatedMemberInOrganization',
  DeleteAttachmentFromCard = 'deleteAttachmentFromCard',
  DeleteBoardInvitation = 'deleteBoardInvitation',
  DeleteCard = 'deleteCard',
  DeleteCustomField = 'deleteCustomField',
  DeleteOrganizationInvitation = 'deleteOrganizationInvitation',
  DisableEnterprisePluginWhitelist = 'disableEnterprisePluginWhitelist',
  DisablePlugin = 'disablePlugin',
  DisablePowerUp = 'disablePowerUp',
  EmailCard = 'emailCard',
  EnableEnterprisePluginWhitelist = 'enableEnterprisePluginWhitelist',
  EnablePlugin = 'enablePlugin',
  EnablePowerUp = 'enablePowerUp',
  MakeAdminOfBoard = 'makeAdminOfBoard',
  MakeNormalMemberOfBoard = 'makeNormalMemberOfBoard',
  MakeNormalMemberOfOrganization = 'makeNormalMemberOfOrganization',
  MakeObserverOfBoard = 'makeObserverOfBoard',
  MemberJoinedTrello = 'memberJoinedTrello',
  MoveCardFromBoard = 'moveCardFromBoard',
  MoveCardToBoard = 'moveCardToBoard',
  MoveListFromBoard = 'moveListFromBoard',
  MoveListToBoard = 'moveListToBoard',
  ReactivatedMemberInEnterprise = 'reactivatedMemberInEnterprise',
  ReactivatedMemberInOrganization = 'reactivatedMemberInOrganization',
  RemoveChecklistFromCard = 'removeChecklistFromCard',
  RemoveFromEnterprisePluginWhitelist = 'removeFromEnterprisePluginWhitelist',
  RemoveFromOrganizationBoard = 'removeFromOrganizationBoard',
  RemoveMemberFromCard = 'removeMemberFromCard',
  RemoveOrganizationFromEnterprise = 'removeOrganizationFromEnterprise',
  UnconfirmedBoardInvitation = 'unconfirmedBoardInvitation',
  UnconfirmedOrganizationInvitation = 'unconfirmedOrganizationInvitation',
  UpdateBoard = 'updateBoard',
  UpdateBoardOrg = 'updateBoardOrg',
  UpdateCard = 'updateCard',
  UpdateCheckItemStateOnCard = 'updateCheckItemStateOnCard',
  UpdateChecklist = 'updateChecklist',
  UpdateEnterprise = 'updateEnterprise',
  UpdateCustomField = 'updateCustomField',
  UpdateCustomFieldItem = 'updateCustomFieldItem',
  UpdateList = 'updateList',
  UpdateMember = 'updateMember',
  UpdateOrganization = 'updateOrganization'
}

/** Announcements appear in the header in the Taco component */
export type Announcement = {
   __typename: 'Announcement',
  /** The ID of the Announcement */
  id: Scalars['ID'],
  /** The title of the Announcement */
  title: Scalars['String'],
  /** The HTML content of the Announcement */
  html: Scalars['String'],
  /** The locale of the Announcement */
  locale: Scalars['String'],
  /** The type of Announcement */
  type: AnnouncementType,
  /** The url to learn more about the Announcement */
  url?: Maybe<Scalars['String']>,
};

/** The response when dismissing an announcement. Just indicates success */
export type Announcement_DismissResponse = {
   __typename: 'Announcement_DismissResponse',
  success: Scalars['Boolean'],
};

/** 
 * The types of Announcements. Most are blog posts, but there is a reserved type for announcing
 * maintenance downtime that will give the Roo component an alternate appearance
 **/
export enum AnnouncementType {
  Blog = 'blog',
  Downtime = 'downtime'
}

/** An object representing an attachment belonging to a card */
export type Attachment = {
   __typename: 'Attachment',
  /** The ID of the attachment */
  id: Scalars['ID'],
  /** The size of the attachment in bytes */
  bytes: Scalars['Int'],
  /** The date the attachment was added */
  date: Scalars['String'],
  /** For image attachments, the extracted edge color */
  edgeColor?: Maybe<Scalars['String']>,
  /** The ID of the member who added the attachment */
  idMember: Scalars['ID'],
  /** Whether the attachment was uploaded */
  isUpload: Scalars['Boolean'],
  /** The mimeType for the attachment */
  mimeType?: Maybe<Scalars['String']>,
  /** The name of the attachment */
  name: Scalars['String'],
  /** The position of the attachment in the attachments list */
  pos: Scalars['Float'],
  /** If the attachment is an image, an array of generated previews of the image in various sizes */
  previews?: Maybe<Array<Attachment_Preview>>,
  /** The URL to the attachment */
  url: Scalars['String'],
};

/** A filter for the Attachments being requested */
export enum Attachment_Filter {
  /** Only attachments which are Card covers */
  Cover = 'cover'
}

export type Attachment_Preview = {
   __typename: 'Attachment_Preview',
  /** The size of the attachment preview in bytes */
  bytes: Scalars['Int'],
  /** The URL to the preview */
  url: Scalars['String'],
  /** The height of the image */
  height: Scalars['Int'],
  /** The width of the image */
  width: Scalars['Int'],
  /** Whether or not the image was scaled */
  scaled: Scalars['Boolean'],
};

/** Boards are fundamental to Trello. A board may belong to 0 or 1 teams and can have 0 or more lists. */
export type Board = {
   __typename: 'Board',
  /** The Actions taken on this Board */
  actions: Array<Action>,
  /** The Butler Buttons the board owns */
  butlerButtons: Array<ButlerButton>,
  /** The Cards on the Board */
  cards: Array<Card>,
  /** The CustomFields configured for the Board */
  customFields: Array<CustomField>,
  /** The Members on the Board */
  members: Array<Member>,
  /** The Organization this Board belongs to */
  organization?: Maybe<Organization>,
  /** The Lists on the Board */
  lists: Array<List>,
  /** The Member's preferences specific to this Board */
  myPrefs: MyPrefs,
  /** The Labels on this Board */
  labels: Array<Label>,
  /** The counts of membership types on this Board */
  membershipCounts?: Maybe<MembershipCounts>,
  /** The Plugins on the Board */
  plugins: Array<Plugin>,
  /** The PluginData for this Board */
  pluginData: Array<PluginData>,
  /** The counts for this Board being starred */
  starCounts?: Maybe<StarCounts>,
  /** A specific Export on this board */
  export?: Maybe<Export>,
  /** The Exports on this Board */
  exports: Array<Export>,
  /** The ID of the Board */
  id: Scalars['ID'],
  /** The name of the Board */
  name: Scalars['String'],
  /** Boolean whether the board has been closed or not */
  closed: Scalars['Boolean'],
  /** How the Board was created */
  creationMethod?: Maybe<CreationMethod>,
  /** The date that the last activity occured on the Board */
  dateLastActivity?: Maybe<Scalars['String']>,
  /** The date that the current Member last viewed the Board */
  dateLastView?: Maybe<Scalars['String']>,
  /** The date that plugins are scheduled to be disabled */
  datePluginDisable?: Maybe<Scalars['String']>,
  /** The description of the Board (About this Board) */
  desc: Scalars['String'],
  /** If the description includes custom emoji, this object will contain the information necessary to display them. */
  descData?: Maybe<Scalars['JSONObject']>,
  /** MongoID of the organization to which the board belongs */
  idOrganization?: Maybe<Scalars['String']>,
  /** The ids for the Collections(Tags) that the Board is part of */
  idTags: Array<Scalars['String']>,
  /** MongoID of the enterprise to which the board belongs */
  enterpriseOwned: Scalars['Boolean'],
  /** The limits on the Board */
  limits: Board_Limits,
  /** Object containing color keys and the label names given for one label of each color on the board */
  labelNames: Board_LabelNames,
  /** The Memberships of the Board */
  memberships: Array<Board_Membership>,
  /** Boolean whether the board has been pinned or not */
  pinned: Scalars['Boolean'],
  /** Short for 'preferences', these are the settings for the board */
  prefs?: Maybe<Board_Prefs>,
  /** The field that determine how a template renders in the template gallery */
  templateGallery?: Maybe<TemplateGallery>,
  /** Persistent URL for the board */
  url: Scalars['String'],
  /** URL for the board using only its shortMongoID */
  shortUrl: Scalars['String'],
  /** The shortMongoId for this Board */
  shortLink: Scalars['String'],
  /** Whether the board has been starred by the current user */
  starred: Scalars['Boolean'],
  /** Whether the current Member is subscribed to the Board */
  subscribed: Scalars['Boolean'],
};


/** Boards are fundamental to Trello. A board may belong to 0 or 1 teams and can have 0 or more lists. */
export type BoardActionsArgs = {
  filter?: Maybe<Array<Action_Type>>,
  limit?: Maybe<Scalars['Int']>
};


/** Boards are fundamental to Trello. A board may belong to 0 or 1 teams and can have 0 or more lists. */
export type BoardCardsArgs = {
  filter?: Maybe<Card_Filter>
};


/** Boards are fundamental to Trello. A board may belong to 0 or 1 teams and can have 0 or more lists. */
export type BoardMembersArgs = {
  filter?: Maybe<Member_Filter>
};


/** Boards are fundamental to Trello. A board may belong to 0 or 1 teams and can have 0 or more lists. */
export type BoardListsArgs = {
  filter?: Maybe<List_Filter>
};


/** Boards are fundamental to Trello. A board may belong to 0 or 1 teams and can have 0 or more lists. */
export type BoardLabelsArgs = {
  limit?: Maybe<Scalars['Int']>
};


/** Boards are fundamental to Trello. A board may belong to 0 or 1 teams and can have 0 or more lists. */
export type BoardMembershipCountsArgs = {
  filter?: Maybe<MembershipCounts_Filter>
};


/** Boards are fundamental to Trello. A board may belong to 0 or 1 teams and can have 0 or more lists. */
export type BoardPluginsArgs = {
  filter?: Maybe<Plugin_Filter>
};


/** Boards are fundamental to Trello. A board may belong to 0 or 1 teams and can have 0 or more lists. */
export type BoardExportArgs = {
  id: Scalars['ID']
};


/** Boards are fundamental to Trello. A board may belong to 0 or 1 teams and can have 0 or more lists. */
export type BoardExportsArgs = {
  id: Scalars['ID']
};

/** A filter for the Boards being requested */
export enum Board_Filter {
  /** Returns all boards that are open */
  Open = 'open',
  /** Returns all boards that are closed */
  Closed = 'closed',
  /** Returns all boards that have visibility set to Private */
  Members = 'members',
  /** Returns all boards that have visibility set to Team */
  Organization = 'organization',
  /** Returns all boards that have visibility set to Public. */
  Public = 'public',
  /** Returns all boards that have been starred. */
  Starred = 'starred'
}

/** 
 * An object containing each of the Label colors used on a board, with their
 * corresponding names. If there are multiple labels using the same color, the first
 * name will be used.
 **/
export type Board_LabelNames = {
   __typename: 'Board_LabelNames',
  /** The first green label's name */
  green: Scalars['String'],
  /** The first yellow label's name */
  yellow: Scalars['String'],
  /** The first orange label's name */
  orange: Scalars['String'],
  /** The first red label's name */
  red: Scalars['String'],
  /** The first purple label's name */
  purple: Scalars['String'],
  /** The first blue label's name */
  blue: Scalars['String'],
  /** The first sky label's name */
  sky: Scalars['String'],
  /** The first lime label's name */
  lime: Scalars['String'],
  /** The first pink label's name */
  pink: Scalars['String'],
  /** The first black label's name */
  black: Scalars['String'],
};

/** The limits on the Board */
export type Board_Limits = {
   __typename: 'Board_Limits',
  /** The board-attachment limits */
  attachments: Board_Limits_Attachments,
  /** The board limits */
  boards: Board_Limits_Boards,
  /** The board-card limits */
  cards: Board_Limits_Cards,
  /** The board-checklist limits */
  checklists: Board_Limits_Checklists,
  /** The board-checkItem limits */
  checkItems: Board_Limits_CheckItems,
  /** The board-customField limits */
  customFields: Board_Limits_CustomFields,
  /** The board-customFieldOption limits */
  customFieldOptions: Board_Limits_CustomFieldOptions,
  /** The board-label limits */
  labels: Board_Limits_Labels,
  /** The board-list limits */
  lists: Board_Limits_Lists,
  /** The board-stickers limits */
  stickers: Board_Limits_Stickers,
  /** The board-reaction limits */
  reactions: Board_Limits_Reactions,
};

/** The board-attachment limits */
export type Board_Limits_Attachments = {
   __typename: 'Board_Limits_Attachments',
  /** Attachments per Board limit */
  perBoard: Limit,
  /** Attachments per Card limit */
  perCard: Limit,
};

/** The board limits */
export type Board_Limits_Boards = {
   __typename: 'Board_Limits_Boards',
  /** Total Members per Board limit */
  totalMembersPerBoard: Limit,
};

/** The board-card limits */
export type Board_Limits_Cards = {
   __typename: 'Board_Limits_Cards',
  /** Open Cards per Board limit */
  openPerBoard: Limit,
  /** Total Cards per Board limit */
  totalPerBoard: Limit,
  /** Open Cards per List limit */
  openPerList: Limit,
  /** Total Cards per List limit */
  totalPerList: Limit,
};

/** The board-checkItem limits */
export type Board_Limits_CheckItems = {
   __typename: 'Board_Limits_CheckItems',
  /** CheckItems per Checklist Limit */
  perChecklist: Limit,
};

/** The board-checklist limits */
export type Board_Limits_Checklists = {
   __typename: 'Board_Limits_Checklists',
  /** Checklists per Board limit */
  perBoard: Limit,
  /** Checklists per Card limit */
  perCard: Limit,
};

/** The board-customFieldOptions limits */
export type Board_Limits_CustomFieldOptions = {
   __typename: 'Board_Limits_CustomFieldOptions',
  /** CustomFieldOptions per CustomField limit */
  perField: Limit,
};

/** The board-customField limits */
export type Board_Limits_CustomFields = {
   __typename: 'Board_Limits_CustomFields',
  /** CustomFields per Board limit */
  perBoard: Limit,
};

/** The board-labeljj limits */
export type Board_Limits_Labels = {
   __typename: 'Board_Limits_Labels',
  /** Labels per Board limit */
  perBoard: Limit,
};

/** The board-list limits */
export type Board_Limits_Lists = {
   __typename: 'Board_Limits_Lists',
  /** Open Lists per Board limit */
  openPerBoard: Limit,
  /** Total Lists per Board limit */
  totalPerBoard: Limit,
};

/** The board-reaction limits */
export type Board_Limits_Reactions = {
   __typename: 'Board_Limits_Reactions',
  /** Reactions per Action limit */
  perAction: Limit,
  /** Unique Reactions per Action limit */
  uniquePerAction: Limit,
};

/** The board-sticker limits */
export type Board_Limits_Stickers = {
   __typename: 'Board_Limits_Stickers',
  /** Stickers per Card limit */
  perCard: Limit,
};

/** An association between a Member and a Board */
export type Board_Membership = {
   __typename: 'Board_Membership',
  /** The ID of the Membership */
  id: Scalars['String'],
  /** The ID of the Member */
  idMember: Scalars['String'],
  /** The type of Membership this is */
  memberType: Board_Membership_MemberType,
  /** Whether the Member has confirmed their email address */
  unconfirmed: Scalars['Boolean'],
  /** Whether the Member has been deactivated */
  deactivated: Scalars['Boolean'],
};

/** The type of membership a member has on a Board */
export enum Board_Membership_MemberType {
  /** A normal member */
  Normal = 'normal',
  /** An observer (no write permissions) */
  Observer = 'observer',
  /** An admin */
  Admin = 'admin'
}

/** The preferences for a Board */
export type Board_Prefs = {
   __typename: 'Board_Prefs',
  /** The permission level (visibility) of the Board */
  permissionLevel: Board_Prefs_PermissionLevel,
  /** Whether voting is enabled on the Board */
  voting: Scalars['Boolean'],
  /** The comment permissions for the Board */
  comments: Board_Prefs_Comments,
  /** The invite permissions for the Board */
  invitations: Board_Prefs_Invitations,
  /** Whether users are allowed to join the Board without invite */
  selfJoin: Scalars['Boolean'],
  /** Whether Card covers are enabled */
  cardCovers: Scalars['Boolean'],
  /** The Card aging mode */
  cardAging: Board_Prefs_CardAging,
  /** Whether a calendar feed is enabled for the Board */
  calendarFeedEnabled: Scalars['Boolean'],
  /** The Board background (can be a color like 'orange' or an ID */
  background: Scalars['String'],
  /** The Board background (can be a color like 'orange' or an ID) */
  backgroundImage?: Maybe<Scalars['String']>,
  /** Pre-scaled background images for the Board */
  backgroundImageScaled?: Maybe<Array<Board_Prefs_BackgroundImageScaled>>,
  /** Whether the background should tile */
  backgroundTile: Scalars['Boolean'],
  /** Whether the background is considered 'dark' or 'light' */
  backgroundBrightness: Board_Prefs_BackgroundBrightness,
  /** Hex color for the Board background */
  backgroundColor?: Maybe<Scalars['String']>,
  /** Hex color for the tope of the background */
  backgroundTopColor: Scalars['String'],
  /** Hex color for the bottom of the background */
  backgroundBottomColor: Scalars['String'],
  /** Whether the Board visibility can be set to Public */
  canBePublic: Scalars['Boolean'],
  /** Whether the Board visibility can be set to Enterprise */
  canBeEnterprise: Scalars['Boolean'],
  /** Whether the Board visibility can be set to Organization */
  canBeOrg: Scalars['Boolean'],
  /** Whether the Board visibility can be set to Private */
  canBePrivate: Scalars['Boolean'],
  /** Whether invitations are enabled for the Board */
  canInvite: Scalars['Boolean'],
  /** Whether votes from other members are hidden on this Board */
  hideVotes: Scalars['Boolean'],
  /** Whether this Board is a Template */
  isTemplate: Scalars['Boolean'],
};

/** The brightness of the Board background */
export enum Board_Prefs_BackgroundBrightness {
  Light = 'light',
  Dark = 'dark'
}

/** A pre-scaled version of the Board background */
export type Board_Prefs_BackgroundImageScaled = {
   __typename: 'Board_Prefs_BackgroundImageScaled',
  width: Scalars['Int'],
  height: Scalars['Int'],
  url: Scalars['String'],
};

/** The card aging mode of the Board */
export enum Board_Prefs_CardAging {
  /** Cards don't age */
  Regular = 'regular',
  /** Cards age in Lists */
  Pirate = 'pirate'
}

/** Board commenting permissions */
export enum Board_Prefs_Comments {
  /** Board members can comment */
  Members = 'members',
  /** Organization members can comment */
  Org = 'org',
  /** Obververs can comment */
  Observers = 'observers',
  /** Anyone can comment */
  Public = 'public',
  /** Comments are disabled */
  Disabled = 'disabled'
}

/** Board invitation permissions */
export enum Board_Prefs_Invitations {
  /** Only admins can invite more Members */
  Admins = 'admins',
  /** All Board Members can invite more Members */
  Members = 'members'
}

/** The permission level (visibility) of an Board */
export enum Board_Prefs_PermissionLevel {
  /** Visible to to Enterprise members */
  Enterprise = 'enterprise',
  /** Only visible to Board members */
  Private = 'private',
  /** Visible to everyone */
  Public = 'public',
  /** Visible to the Organization members */
  Org = 'org'
}

/** A starred Board for a Member */
export type BoardStar = {
   __typename: 'BoardStar',
  /** The ID of the BoardStar relationship */
  id: Scalars['ID'],
  /** The ID of the Board */
  idBoard: Scalars['String'],
  /** The relative position of the starred Board */
  pos: Scalars['Int'],
};

/** Butler Buttons schema */
export type ButlerButton = {
   __typename: 'ButlerButton',
  enabled: Scalars['Boolean'],
  id: Scalars['String'],
  image: Scalars['String'],
  label: Scalars['String'],
  shared: Scalars['Boolean'],
  type: Scalars['String'],
  idMemberOwner: Scalars['String'],
  idModel: Scalars['String'],
  modelType: Scalars['String'],
};

/** Ad Campaigns in Trello */
export type Campaign = {
   __typename: 'Campaign',
  id: Scalars['ID'],
  name: Scalars['String'],
  dateDismissed?: Maybe<Scalars['String']>,
  currentStep: Scalars['String'],
};

/** Lists in Trello contain Cards. A Card belongs to exactly one List. */
export type Card = {
   __typename: 'Card',
  /** The Attachments belonging to the card */
  attachments: Array<Attachment>,
  /** The members on this card */
  members: Array<Member>,
  /** The Checklists belonging to the Card */
  checklists: Array<Checklist>,
  /** The CustomFieldItems on this Card */
  customFieldItems: Array<CustomFieldItem>,
  /** The Board the Card is on */
  board: Board,
  /** The Labels on this Card */
  labels: Array<Label>,
  /** The List the Card is on */
  list: List,
  /** The PluginData for this Card */
  pluginData: Array<PluginData>,
  /** The Stickers on the card */
  stickers: Array<Sticker>,
  /** The ID of the card. */
  id: Scalars['ID'],
  /** Pieces of information about the card that are displayed on the front of the card. */
  badges: Card_Badges,
  /** 
 * Whether the card is closed (archived). Note: Archived lists and boards do not
   * cascade archives to cards. A card can have closed: false but be on an archived board.
 **/
  closed: Scalars['Boolean'],
  /** How the Card was created */
  creationMethod?: Maybe<CreationMethod>,
  /** 
 * The datetime of the last activity on the card. Note: There are activities that
   * update dateLastActivity that do not create a corresponding action. For
   * instance, updating the name field of a checklist item on a card does not
   * create an action but does update the card and board's dateLastActivity value.
 **/
  dateLastActivity: Scalars['String'],
  /** The description for the card. Up to 16384 chars. */
  desc: Scalars['String'],
  /** If the description includes custom emoji, this object will contain the information necessary to display them. */
  descData?: Maybe<Scalars['JSONObject']>,
  /** The due date on the card, if one exists. */
  due?: Maybe<Scalars['String']>,
  /** Whether the due date has been marked complete. */
  dueComplete: Scalars['Boolean'],
  /** The number of minutes before the due date that the Member should be notified. No value indicates the default (5 minutes). */
  dueReminder?: Maybe<Scalars['String']>,
  /** The email address of the Card, emails sent to this address will appear as a comment by the current Member on the Card */
  email?: Maybe<Scalars['String']>,
  /** The id of the attachment selected as the cover image, if one exists. */
  idAttachmentCover?: Maybe<Scalars['ID']>,
  /** The ID of the board the card is on. */
  idBoard: Scalars['ID'],
  /** An array of checklist IDs that are on this card. */
  idChecklists: Array<Scalars['ID']>,
  /** An array of label IDs that are on this card. */
  idLabels: Array<Scalars['ID']>,
  /** The ID of the list the card is in. */
  idList: Scalars['ID'],
  /** An array of member IDs that are on this card. */
  idMembers: Array<Scalars['ID']>,
  /** An array of member IDs who have voted on this card. */
  idMembersVoted: Array<Scalars['ID']>,
  /** Numeric ID for the card on this board. Only unique to the board, and subject to change as the card moves. */
  idShort: Scalars['Int'],
  /** The limits on the Card */
  limits: Card_Limits,
  /** Whether the card cover image was selected automatically by Trello, or manually by the user. */
  manualCoverAttachment: Scalars['Boolean'],
  /** Name of the card. */
  name: Scalars['String'],
  /** Position of the card in the list. */
  pos: Scalars['Float'],
  /** The 8 character shortened ID for the card. */
  shortLink: Scalars['String'],
  /** URL to the card without the name slug. */
  shortUrl: Scalars['String'],
  /** Whether this member is subscribed to the card. */
  subscribed: Scalars['Boolean'],
  /** Full URL to the card, with the name slug. */
  url: Scalars['String'],
  /** Address of card location. */
  address?: Maybe<Scalars['String']>,
  /** Name of card location. */
  locationName?: Maybe<Scalars['String']>,
  /** An object containing keys for latitude and longitude whose values are numbers between -180 and 180. */
  coordinates?: Maybe<Card_Coordinates>,
  /** An object containing the cover information of the card. */
  cover?: Maybe<Card_Cover>,
  /** Whether this Card is a Template */
  isTemplate: Scalars['Boolean'],
};


/** Lists in Trello contain Cards. A Card belongs to exactly one List. */
export type CardAttachmentsArgs = {
  filter?: Maybe<Attachment_Filter>
};

/** An object containing values necessary to render the front of a card */
export type Card_Badges = {
   __typename: 'Card_Badges',
  /** The number of attachments on the card */
  attachments: Scalars['Int'],
  /** An object containing more granular attachment counts */
  attachmentsByType: Card_Badges_AttachmentsByType,
  /** The count of checkItems on the card */
  checkItems: Scalars['Int'],
  /** The count of checkItems on the card in the 'complete' state */
  checkItemsChecked: Scalars['Int'],
  /** The count of comments on the card */
  comments: Scalars['Int'],
  /** A boolean indicating whether the card has a description */
  description: Scalars['Boolean'],
  /** The due date of the Card, if one has been set */
  due?: Maybe<Scalars['String']>,
  /** Whether the due date has been marked as 'complete' */
  dueComplete: Scalars['Boolean'],
  /** Whether the user is subscribed to the card */
  subscribed: Scalars['Boolean'],
  /** Whether the user has voted on the card */
  viewingMemberVoted: Scalars['Boolean'],
  /** The count of votes on the card */
  votes: Scalars['Int'],
};

/** An object containing counts of attachments by type */
export type Card_Badges_AttachmentsByType = {
   __typename: 'Card_Badges_AttachmentsByType',
  /** The trello-specific attachment counts on the Card */
  trello: Card_Badges_AttachmentsByType_Trello,
};

/** An object containing counts of trello attachments */
export type Card_Badges_AttachmentsByType_Trello = {
   __typename: 'Card_Badges_AttachmentsByType_Trello',
  /** The count of Board attachments on the Card */
  board: Scalars['Int'],
  /** The count of Card attachments on the Card */
  card: Scalars['Int'],
};

/** An object containing keys for latitude and longitude whose values are numbers between -180 and 180 */
export type Card_Coordinates = {
   __typename: 'Card_Coordinates',
  /** The latitude (between -180 and 180) */
  latitude: Scalars['Float'],
  /** The longitude (between -180 and 180) */
  longitude: Scalars['Float'],
};

export type Card_Cover = {
   __typename: 'Card_Cover',
  /** The ID of the image attachment used as the card cover. */
  idAttachment?: Maybe<Scalars['String']>,
  /** The ID of the uploaded background used as the card cover. */
  idUploadedBackground?: Maybe<Scalars['String']>,
  /** The color that is used as the card cover. */
  color?: Maybe<Scalars['String']>,
  /** The size of the card cover. It is either normal or full. */
  size?: Maybe<Scalars['String']>,
  /** The brightness for the card cover. It is either dark or light. */
  brightness?: Maybe<Scalars['String']>,
  /** If the cover is an image, an array of generated previews of the image in various sizes */
  scaled?: Maybe<Array<Card_Cover_Scaled>>,
  /** For image covers, the extracted edge color */
  edgeColor?: Maybe<Scalars['String']>,
  /** For shared uploaded backgrounds, the url that the image was downloaded from */
  sharedSourceUrl?: Maybe<Scalars['String']>,
};

export type Card_Cover_Scaled = {
   __typename: 'Card_Cover_Scaled',
  /** The size of the cover preview in bytes */
  bytes: Scalars['Int'],
  /** The URL to the preview */
  url: Scalars['String'],
  /** The height of the image */
  height: Scalars['Int'],
  /** The width of the image */
  width: Scalars['Int'],
  /** Whether or not the image was scaled */
  scaled: Scalars['Boolean'],
};

/** An object representing the response from the deleteCard mutation */
export type Card_DeleteResponse = {
   __typename: 'Card_DeleteResponse',
  /** Whether the deletion was successful */
  success: Scalars['Boolean'],
};

/** A filter for the Cards being requested */
export enum Card_Filter {
  /** Returns all cards that are open in lists that have not been archived */
  Open = 'open',
  /** Returns all cards that are closed or in lists that have been archived */
  Closed = 'closed',
  /** Returns all open cards in lists that are not closed */
  Visible = 'visible',
  /** Returns all template cards */
  Template = 'template'
}

/** The limits on the Card */
export type Card_Limits = {
   __typename: 'Card_Limits',
  /** The card-attachment limits */
  attachments: Card_Limits_Attachments,
  /** The card-checklist limits */
  checklists: Card_Limits_Checklists,
  /** The card-sticker limits */
  stickers: Card_Limits_Stickers,
};

/** The card-attachment limits */
export type Card_Limits_Attachments = {
   __typename: 'Card_Limits_Attachments',
  /** Attachments per Card limit */
  perCard: Card_Limits_Attachments_PerCard,
};

/** Attachments per Card limit */
export type Card_Limits_Attachments_PerCard = {
   __typename: 'Card_Limits_Attachments_PerCard',
  /** The threshold at which a limit will enter the 'warn' status */
  warnAt: Scalars['Int'],
  /** The threshold at which a limit will enter the 'disabled'/'maxExceeded' status */
  disableAt: Scalars['Int'],
  /** The status of the limit */
  status: LimitStatus,
  /** The count that the limited number is currently at. Will only be populated for limits over the warn threshold */
  count?: Maybe<Scalars['Int']>,
};

/** The card-checklist limits */
export type Card_Limits_Checklists = {
   __typename: 'Card_Limits_Checklists',
  /** Checklists per Card limit */
  perCard: Card_Limits_Checklists_PerCard,
};

/** Checklists per Card limit */
export type Card_Limits_Checklists_PerCard = {
   __typename: 'Card_Limits_Checklists_PerCard',
  /** The threshold at which a limit will enter the 'warn' status */
  warnAt: Scalars['Int'],
  /** The threshold at which a limit will enter the 'disabled'/'maxExceeded' status */
  disableAt: Scalars['Int'],
  /** The status of the limit */
  status: LimitStatus,
  /** The count that the limited number is currently at. Will only be populated for limits over the warn threshold */
  count?: Maybe<Scalars['Int']>,
};

/** The card-sticker limits */
export type Card_Limits_Stickers = {
   __typename: 'Card_Limits_Stickers',
  /** Stickers per Card limit */
  perCard: Card_Limits_Stickers_PerCard,
};

/** Stickers per Card limit */
export type Card_Limits_Stickers_PerCard = {
   __typename: 'Card_Limits_Stickers_PerCard',
  /** The threshold at which a limit will enter the 'warn' status */
  warnAt: Scalars['Int'],
  /** The threshold at which a limit will enter the 'disabled'/'maxExceeded' status */
  disableAt: Scalars['Int'],
  /** The status of the limit */
  status: LimitStatus,
  /** The count that the limited number is currently at. Will only be populated for limits over the warn threshold */
  count?: Maybe<Scalars['Int']>,
};

/** The information about the channel (stable/beta/alpha) the Member is on and what they have access to */
export type Channels = {
   __typename: 'Channels',
  /** Whether the Member is allowed to pick releases from the Channel Switcher */
  dev: Scalars['Boolean'],
  /** The channel the Member is currently using */
  active: Scalars['String'],
  /** The channels the Member is allowed to use */
  allowed: Array<Scalars['String']>,
};

/** 
 * CheckItems in Trello are contained within Checklists on a Card. They represent a single
 * task to be done and can be in an 'incomplete' or 'complete' state
 **/
export type CheckItem = {
   __typename: 'CheckItem',
  /** The ID of the check item. */
  id: Scalars['ID'],
  /** The ID of the checklist the check item is on. */
  idChecklist: Scalars['ID'],
  /** The name of the check item. */
  name: Scalars['String'],
  /** The position of the check item on the checklist (relative to any other check items on the checklist). */
  pos: Scalars['Float'],
  /** The state of the check item. */
  state: CheckItem_State,
  /** A temporary ID that is returned when creating a new check item */
  temporaryId?: Maybe<Scalars['String']>,
};

/** An object representing the response from the deleteCheckItem mutation */
export type CheckItem_DeleteResponse = {
   __typename: 'CheckItem_DeleteResponse',
  /** Whether the deletion was successful */
  success: Scalars['Boolean'],
};

/** The completion state of a CheckItem */
export enum CheckItem_State {
  Complete = 'complete',
  Incomplete = 'incomplete'
}

/** CheckLists are a container for CheckItems on a Card */
export type Checklist = {
   __typename: 'Checklist',
  /** The list of CheckItems contained within this Checklist */
  checkItems: Array<CheckItem>,
  /** The cards the Checklist is on */
  cards: Array<Card>,
  /** The ID of the checklist. */
  id: Scalars['ID'],
  /** The ID of the board the checklist is on. */
  idBoard: Scalars['ID'],
  /** The ID of the card the checklist is on. */
  idCard: Scalars['ID'],
  /** The name of the checklist. */
  name: Scalars['String'],
  /** The position of the checklist on the card (relative to any other checklists on the card). */
  pos: Scalars['Float'],
  /** A temporary ID that is returned when creating a new checklist */
  temporaryId?: Maybe<Scalars['String']>,
};

/** An object representing the response from the deleteChecklist mutation */
export type Checklist_DeleteResponse = {
   __typename: 'Checklist_DeleteResponse',
  /** Whether the deletion was successful */
  success: Scalars['Boolean'],
};

/** 
 * An organization owned by a managed member of an enterprise. This is not a model, but rather just a set
 * of fields of an Organization that is solely used for the enteprise dashboard.
 **/
export type ClaimableOrganization = {
   __typename: 'ClaimableOrganization',
  id: Scalars['ID'],
  products: Array<Scalars['Int']>,
  name: Scalars['String'],
  displayName: Scalars['String'],
  idActiveAdmins: Array<Scalars['ID']>,
  activeMembershipCount: Scalars['Int'],
};

/** 
 * The list of claimable organizations (see below), as well as the total count (the endpoint does not return
 * all of them)
 **/
export type ClaimableOrganizations = {
   __typename: 'ClaimableOrganizations',
  organizations: Array<ClaimableOrganization>,
  count: Scalars['Int'],
};

/** How an item was created */
export enum CreationMethod {
  /** Item was created to demonstrate Trello features. eg. Cards on the welcome board */
  Demo = 'demo',
  /** Item was generated without the member input, eg. the ToDo board created for new users */
  Automatic = 'automatic',
  /** Item was generated automatically, but with some member input. eg. Cards created through the onboarding flow */
  Assisted = 'assisted'
}

/** A Credit indicates a 'free reward' (typically free bc or gold membership) */
export type Credit = {
   __typename: 'Credit',
  /** The ID of the model these credits are for */
  idModel: Scalars['String'],
  /** The type of entity these credits are for (Member or Organization) */
  modelType: Scalars['String'],
  /** The ID of the member that was invited to earn these credits */
  idMemberInvited?: Maybe<Scalars['String']>,
  /** The count of credits */
  count: Scalars['Int'],
  /** Whether the credits have been applied */
  applied: Scalars['Boolean'],
  /** The type of Credit this is */
  type: Credit_Type,
  /** A description of how the Credit was rewarded */
  via?: Maybe<Scalars['String']>,
  /** The reward for the Credit (gold or bc) */
  reward?: Maybe<Credit_Reward>,
};

/** A reward applicable to a Credit */
export enum Credit_Reward {
  Gold = 'gold',
  Bc = 'bc'
}

/** The type of the Credit */
export enum Credit_Type {
  Invitation = 'invitation',
  PromoCode = 'promoCode',
  Support = 'support'
}

/** A configurable field that can be added to a Card, and optionally shown on the Card Front */
export type CustomField = {
   __typename: 'CustomField',
  /** The ID of the CustomField */
  id: Scalars['ID'],
  /** The ID of the model that the CustomField is configured for */
  idModel: Scalars['String'],
  /** The type of the model that the CustomField is on (currently only Board) */
  modelType: Scalars['String'],
  /** The computed has of the name and type fields of this CustomField (sometimes used for grouping) */
  fieldGroup: Scalars['String'],
  /** The display options for the CustomField */
  display: CustomField_Display,
  /** The position (on the Card back and Card front) of the CustomField relative to others */
  pos: Scalars['Int'],
  /** The type of CustomField this is */
  type: CustomField_Type,
  /** The list of options available to a 'list' CustomField */
  options?: Maybe<Array<CustomField_Option>>,
};

/** Configuration for displaying a CustomField */
export type CustomField_Display = {
   __typename: 'CustomField_Display',
  /** Whether the CustomField should be displayed on the card front */
  cardFront: Scalars['Boolean'],
};

/** An option in the 'list' CustomField */
export type CustomField_Option = {
   __typename: 'CustomField_Option',
  /** The ID of the CustomField option */
  id: Scalars['ID'],
  /** The ID of the CustomField this option belongs to */
  idCustomField: Scalars['String'],
  /** The value for the CustomField option */
  value: CustomField_Option_Value,
  /** The color of the CustomField option (can be 'none') */
  color: Scalars['String'],
  /** An integer indicating the position of the CustomField Option in its list */
  pos: Scalars['Int'],
};

/** The value for a CustomField option */
export type CustomField_Option_Value = {
   __typename: 'CustomField_Option_Value',
  /** The text value for a CustomField option */
  text: Scalars['String'],
};

/** The type of a CustomField */
export enum CustomField_Type {
  Checkbox = 'checkbox',
  Number = 'number',
  List = 'list',
  Date = 'date',
  Text = 'text'
}

/** An item representing a value for a particular CustomField on a Card */
export type CustomFieldItem = {
   __typename: 'CustomFieldItem',
  /** The ID of the CustomFieldItem */
  id: Scalars['ID'],
  /** The ID of the CustomField that this item holds a value for */
  idCustomField: Scalars['String'],
  /** The ID of the model this CustomFieldItem is on (the Card ID) */
  idModel: Scalars['String'],
  /** The type of model this CustomFieldItem is on (only Cards are supported) */
  modelType: CustomFieldItem_ModelType,
  /** The value for this CustomFieldItem, the shape of this data depends on the type of CustomField this is for */
  value: Scalars['JSONObject'],
};

/** The type of model a CustomFieldItem is on (only Cards are supported) */
export enum CustomFieldItem_ModelType {
  Card = 'card'
}

/** The name and url of a given email provider that is retrieved from the MX records for a given email address */
export type EmailProvider = {
   __typename: 'EmailProvider',
  /** Name of the email provider e.g. Gmail */
  name: Scalars['String'],
  /** Url to the providers inbox */
  url: Scalars['String'],
};

/** An Enterprise in Trello is made up of many Organizations (teams) */
export type Enterprise = {
   __typename: 'Enterprise',
  /** The ID of the Enterprise */
  id: Scalars['ID'],
  /** A list of teams that can be claimed by an enterprise */
  claimableOrganizations: ClaimableOrganizations,
  /** The display name of the Enterprise */
  displayName: Scalars['String'],
  /** Domains claimed by the Enterprise */
  enterpriseDomains: Array<Scalars['String']>,
  /** Whether this Enterprise has any claimed domains */
  hasClaimedDomains: Scalars['Boolean'],
  /** The ids of the admins in the enterprise */
  idAdmins: Array<Scalars['String']>,
  /** The ids of the plugins allowed on the Enterprise */
  idPluginsAllowed: Array<Scalars['String']>,
  /** Whether this Enterprise is really an Enterprise, or a Business Class Purchase Order (BCPO) 'Enterprise' */
  isRealEnterprise: Scalars['Boolean'],
  /** The hash of the custom logo for the Enterprise */
  logoHash?: Maybe<Scalars['String']>,
  /** The URL of the custom logo for the Enterprise */
  logoUrl?: Maybe<Scalars['String']>,
  /** The name of the Enterprise */
  name: Scalars['String'],
  /** The overridden prefs for individual Organizations owned by the Enterprise */
  organizationPrefs: Organization_Prefs,
  /** Whether the Enterprise has enabled plugin whitelisting restrictions */
  pluginWhitelistingEnabled: Scalars['Boolean'],
  /** The preferences for the Enterprise */
  prefs?: Maybe<Enterprise_Prefs>,
  /** Data used to represent the effects of transferring an organization to an enterprise */
  transferrableData: TransferrableData,
  /** Data regarding the Enterprise's licenses */
  licenses: Enterprise_Licenses,
};


/** An Enterprise in Trello is made up of many Organizations (teams) */
export type EnterpriseTransferrableDataArgs = {
  idOrganization: Scalars['ID']
};

/** A filter for the Enterprises being requested */
export enum Enterprise_Filter {
  /** Only Enterprises that 'own' the Member */
  Owned = 'owned'
}

export type Enterprise_Licenses = {
   __typename: 'Enterprise_Licenses',
  /** The maximum number of members allowed in the Enterprise without purchasing additional seats */
  maxMembers?: Maybe<Scalars['Int']>,
  /** The number of members in the Enterprise */
  totalMembers: Scalars['Int'],
};

/** Represents the preferences of an Enterprise */
export type Enterprise_Prefs = {
   __typename: 'Enterprise_Prefs',
  /** The custom branding color for the Enterprise */
  brandingColor?: Maybe<Scalars['String']>,
};

export type Export = {
   __typename: 'Export',
  id: Scalars['ID'],
  status: ExportStatus,
  size?: Maybe<Scalars['Int']>,
};

export enum ExportStage {
  ExportQueued = 'Export_queued',
  PreparingToExport = 'Preparing_to_export',
  FetchingBoardData = 'Fetching_board_data',
  CreatingArchive = 'Creating_archive',
  ExportCompleted = 'Export_completed',
  ExportFailed = 'Export_failed'
}

export type ExportStatus = {
   __typename: 'ExportStatus',
  attempts: Scalars['Int'],
  finished: Scalars['Boolean'],
  stage: ExportStage,
};



export type InputCover = {
  idAttachment?: Maybe<Scalars['String']>,
  idUploadedBackground?: Maybe<Scalars['String']>,
  url?: Maybe<Scalars['String']>,
  color?: Maybe<Scalars['String']>,
  brightness?: Maybe<Scalars['String']>,
  size?: Maybe<Scalars['String']>,
};

export type InputPluginListing = {
  /** The name of the plugin. */
  name: Scalars['String'],
  /** The locale of the listing. */
  locale: Scalars['String'],
  /** The description of the plugin. */
  description: Scalars['String'],
  /** The overview of the plugin. */
  overview: Scalars['String'],
};

/** Response from adding a member to a team */
export type InviteMember_Response = {
   __typename: 'InviteMember_Response',
  success: Scalars['Boolean'],
  error?: Maybe<Scalars['String']>,
};


/** Labels are defined per board, and can be applied to the cards on that board */
export type Label = {
   __typename: 'Label',
  /** The ID of the Label */
  id: Scalars['ID'],
  /** The name of the label. */
  name: Scalars['String'],
  /** The ID of the board the label is on. */
  idBoard: Scalars['String'],
  /** The color of the label. */
  color?: Maybe<Scalars['String']>,
};

/** An object containing information about a Limit */
export type Limit = {
   __typename: 'Limit',
  /** The threshold at which a limit will enter the 'warn' status */
  warnAt: Scalars['Int'],
  /** The threshold at which a limit will enter the 'disabled'/'maxExceeded' status */
  disableAt: Scalars['Int'],
  /** The status of the limit */
  status: LimitStatus,
  /** The count that the limited number is currently at. Will only be populated for limits over the warn threshold */
  count?: Maybe<Scalars['Int']>,
};

/** The status of a Limit */
export enum LimitStatus {
  /** The limit is not within the warning range */
  Ok = 'ok',
  /** The limit is at/over the warning threshold */
  Warn = 'warn',
  /** The limit is at the disabled threshold */
  Disabled = 'disabled',
  /** The limit is over the disabled thershold */
  MaxExceeded = 'maxExceeded'
}

/** A Board is made up of vertical Lists which contain Cards */
export type List = {
   __typename: 'List',
  /** The Cards in the List */
  cards: Array<Card>,
  /** The Board that the List is on */
  board: Board,
  /** The ID of the List */
  id: Scalars['String'],
  /** Whether the List is closed (archived) */
  closed: Scalars['Boolean'],
  /** How the List was created */
  creationMethod?: Maybe<CreationMethod>,
  /** The limits on the List */
  limits: List_Limits,
  /** The name of the List */
  name: Scalars['String'],
  /** The ID of the Board the List is on */
  idBoard: Scalars['String'],
  /** The position of the List on the Board */
  pos: Scalars['Float'],
  /** The 'soft' limit of Cards in the List */
  softLimit?: Maybe<Scalars['Int']>,
  /** Whether the Member is subscribed to this List */
  subscribed: Scalars['Boolean'],
};


/** A Board is made up of vertical Lists which contain Cards */
export type ListCardsArgs = {
  filter?: Maybe<Card_Filter>
};

/** A filter for the Lists being requested */
export enum List_Filter {
  /** Only open Lists */
  Open = 'open',
  /** Only closed (archived) Lists */
  Closed = 'closed'
}

/** The limits on the List */
export type List_Limits = {
   __typename: 'List_Limits',
  /** The list-card limits */
  cards: List_Limits_Cards,
};

/** The list-card limits */
export type List_Limits_Cards = {
   __typename: 'List_Limits_Cards',
  /** Open Cards per List Limit */
  openPerList: Limit,
  /** Total Cards per List Limit */
  totalPerList: Limit,
};

/** A Login method for a Member */
export type Login = {
   __typename: 'Login',
  /** The ID of the Login */
  id: Scalars['ID'],
  /** The email address associated with this Login */
  email: Scalars['String'],
  /** Whether this is the primary login for this user */
  primary: Scalars['Boolean'],
  /** The types of Login methods that can be used with this email */
  types: Array<Member_LoginType>,
};

/** Everyone with a Trello account is called a member. */
export type Member = {
   __typename: 'Member',
  /** The boards the user is a member of */
  boards: Array<Board>,
  /** The Boards the Member has starred */
  boardStars: Array<BoardStar>,
  /** The ad campaigns the member is in */
  campaigns: Array<Campaign>,
  /** The Credits owned by this Member */
  credits: Array<Credit>,
  /** The cards the member is on */
  cards: Array<Card>,
  /** The information about the channel (stable/beta/alpha) the Member is on and what they have access to */
  channels?: Maybe<Channels>,
  /** The organizations the user is a member of */
  organizations: Array<Organization>,
  /** The Enterprises this Member is a part of */
  enterprises: Array<Enterprise>,
  /** The PluginData on this Member */
  pluginData: Array<PluginData>,
  /** The saved search queries for this Member */
  savedSearches: Array<SavedSearch>,
  /** The ID of the member. */
  id: Scalars['ID'],
  /** Whether activity has been blocked for this Member */
  activityBlocked: Scalars['Boolean'],
  /** The Atlassian Account ID of the member. */
  aaId?: Maybe<Scalars['String']>,
  /** The Atlassian Account email of the member. */
  aaEmail?: Maybe<Scalars['String']>,
  /** Whether the member is 'mastered' by Atlassian Account */
  isAaMastered: Scalars['Boolean'],
  /** Date the member was enrolled to an Atlassian Account */
  aaEnrolledDate?: Maybe<Scalars['String']>,
  /** 
 * Member profile images are hosted at:
   * https://trello-avatars.s3.amazonaws.com/{avatarHash}/{size}.png size can be 30, 50, or 170
 **/
  avatarHash?: Maybe<Scalars['String']>,
  /** The URL of the current avatar being used, regardless of whether it is a gravatar or uploaded avatar. */
  avatarUrl?: Maybe<Scalars['String']>,
  /** The source of the user's avatar - either via 'upload' or 'gravatar'. */
  avatarSource?: Maybe<Member_AvatarSource>,
  /** Optional bio for the member. */
  bio: Scalars['String'],
  /** If the bio includes custom emoji, this object will contain the information necessary to display them. */
  bioData?: Maybe<Scalars['JSONObject']>,
  /** Whether the member has confirmed their email address after signing up. */
  confirmed: Scalars['Boolean'],
  /** The primary email address for the member. You can only read your own. */
  email?: Maybe<Scalars['String']>,
  /** The full display name for the member. */
  fullName?: Maybe<Scalars['String']>,
  /** 
 * Same as avatarHash above; member profile images are hosted at:
   * https://trello-avatars.s3.amazonaws.com/{gravatarHash}/{size}.png size can be
   * 30, 50, or 170 string.
 **/
  gravatarHash?: Maybe<Scalars['String']>,
  /** An array of board IDs this member is on. */
  idBoards: Array<Scalars['String']>,
  /** An array of organization IDs this member is in. */
  idOrganizations: Array<Scalars['String']>,
  /** The enterprise that 'owns' this Member (i.e this member is owned by a Trello Enterprise customer) */
  idEnterprise?: Maybe<Scalars['String']>,
  /** Enterprises that have explicitly deactivated this member */
  idEnterprisesDeactivated: Array<Scalars['String']>,
  /** The id of the Member that referred this Member to Trello */
  idMemberReferrer?: Maybe<Scalars['String']>,
  /** An array of enterprise IDs this member is an admin of. */
  idEnterprisesAdmin: Array<Scalars['String']>,
  /** An array of organization IDs this member is an admin of. */
  idPremOrgsAdmin: Array<Scalars['String']>,
  /** How many delta updates have been processed by this Member */
  ixUpdate: Scalars['String'],
  /** The member's initials, used for display when there isn't an avatar set. */
  initials?: Maybe<Scalars['String']>,
  /** The types of logins a user can use: password, saml, google, android or atlassian */
  loginTypes?: Maybe<Array<Maybe<Member_LoginType>>>,
  /** The limits on this Member */
  limits: Member_Limits,
  /** Information about if/when the Member has opted in/out of marketing communication */
  marketingOptIn: Member_MarketingOptIn,
  /** One of: 'normal', 'ghost'. A ghost is an individual who has been invited to join but has not yet created a Trello account. */
  memberType: Member_MemberType,
  /** Information about in-app messages that the Member has dismissed */
  messagesDismissed?: Maybe<Array<Member_MessageDismissed>>,
  /** The information the Member has chosen to be non-public */
  nonPublic?: Maybe<Member_NonPublic>,
  /** Whether non public information is available for the Member */
  nonPublicAvailable: Scalars['Boolean'],
  /** A list of the 'one time messages' that have been dismissed by the member */
  oneTimeMessagesDismissed?: Maybe<Array<Maybe<Scalars['String']>>>,
  /** Information about the paid account of Member */
  paidAccount: PaidAccount,
  /** The preferences (settings) for this member */
  prefs?: Maybe<Member_Prefs>,
  /** The premium features allowed for this member */
  premiumFeatures: Array<Scalars['String']>,
  /** 
 * 10 - member has Trello Gold as a result of being in a Business Class team. 37
   * - member has monthly Trello Gold. 38 - member has annual Trello Gold.
 **/
  products: Array<Scalars['Int']>,
  /** The trophies the Member has earned */
  trophies: Array<Scalars['String']>,
  /** 
 * Same as avatarHash - member profile images are hosted at:
   * https://trello-avatars.s3.amazonaws.com/{uploadedAvatarHash}/{size}.png size
   * can be 30, 50, or 170.
 **/
  uploadedAvatarHash?: Maybe<Scalars['String']>,
  /** The URL of the uploaded avatar if one has been uploaded. */
  uploadedAvatarUrl?: Maybe<Scalars['String']>,
  /** The URL to the member's profile page. */
  url: Scalars['String'],
  /** The username for the member. What is shown in @mentions for example. */
  username: Scalars['String'],
  /** The logins for the members. */
  logins: Array<Login>,
  /** The agreements made by the member. */
  agreements: Array<Member_Agreement>,
};


/** Everyone with a Trello account is called a member. */
export type MemberBoardsArgs = {
  filter?: Maybe<Board_Filter>
};


/** Everyone with a Trello account is called a member. */
export type MemberCreditsArgs = {
  filter: Array<Credit_Type>
};


/** Everyone with a Trello account is called a member. */
export type MemberCardsArgs = {
  filter?: Maybe<Card_Filter>
};


/** Everyone with a Trello account is called a member. */
export type MemberOrganizationsArgs = {
  filter?: Maybe<Organization_Filter>
};


/** Everyone with a Trello account is called a member. */
export type MemberEnterprisesArgs = {
  filter?: Maybe<Enterprise_Filter>
};

/** The agreements made by the member */
export type Member_Agreement = {
   __typename: 'Member_Agreement',
  id: Scalars['ID'],
  agreementType: Scalars['String'],
};

/** The source of an avatar */
export enum Member_AvatarSource {
  /** No avatar */
  None = 'none',
  /** The avatar is hosted by gravatar */
  Gravatar = 'gravatar',
  /** The avatar has been uploaded */
  Upload = 'upload'
}

/** A filter for the Members being requested */
export enum Member_Filter {
  /** Normal members of the Organization or Board */
  Normal = 'normal',
  /** Admin members of the Organization or Board */
  Admins = 'admins'
}

/** The limits on the Member */
export type Member_Limits = {
   __typename: 'Member_Limits',
  /** The member-board limits */
  boards: Member_Limits_Boards,
  /** The member-organization limits */
  orgs: Member_Limits_Orgs,
};

/** The member-board limits */
export type Member_Limits_Boards = {
   __typename: 'Member_Limits_Boards',
  /** The limit for the total boards per member */
  totalPerMember: Limit,
};

/** The member-organization limits */
export type Member_Limits_Orgs = {
   __typename: 'Member_Limits_Orgs',
  /** The limit for the total organizations per member */
  totalPerMember: Limit,
};

/** The types of logins a user can use */
export enum Member_LoginType {
  Android = 'android',
  Atlassian = 'atlassian',
  Google = 'google',
  Password = 'password',
  Saml = 'saml'
}

/** Information about if/when the Member has opted in/out of marketing communication */
export type Member_MarketingOptIn = {
   __typename: 'Member_MarketingOptIn',
  /** Whether the Member is opted in to marketing communication */
  optedIn: Scalars['Boolean'],
  /** When the Member last opted in/out of marketing communication */
  date: Scalars['String'],
};

/** 
 * Whether the member is a registered Trello user or a 'ghost' user
 * created by an email invite
 **/
export enum Member_MemberType {
  Ghost = 'ghost',
  Normal = 'normal'
}

/** Information about in-app messages that the Member has dismissed */
export type Member_MessageDismissed = {
   __typename: 'Member_MessageDismissed',
  /** The ID of the MessageDismissed record (not the id of the message itself) */
  id: Scalars['ID'],
  /** The name of the message dismissed */
  name: Scalars['String'],
  /** The number of times the message has been dismissed */
  count: Scalars['Int'],
  /** The date the message was last dismissed */
  lastDismissed: Scalars['String'],
};

/** The information the Member has chosen to be non-public */
export type Member_NonPublic = {
   __typename: 'Member_NonPublic',
  /** The URL of the current avatar being used, regardless of whether it is a gravatar or uploaded avatar. */
  avatarUrl?: Maybe<Scalars['String']>,
  /** 
 * Member profile images are hosted at:
   * https://trello-avatars.s3.amazonaws.com/{avatarHash}/{size}.png size can be 30, 50, or 170
 **/
  avatarHash?: Maybe<Scalars['String']>,
  /** The member's initials, used for display when there isn't an avatar set. */
  initials?: Maybe<Scalars['String']>,
  /** The full display name for the member. */
  fullName?: Maybe<Scalars['String']>,
};

/** The preferences for a Member */
export type Member_Prefs = {
   __typename: 'Member_Prefs',
  /** How often the user should receive email summaries */
  minutesBetweenSummaries: Scalars['Int'],
  /** The default minutes before a due date to send a notification */
  minutesBeforeDeadlineToNotify: Scalars['Int'],
  /** Whether the user has enabled color blind mode */
  colorBlind: Scalars['Boolean'],
  /** The user's locale preference */
  locale: Scalars['String'],
  /** The users timezone preference */
  timezoneInfo: Member_Prefs_TimezoneInfo,
  /** The users twoFactor authentication info */
  twoFactor?: Maybe<Member_Prefs_TwoFactor>,
  /** Privacy settings for a user's details */
  privacy: Member_Prefs_Privacy,
};

/** Privacy settings for a user's details */
export type Member_Prefs_Privacy = {
   __typename: 'Member_Prefs_Privacy',
  /** Privacy setting for displaying the user's full name */
  fullName: Member_Prefs_PrivacyOption,
  /** Privacy setting for displaying the user's avatar */
  avatar: Member_Prefs_PrivacyOption,
};

/** The visibility of a user detail */
export enum Member_Prefs_PrivacyOption {
  /** Visible to everyone */
  Public = 'public',
  /** Not visible to anyone */
  Private = 'private',
  /** Visible to collaborators only */
  Collaborator = 'collaborator'
}

/** Information about a user's Timezone */
export type Member_Prefs_TimezoneInfo = {
   __typename: 'Member_Prefs_TimezoneInfo',
  timezoneNext: Scalars['String'],
  dateNext: Scalars['String'],
  offsetNext: Scalars['Int'],
  timezoneCurrent: Scalars['String'],
  offsetCurrent: Scalars['Int'],
};

/** Information about a user's 2-factor authentication */
export type Member_Prefs_TwoFactor = {
   __typename: 'Member_Prefs_TwoFactor',
  /** Whether 2-factor-auth is enabled for the user */
  enabled: Scalars['Boolean'],
  /** Whether new backup codes are needed for the user */
  needsNewBackups: Scalars['Boolean'],
};

/** Member as Input for adding a member to a team */
export type MemberOrEmail = {
  id?: Maybe<Scalars['ID']>,
  email?: Maybe<Scalars['String']>,
};

/** Counts of various membership types on the Board */
export type MembershipCounts = {
   __typename: 'MembershipCounts',
  /** 0 or 1 indicating whether you are a Member of the Board */
  me?: Maybe<Scalars['Int']>,
  /** The count of normal Members on the Board */
  normal?: Maybe<Scalars['Int']>,
  /** The count of admin Members on the Board */
  admin?: Maybe<Scalars['Int']>,
  /** The count of active Members on the Board */
  active?: Maybe<Scalars['Int']>,
  /** The count of deactivated Members on the Board */
  deactivated?: Maybe<Scalars['Int']>,
};

/** Filters for only certain counts to be aggregated on MembershipCounts */
export enum MembershipCounts_Filter {
  Me = 'me',
  Normal = 'normal',
  Admin = 'admin',
  Active = 'active',
  Deactivated = 'deactivated'
}

export type Mutation = {
   __typename: 'Mutation',
  /** Adds a message to oneTimeMessagesDismissed */
  addOneTimeMessagesDismissed?: Maybe<Member>,
  /** Adds Members to Organization */
  addMembersToOrg?: Maybe<InviteMember_Response>,
  /** Creates an organization */
  createOrganization?: Maybe<Organization>,
  /** Update the locale of the user */
  updateUserLocale?: Maybe<Member>,
  /** Set an Atlassian Account login ID as the primary login, and delete all other logins */
  prepMemberForAtlassianAccountOnboarding?: Maybe<Member>,
  /** Internal endpoint for development and trelloinc members */
  deleteOneTimeMessagesDismissed?: Maybe<Member>,
  /** Dismisses an Announcement */
  dismissAnnouncement?: Maybe<Announcement_DismissResponse>,
  /** Add a CheckItem to a checklist on a Card */
  addCheckItem?: Maybe<CheckItem>,
  /** Add a Checklist to a Card */
  addChecklist?: Maybe<Checklist>,
  /** Delete a CheckItem from a Checklist on a Card */
  deleteCheckItem?: Maybe<CheckItem_DeleteResponse>,
  /** Delete a Checklist from a Card */
  deleteChecklist?: Maybe<Checklist_DeleteResponse>,
  /** Adds a campaign */
  addCampaign?: Maybe<Campaign>,
  /** Updates a campaign */
  updateCampaign?: Maybe<Campaign>,
  /** Updates a board's org. If no boardId is given, the board becomes a personal board. */
  updateBoardOrg?: Maybe<Board>,
  /** Update the name of a CheckItem */
  updateCheckItemName?: Maybe<CheckItem>,
  /** Update the vertical position of a CheckItem in its Checklist */
  updateCheckItemPos?: Maybe<CheckItem>,
  /** Update the 'checked' state of a CheckItem */
  updateCheckItemState?: Maybe<CheckItem>,
  /** Update the name of a Checklist */
  updateChecklistName?: Maybe<Checklist>,
  /** Update the name of a Checklist */
  updateChecklistPos?: Maybe<Checklist>,
  /** Enable a Plugin on a Board */
  enablePlugin?: Maybe<Plugin_EnableResponse>,
  /** Update a Plugin */
  updatePlugin?: Maybe<Plugin>,
  /** Copies a board to an organization's workspace */
  copyBoardToOrg?: Maybe<Board>,
  /** Create a Plugin */
  createPlugin?: Maybe<Plugin>,
  /** Delete a Plugin */
  deletePlugin?: Maybe<Plugin_DeleteResponse>,
  /** Create a Plugin listing */
  createPluginListing?: Maybe<Plugin_Listing>,
  /** Update a Plugin's listing */
  updatePluginListing?: Maybe<Plugin_Listing>,
  /** Create an Agreement for developer terms */
  acceptDeveloperTerms?: Maybe<Member_Agreement>,
  /** Update a member's avatar source */
  updateMemberAvatarSource?: Maybe<Member>,
  /** Upload a new avatar */
  uploadMemberAvatar?: Maybe<Member>,
  /** Upload a card cover */
  uploadCardCover?: Maybe<Attachment>,
  /** Update a card cover */
  updateCardCover?: Maybe<Card>,
  /** Adds a new email to the current member */
  addMemberEmail?: Maybe<Member>,
  /** Resend verification email */
  resendVerificationEmail?: Maybe<Member>,
  /** Create a new template card */
  createCardTemplate?: Maybe<Card>,
  /** Copies a card */
  copyCard?: Maybe<Card>,
  /** Delete a card */
  deleteCard?: Maybe<Card_DeleteResponse>,
  /** Start board export */
  startBoardExport?: Maybe<Export>,
  /** Put a team under an Enterprise's ownership */
  claimOrganization: Organization,
};


export type MutationAddOneTimeMessagesDismissedArgs = {
  memberId: Scalars['ID'],
  messageId: Scalars['ID']
};


export type MutationAddMembersToOrgArgs = {
  orgId: Scalars['ID'],
  users: Array<Maybe<MemberOrEmail>>,
  invitationMessage: Scalars['String']
};


export type MutationCreateOrganizationArgs = {
  displayName: Scalars['String'],
  type: Scalars['String'],
  desc?: Maybe<Scalars['String']>,
  enterprise?: Maybe<Scalars['String']>,
  allAdminsEnabled?: Maybe<Scalars['Boolean']>
};


export type MutationUpdateUserLocaleArgs = {
  memberId: Scalars['ID'],
  locale: Scalars['String']
};


export type MutationPrepMemberForAtlassianAccountOnboardingArgs = {
  memberId: Scalars['ID'],
  aaLoginId: Scalars['ID'],
  nonAaLoginIds: Array<Scalars['ID']>
};


export type MutationDeleteOneTimeMessagesDismissedArgs = {
  memberId: Scalars['ID'],
  message: Scalars['String']
};


export type MutationDismissAnnouncementArgs = {
  announcementId: Scalars['ID']
};


export type MutationAddCheckItemArgs = {
  cardId: Scalars['ID'],
  checklistId?: Maybe<Scalars['ID']>,
  name: Scalars['String'],
  temporaryId: Scalars['String']
};


export type MutationAddChecklistArgs = {
  boardId: Scalars['ID'],
  cardId: Scalars['ID'],
  checklistSourceId?: Maybe<Scalars['ID']>,
  name: Scalars['String'],
  temporaryId: Scalars['String']
};


export type MutationDeleteCheckItemArgs = {
  cardId: Scalars['ID'],
  checklistId: Scalars['ID'],
  checkItemId: Scalars['ID']
};


export type MutationDeleteChecklistArgs = {
  checklistId: Scalars['ID']
};


export type MutationAddCampaignArgs = {
  name: Scalars['String'],
  currentStep: Scalars['String']
};


export type MutationUpdateCampaignArgs = {
  campaignId: Scalars['ID'],
  currentStep?: Maybe<Scalars['String']>,
  dateDismissed?: Maybe<Scalars['String']>,
  isDismissed?: Maybe<Scalars['Boolean']>
};


export type MutationUpdateBoardOrgArgs = {
  boardId: Scalars['ID'],
  orgId?: Maybe<Scalars['ID']>
};


export type MutationUpdateCheckItemNameArgs = {
  cardId: Scalars['ID'],
  checklistId: Scalars['ID'],
  checkItemId: Scalars['ID'],
  name: Scalars['String']
};


export type MutationUpdateCheckItemPosArgs = {
  cardId: Scalars['ID'],
  checklistId: Scalars['ID'],
  checkItemId: Scalars['ID'],
  pos: Scalars['Float']
};


export type MutationUpdateCheckItemStateArgs = {
  cardId: Scalars['ID'],
  checklistId: Scalars['ID'],
  checkItemId: Scalars['ID'],
  state: CheckItem_State
};


export type MutationUpdateChecklistNameArgs = {
  checklistId: Scalars['ID'],
  name: Scalars['String']
};


export type MutationUpdateChecklistPosArgs = {
  checklistId: Scalars['ID'],
  pos: Scalars['Float']
};


export type MutationEnablePluginArgs = {
  boardId: Scalars['ID'],
  pluginId: Scalars['ID']
};


export type MutationUpdatePluginArgs = {
  pluginId: Scalars['ID'],
  fields?: Maybe<UpdatePluginFields>
};


export type MutationCopyBoardToOrgArgs = {
  organizationId: Scalars['ID'],
  boardId: Scalars['ID']
};


export type MutationCreatePluginArgs = {
  organizationId: Scalars['ID'],
  agreementId: Scalars['ID'],
  listings: Array<InputPluginListing>,
  iframeConnectorUrl: Scalars['String'],
  author?: Maybe<Scalars['String']>
};


export type MutationDeletePluginArgs = {
  pluginId: Scalars['ID']
};


export type MutationCreatePluginListingArgs = {
  pluginId: Scalars['ID'],
  locale: Scalars['String'],
  name: Scalars['String'],
  overview: Scalars['String'],
  description: Scalars['String']
};


export type MutationUpdatePluginListingArgs = {
  pluginId: Scalars['ID'],
  pluginListingId: Scalars['ID'],
  locale?: Maybe<Scalars['String']>,
  name?: Maybe<Scalars['String']>,
  overview?: Maybe<Scalars['String']>,
  description?: Maybe<Scalars['String']>
};


export type MutationAcceptDeveloperTermsArgs = {
  memberId: Scalars['ID']
};


export type MutationUpdateMemberAvatarSourceArgs = {
  avatarSource: Member_AvatarSource
};


export type MutationUploadMemberAvatarArgs = {
  file: Scalars['FileUpload'],
  uploadProgressCallback?: Maybe<Scalars['FileUploadProgressCallback']>
};


export type MutationUploadCardCoverArgs = {
  cardId: Scalars['ID'],
  file: Scalars['FileUpload']
};


export type MutationUpdateCardCoverArgs = {
  cardId: Scalars['ID'],
  cover?: Maybe<InputCover>
};


export type MutationAddMemberEmailArgs = {
  email: Scalars['String']
};


export type MutationResendVerificationEmailArgs = {
  email: Scalars['String']
};


export type MutationCreateCardTemplateArgs = {
  listId: Scalars['ID'],
  name: Scalars['String'],
  closed?: Maybe<Scalars['Boolean']>
};


export type MutationCopyCardArgs = {
  idCardSource: Scalars['ID'],
  idList: Scalars['ID'],
  name?: Maybe<Scalars['String']>,
  keepFromSource?: Maybe<Array<Scalars['String']>>
};


export type MutationDeleteCardArgs = {
  idCard: Scalars['ID']
};


export type MutationStartBoardExportArgs = {
  id: Scalars['ID']
};


export type MutationClaimOrganizationArgs = {
  idEnterprise: Scalars['ID'],
  idOrganization: Scalars['ID']
};

/** The Board preferences specific to the current Member */
export type MyPrefs = {
   __typename: 'MyPrefs',
  /** Whether the sidebar should be shown */
  showSidebar: Scalars['Boolean'],
  /** The generated key used in the email address for the Board */
  emailKey?: Maybe<Scalars['String']>,
  /** The id of the List to add cards to when the Board is emailed */
  idEmailList?: Maybe<Scalars['String']>,
  /** The position in the List to add cards to when the Board is emailed */
  emailPosition?: Maybe<MyPrefs_EmailPosition>,
};

/** The position in the List to add cards to when the Board is emailed */
export enum MyPrefs_EmailPosition {
  /** The top of the List */
  Top = 'top',
  /** The bottom of the List */
  Bottom = 'bottom'
}

/** Organizations, or as they are referred to in Trello, "Teams", represent collections of members and boards. */
export type Organization = {
   __typename: 'Organization',
  /** The boards belonging to the Organization that are visible to the user */
  boards: Array<Board>,
  /** The Enterprise this Organization belongs to */
  enterprise?: Maybe<Enterprise>,
  /** The Members in the Organization */
  members: Array<Member>,
  /** Information about the paid account of an organization */
  paidAccount: PaidAccount,
  /** The PluginData for this Organization */
  pluginData: Array<PluginData>,
  /** The Collections(Tags) belonging to the Organization */
  tags: Array<Tag>,
  /** Boolean to indicate if team is part of the All Users Are Admins feature */
  allAdminsEnabled?: Maybe<Scalars['Boolean']>,
  /** The ID of the organization. */
  id: Scalars['ID'],
  /** The count of active billable members in the organization. Used if the organization is build only for active members. */
  activeBillableMemberCount?: Maybe<Scalars['Int']>,
  /** The count of available licenses in the organization */
  availableLicenseCount?: Maybe<Scalars['Int']>,
  /** The count of billable members in the organization. */
  billableMemberCount?: Maybe<Scalars['Int']>,
  /** The count of billable collaborators (board guests) */
  billableCollaboratorCount?: Maybe<Scalars['Int']>,
  /** The description of the team */
  desc: Scalars['String'],
  /** If the bio includes custom emoji, this object will contain the information necessary to display them. */
  descData?: Maybe<Scalars['JSONObject']>,
  /** The name for the team. For example: Trello Inc */
  displayName: Scalars['String'],
  /** The list of board ids belonging to the Organization that are visible to the user */
  idBoards: Array<Scalars['String']>,
  /** The ID of the Enterprise this Organization belongs to */
  idEnterprise?: Maybe<Scalars['String']>,
  /** Hash for the organization's logo */
  logoHash?: Maybe<Scalars['String']>,
  /** The limits on the Organization */
  limits: Organization_Limits,
  /** The Memberships of the Organization */
  memberships: Array<Organization_Membership>,
  /** The programmatic name for the team. For example: trelloinc */
  name: Scalars['String'],
  /** The preferences (settings) for the team */
  prefs: Organization_Prefs,
  /** The premium features allowed for this team */
  premiumFeatures: Array<Scalars['String']>,
  /** The list of product SKUs belonging to this Organization */
  products: Array<Scalars['Int']>,
  /** Defines the intent of the team */
  teamType?: Maybe<Scalars['String']>,
  /** The URL to the team page on Trello */
  url: Scalars['String'],
  /** The URL for the organization */
  website?: Maybe<Scalars['String']>,
  /** The Stats of the Organization used for reporting */
  stats: Organization_Stats,
  /** The Plugins owned by the Organization */
  ownedPlugins: Array<Plugin>,
  /** The new billable guests that would be added as a result of adding this board to the organization */
  newBillableGuests: Array<Organization_NewBillableGuest>,
};


/** Organizations, or as they are referred to in Trello, "Teams", represent collections of members and boards. */
export type OrganizationBoardsArgs = {
  filter?: Maybe<Board_Filter>,
  startIndex?: Maybe<Scalars['Int']>,
  count?: Maybe<Scalars['Int']>
};


/** Organizations, or as they are referred to in Trello, "Teams", represent collections of members and boards. */
export type OrganizationMembersArgs = {
  filter?: Maybe<Member_Filter>
};


/** Organizations, or as they are referred to in Trello, "Teams", represent collections of members and boards. */
export type OrganizationNewBillableGuestsArgs = {
  boardId: Scalars['ID']
};

/** A filter for the Organizations being requested */
export enum Organization_Filter {
  /** Returns all Organizations that have visibility set to Private */
  Members = 'members',
  /** Returns all Organizations that have visibility set to Public */
  Public = 'public'
}

/** The limits on the Organization */
export type Organization_Limits = {
   __typename: 'Organization_Limits',
  /** The org limits */
  orgs: Organization_Limits_Orgs,
};

export type Organization_Limits_Orgs = {
   __typename: 'Organization_Limits_Orgs',
  /** The total Members per Organization limit */
  totalMembersPerOrg: Limit,
  /** The free Boards per Organization limit */
  freeBoardsPerOrg: Limit,
};

/** An association between a Member and an Organization */
export type Organization_Membership = {
   __typename: 'Organization_Membership',
  /** The ID of the Membership */
  id: Scalars['String'],
  /** The ID of the Member */
  idMember: Scalars['String'],
  /** The type of Membership this is */
  memberType: Organization_Membership_MemberType,
  /** Whether the Member has confirmed their email address */
  unconfirmed: Scalars['Boolean'],
  /** Whether the Member has been deactivated */
  deactivated: Scalars['Boolean'],
};

/** The type of membership a member has on an Organization */
export enum Organization_Membership_MemberType {
  /** A normal member */
  Normal = 'normal',
  /** An admin */
  Admin = 'admin'
}

/** Information about a member that would become a billable guest */
export type Organization_NewBillableGuest = {
   __typename: 'Organization_NewBillableGuest',
  /** The ID of the Member */
  id: Scalars['ID'],
  /** 
 * Member profile images are hosted at:
   * https://trello-avatars.s3.amazonaws.com/{avatarHash}/{size}.png size can be 30, 50, or 170
 **/
  avatarHash?: Maybe<Scalars['String']>,
  /** The full display name for the member. */
  fullName?: Maybe<Scalars['String']>,
  /** The username for the member. What is shown in @mentions for example. */
  username: Scalars['String'],
  /** Whether the member has confirmed their email address after signing up. */
  confirmed: Scalars['Boolean'],
  /** The member's initials, used for display when there isn't an avatar set. */
  initials: Scalars['String'],
};

/** The preferences for an Organization */
export type Organization_Prefs = {
   __typename: 'Organization_Prefs',
  /** The associated google apps domain */
  associatedDomain?: Maybe<Scalars['String']>,
  /** Whether external members can be added to an Organization's boards */
  externalMembersDisabled?: Maybe<Scalars['Boolean']>,
  /** An array of attachment types. Will always include 'trello' */
  attachmentRestrictions?: Maybe<Array<Scalars['String']>>,
  /** The restrictions on who can delete a Board */
  boardDeleteRestrict?: Maybe<Organization_Prefs_BoardDeleteRestrict>,
  /** The restrictions on who can view a Board */
  boardVisibilityRestrict?: Maybe<Organization_Prefs_BoardVisibilityRestrict>,
  /** Restrictions on emails allowed to invite to the Organization */
  orgInviteRestrict?: Maybe<Array<Scalars['String']>>,
  /** Restrictions on emails allowed to invite to the Organization */
  boardInviteRestrict?: Maybe<Scalars['String']>,
  /** The visibility of the Organization */
  permissionLevel?: Maybe<Organization_Prefs_PermissionLevel>,
};

/** An object that represents a set of restrictions for a Board deletion */
export type Organization_Prefs_BoardDeleteRestrict = {
   __typename: 'Organization_Prefs_BoardDeleteRestrict',
  /** How private boards should be restricted */
  private: Organization_Prefs_RestrictionType,
  /** How organization boards should be restricted */
  org: Organization_Prefs_RestrictionType,
  /** How enterprise boards should be restricted */
  enterprise: Organization_Prefs_RestrictionType,
  /** How public boards should be restricted */
  public: Organization_Prefs_RestrictionType,
};

/** An object that represents a set of restrictions for a Board visibility */
export type Organization_Prefs_BoardVisibilityRestrict = {
   __typename: 'Organization_Prefs_BoardVisibilityRestrict',
  /** How private boards should be restricted */
  private: Organization_Prefs_RestrictionType,
  /** How organization boards should be restricted */
  org: Organization_Prefs_RestrictionType,
  /** How enterprise boards should be restricted */
  enterprise: Organization_Prefs_RestrictionType,
  /** How public boards should be restricted */
  public: Organization_Prefs_RestrictionType,
};

/** The permission level (visibility) of an Organization */
export enum Organization_Prefs_PermissionLevel {
  /** Publicly visible */
  Public = 'public',
  /** Only visible to Members of the Organization */
  Private = 'private'
}

/** A permission level for a board restriction */
export enum Organization_Prefs_RestrictionType {
  /** Anyone in the Organization */
  Org = 'org',
  /** Only admins */
  Admin = 'admin',
  /** No one */
  None = 'none'
}

/** Stats reported on at the organization level */
export type Organization_Stats = {
   __typename: 'Organization_Stats',
  /** The id of the organization the stats are for. */
  id: Scalars['ID'],
  /** The cards stats for the organization. */
  cards: Organization_Stats_Cards,
  /** The labelNames used on boards in the organization. */
  labelNames: Organization_Stats_LabelNames,
};


/** Stats reported on at the organization level */
export type Organization_StatsCardsArgs = {
  groupBy?: Maybe<Organization_Stats_Cards_GroupBy>,
  idBoards?: Maybe<Array<Scalars['ID']>>,
  idMembers?: Maybe<Array<Scalars['ID']>>,
  idLabels?: Maybe<Array<Scalars['ID']>>,
  dueDateSince?: Maybe<Scalars['String']>,
  dueDateUntil?: Maybe<Scalars['String']>,
  refreshTime?: Maybe<Scalars['Int']>
};

/** Cards stats reported on at the organization level */
export type Organization_Stats_Cards = {
   __typename: 'Organization_Stats_Cards',
  /** Whether the stats are complete or not  */
  incomplete: Scalars['Boolean'],
  /** The cards stats */
  stats: Array<Organization_Stats_Cards_Stat>,
};

/** The possible options for grouping an organization's card stats */
export enum Organization_Stats_Cards_GroupBy {
  Label = 'label',
  LabelName = 'labelName',
  Member = 'member'
}

/** 
 * A stat on the number of cards in an organization
 * with a certain property, potentially grouped and filtered
 **/
export type Organization_Stats_Cards_Stat = {
   __typename: 'Organization_Stats_Cards_Stat',
  /** The id of the label that the stat is grouped by. */
  idLabel?: Maybe<Scalars['ID']>,
  /** The name of the label that the stat is grouped by. */
  labelName?: Maybe<Scalars['String']>,
  /** The id of the member that the stat is grouped by. */
  idMember?: Maybe<Scalars['ID']>,
  /** The number and ids of overdue cards. */
  overdue: Organization_Stats_Cards_Stat_Overdue,
  /** The number and ids of upcoming cards. */
  upcoming: Organization_Stats_Cards_Stat_Upcoming,
  /** The number and ids of done cards. */
  done: Organization_Stats_Cards_Stat_Done,
  /** The number and ids of cards with no due date. */
  noDueDate: Organization_Stats_Cards_Stat_NoDueDate,
};

export type Organization_Stats_Cards_Stat_Done = {
   __typename: 'Organization_Stats_Cards_Stat_Done',
  /** The number of done cards */
  count: Scalars['Int'],
  /** The IDs of the done cards */
  ids?: Maybe<Array<Scalars['ID']>>,
};

export type Organization_Stats_Cards_Stat_NoDueDate = {
   __typename: 'Organization_Stats_Cards_Stat_NoDueDate',
  /** The number of cards with no due date */
  count: Scalars['Int'],
  /** The IDs of the cards with no due date */
  ids?: Maybe<Array<Scalars['ID']>>,
};

export type Organization_Stats_Cards_Stat_Overdue = {
   __typename: 'Organization_Stats_Cards_Stat_Overdue',
  /** The number of overdue cards */
  count: Scalars['Int'],
  /** The IDs of the overdue cards */
  ids?: Maybe<Array<Scalars['ID']>>,
};

export type Organization_Stats_Cards_Stat_Upcoming = {
   __typename: 'Organization_Stats_Cards_Stat_Upcoming',
  /** The number of upcoming cards */
  count: Scalars['Int'],
  /** The IDs of the upcoming cards */
  ids?: Maybe<Array<Scalars['ID']>>,
};

/** Grouped labels with the same name at the organization level */
export type Organization_Stats_LabelName_Stat = {
   __typename: 'Organization_Stats_LabelName_Stat',
  /** Number of unique labels with this name */
  count: Scalars['Int'],
  /** The IDs of each label within this group */
  ids: Array<Scalars['ID']>,
  /** The name of the label */
  name: Scalars['String'],
  /** The number of times a label with this name has been used */
  totalUses: Scalars['Int'],
};

/** LabelNames stats reported at the organization level */
export type Organization_Stats_LabelNames = {
   __typename: 'Organization_Stats_LabelNames',
  /** Whether the stats are complete or not  */
  incomplete: Scalars['Boolean'],
  /** The labelName stats */
  stats: Array<Organization_Stats_LabelName_Stat>,
};

/** Details of a paid account */
export type PaidAccount = {
   __typename: 'PaidAccount',
  /** The product code of this account */
  product?: Maybe<Scalars['Int']>,
  /** The date this product will expire */
  expiresAt?: Maybe<Scalars['String']>,
  /** The product codes associated with this account */
  products: Array<Scalars['Int']>,
  /** Whether the account's credit card needs updating */
  needsCreditCardUpdate?: Maybe<Scalars['Boolean']>,
  /** Details about the account's invoice */
  invoiceDetails?: Maybe<Scalars['String']>,
  /** The pending product code for this account */
  pendingProduct?: Maybe<Scalars['Int']>,
  /** The credits associated with this account */
  credits?: Maybe<Scalars['Float']>,
  /** The expiration dates of the account's products */
  expirationDates?: Maybe<Scalars['JSONObject']>,
  /** The billing dates of the account's products */
  billingDates?: Maybe<Scalars['JSONObject']>,
  /** The date when the account's standing changed */
  dateStandingChanged?: Maybe<Scalars['String']>,
  /** The locale of the account's contact */
  contactLocale?: Maybe<Scalars['String']>,
  /** The email of the account's contact */
  contactEmail?: Maybe<Scalars['String']>,
  /** The full name of the account's contact */
  contactFullName?: Maybe<Scalars['String']>,
  /** The last 4 digits of the account's credit card */
  cardLast4?: Maybe<Scalars['String']>,
  /** The name of the credit card used for the account */
  cardName?: Maybe<Scalars['String']>,
  /** The type of the credit card used for the account */
  cardType?: Maybe<Scalars['String']>,
  /** The standing of the account */
  standing?: Maybe<Scalars['Int']>,
  /** The subsciber ID of the account */
  ixSubscriber?: Maybe<Scalars['Int']>,
};

export type Plugin = {
   __typename: 'Plugin',
  /** The ID of the plugin. */
  id: Scalars['ID'],
  /** The name of the plugin's author. */
  author: Scalars['String'],
  /** API Key associated with this plugin. */
  apiKey?: Maybe<Scalars['String']>,
  /** Capabilities represent areas of the UX that a plugin can hook into. */
  capabilities: Array<Scalars['String']>,
  /** A list of categories which the plugin will be listed under. */
  categories: Array<Scalars['String']>,
  /** The URL to the main iframe of the plugin. */
  iframeConnectorUrl: Scalars['String'],
  /** The ID of the organization the plugin belongs to. */
  idOrganizationOwner: Scalars['String'],
  /** The URL to the privacy policy of the plugin. */
  privacyUrl?: Maybe<Scalars['String']>,
  /** Whether the plugin is available to the public. */
  public: Scalars['Boolean'],
  /** The moderated state of a plugin. Used to hide or turn off problematic plugins. */
  moderatedState?: Maybe<Plugin_ModeratedState>,
  /** Deprecated name of the plugin. */
  name?: Maybe<Scalars['String']>,
  /** The support email of a plugin. */
  supportEmail?: Maybe<Scalars['String']>,
  /** A list of tags used to make a plugin featued. */
  tags: Array<Scalars['String']>,
  /** The compliance information of the plugin. */
  compliance?: Maybe<Plugin_Compliance>,
  /** If the plugin is compliant with privacy standards. */
  isCompliantWithPrivacyStandards?: Maybe<Scalars['Boolean']>,
  /** The email address of the plugin author. */
  email?: Maybe<Scalars['String']>,
  /** The icon of the plugin. */
  icon: Plugin_Icon,
  /** Urls to the hero image of a plugin. */
  heroImageUrl?: Maybe<Scalars['JSONObject']>,
  /** Listing information of the plugin. */
  listing?: Maybe<Plugin_Listing>,
  /** A list of listing information of the plugin in different locales. */
  listings?: Maybe<Array<Plugin_Listings>>,
  /** Usage bracket information of the plugin. */
  usageBrackets: Plugin_UsageBrackets,
  /** Daily statistics about the plugin. */
  stats: Array<Plugin_Stat>,
};

/** The compliance information of the plugin. */
export type Plugin_Compliance = {
   __typename: 'Plugin_Compliance',
  /** The timestamp of when the storesPersonalData property was changed. */
  dateUpdatedStoresPersonalData: Scalars['String'],
  /** Whether the plugin stores personal data. */
  storesPersonalData: Scalars['Boolean'],
  /** The timestamps of when the plugin last polled the compliance URLs. */
  lastPolled: Plugin_Compliance_LastPolled,
};

/** The timestamps of when the plugin last polled the compliance URLs. */
export type Plugin_Compliance_LastPolled = {
   __typename: 'Plugin_Compliance_LastPolled',
  /** When it last hit the member privacy polling URL. */
  memberPrivacy: Scalars['String'],
};

/** An object representing the response from the deletePlugin mutation. */
export type Plugin_DeleteResponse = {
   __typename: 'Plugin_DeleteResponse',
  /** Whether the deletion was successful */
  success: Scalars['Boolean'],
};

export type Plugin_EnableResponse = {
   __typename: 'Plugin_EnableResponse',
  /** Whether the enablement was successful. */
  success: Scalars['Boolean'],
  /** Error message for why enablement failed. */
  error?: Maybe<Scalars['String']>,
};

export enum Plugin_Filter {
  None = 'none',
  Enabled = 'enabled',
  Available = 'available',
  All = 'all',
  HasClaimedDomains = 'hasClaimedDomains'
}

/** The icon of a Organization Owned Plugin. */
export type Plugin_Icon = {
   __typename: 'Plugin_Icon',
  /** The URL to the icon. */
  url: Scalars['String'],
};

/** Localized listing information of a Plugin. */
export type Plugin_Listing = {
   __typename: 'Plugin_Listing',
  /** id of the plugin listing. */
  id?: Maybe<Scalars['ID']>,
  /** The name of the plugin. */
  name: Scalars['String'],
  /** The locale of the listing. */
  locale: Scalars['String'],
  /** The description of the plugin. */
  description: Scalars['String'],
  /** The overview of the plugin. */
  overview: Scalars['String'],
};

/** Array of Localized listing information of a Plugin. */
export type Plugin_Listings = {
   __typename: 'Plugin_Listings',
  /** id of the plugin listing. */
  id: Scalars['ID'],
  /** The name of the plugin. */
  name: Scalars['String'],
  /** The locale of the listing. */
  locale: Scalars['String'],
  /** The description of the plugin. */
  description: Scalars['String'],
  /** The overview of the plugin. */
  overview: Scalars['String'],
};

/** The moderated state of a plugin. Used to hide or turn off problematic plugins. */
export enum Plugin_ModeratedState {
  /** The plugin is hidden from listings but still functional on boards that have it enabled. */
  Hidden = 'hidden',
  /** The plugin is hidden from listings and boards. */
  Moderated = 'moderated'
}

/** A record of daily statistics about the plugin. */
export type Plugin_Stat = {
   __typename: 'Plugin_Stat',
  /** The date the stat was captured. */
  date: Scalars['String'],
  /** The number of boards using this plugin. */
  boardCount: Scalars['Int'],
};

/** Usage bracket information of the plugin. */
export type Plugin_UsageBrackets = {
   __typename: 'Plugin_UsageBrackets',
  /** The number of boards the plugin is enabled on. */
  boards: Scalars['Int'],
};

/** Data stored by a plugin */
export type PluginData = {
   __typename: 'PluginData',
  /** The id of the PluginData */
  id: Scalars['ID'],
  /** The id of the Plugin */
  idPlugin: Scalars['String'],
  /** The model type the data is scoped to */
  scope: PluginData_Scope,
  /** The id of the model the data is scoped to */
  idModel: Scalars['String'],
  /** Whether the PluginData is private or shared */
  access: PluginData_Access,
  /** The data being stored */
  value: Scalars['String'],
};

/** Whether the PluginData is private or shared */
export enum PluginData_Access {
  Private = 'private',
  Shared = 'shared'
}

/** The model type the data is scoped to */
export enum PluginData_Scope {
  Board = 'board',
  Member = 'member',
  Card = 'card',
  Organization = 'organization'
}

export type Query = {
   __typename: 'Query',
  announcements: Array<Announcement>,
  board?: Maybe<Board>,
  boards: Array<Board>,
  checklist?: Maybe<Checklist>,
  checklists: Array<Checklist>,
  list?: Maybe<List>,
  lists: Array<List>,
  emailProvider: EmailProvider,
  member?: Maybe<Member>,
  members: Array<Member>,
  card?: Maybe<Card>,
  cards: Array<Card>,
  organization?: Maybe<Organization>,
  organizations: Array<Organization>,
  label?: Maybe<Label>,
  labels: Array<Label>,
  enterprise?: Maybe<Enterprise>,
  enterprises: Array<Enterprise>,
  publicPlugins: Array<Plugin>,
  search: Search,
  plugin?: Maybe<Plugin>,
  pluginCategories: Array<Scalars['String']>,
  unsplashPhotos: Array<UnsplashPhoto>,
  templateCategories: Array<TemplateCategory>,
  templateGallery: Array<Board>,
};


export type QueryAnnouncementsArgs = {
  filter?: Maybe<Scalars['String']>
};


export type QueryBoardArgs = {
  id: Scalars['ID']
};


export type QueryBoardsArgs = {
  ids: Array<Scalars['ID']>
};


export type QueryChecklistArgs = {
  id: Scalars['ID']
};


export type QueryChecklistsArgs = {
  ids: Array<Scalars['ID']>
};


export type QueryListArgs = {
  id: Scalars['ID']
};


export type QueryListsArgs = {
  ids: Array<Scalars['ID']>
};


export type QueryEmailProviderArgs = {
  email: Scalars['String']
};


export type QueryMemberArgs = {
  id: Scalars['ID']
};


export type QueryMembersArgs = {
  ids: Array<Scalars['ID']>
};


export type QueryCardArgs = {
  id: Scalars['ID']
};


export type QueryCardsArgs = {
  ids: Array<Scalars['ID']>
};


export type QueryOrganizationArgs = {
  id: Scalars['ID']
};


export type QueryOrganizationsArgs = {
  ids: Array<Scalars['ID']>
};


export type QueryLabelArgs = {
  id: Scalars['ID']
};


export type QueryLabelsArgs = {
  ids: Array<Scalars['ID']>
};


export type QueryEnterpriseArgs = {
  id: Scalars['ID']
};


export type QueryEnterprisesArgs = {
  ids: Array<Scalars['ID']>
};


export type QuerySearchArgs = {
  query: Scalars['String'],
  idBoards?: Maybe<Array<Scalars['ID']>>,
  idOrganizations?: Maybe<Array<Scalars['ID']>>,
  idCards?: Maybe<Array<Scalars['ID']>>,
  partial?: Maybe<Scalars['Boolean']>
};


export type QueryPluginArgs = {
  id: Scalars['ID']
};


export type QueryUnsplashPhotosArgs = {
  query?: Maybe<Scalars['String']>,
  page?: Maybe<Scalars['Int']>,
  perPage?: Maybe<Scalars['Int']>
};

/** Reactions give Members the option to add an emoji to an Action. */
export type Reaction = {
   __typename: 'Reaction',
  /** The ID of the Reaction */
  id: Scalars['ID'],
  /** The ID of the Member who added the Reaction */
  idMember: Scalars['String'],
  /** The ID of the entity this Reaction is on */
  idModel: Scalars['String'],
  /** The ID of the emoji used in the Reaction */
  idEmoji: Scalars['String'],
  /** The Member who added the Reaction */
  member: Member,
  /** The Emoji used on the Reaction */
  emoji: Reaction_Emoji,
};

/** The emoji used on the Reaction */
export type Reaction_Emoji = {
   __typename: 'Reaction_Emoji',
  /** The ID of the Emoji */
  unified: Scalars['String'],
  /** The native Emoji */
  native: Scalars['String'],
  /** The name of the Emoji */
  name: Scalars['String'],
  /** The skin variation of the Emoji */
  skinVariation?: Maybe<Scalars['String']>,
  /** The short name for the Emoji */
  shortName: Scalars['String'],
};

/** A saved search query belonging to a Member */
export type SavedSearch = {
   __typename: 'SavedSearch',
  /** The ID of the saved search */
  id: Scalars['ID'],
  /** The name of the saved search */
  name: Scalars['String'],
  /** The query of the saved search */
  query: Scalars['String'],
  /** The position of the saved search in the UI */
  pos: Scalars['Int'],
};

/** The result returned from a search query */
export type Search = {
   __typename: 'Search',
  /** Info about the search performed */
  options?: Maybe<Search_Options>,
  /** Board results from the search */
  boards: Array<Board>,
  /** Card results from the search */
  cards: Array<Card>,
  /** 
 * There is currently a server bug where the `members` field
   * won't be present if there are no member results. `members`
   * should be non-nullable when that bug is fixed.
   * 
   * Member results from the search
 **/
  members?: Maybe<Array<Member>>,
  /** Organization results from the search */
  organizations: Array<Organization>,
};


/** The result returned from a search query */
export type SearchBoardsArgs = {
  limit?: Maybe<Scalars['Int']>
};


/** The result returned from a search query */
export type SearchCardsArgs = {
  limit?: Maybe<Scalars['Int']>,
  page?: Maybe<Scalars['Int']>
};


/** The result returned from a search query */
export type SearchMembersArgs = {
  limit?: Maybe<Scalars['Int']>
};


/** The result returned from a search query */
export type SearchOrganizationsArgs = {
  limit?: Maybe<Scalars['Int']>
};

/** 
 * ;
 * Info about the options passed to the performed search
 **/
export type Search_Options = {
   __typename: 'Search_Options',
  /** The terms used to perform the search (parsed from the passed in query) */
  terms?: Maybe<Array<Search_Options_Term>>,
  /** The modifiers used to perform the search (parsed from the passed in query) */
  modifiers?: Maybe<Array<Search_Options_Modifier>>,
  /** The modelTypes requested */
  modelTypes?: Maybe<Array<Scalars['String']>>,
  /** 
 * Whether or not the partial flag was set for the search.
   * 
   * By default, search will match the words in your query exactly. Setting the `partial`
   * flag to true means that search will look for content that starts with any of the
   * words in your query.
 **/
  partial?: Maybe<Scalars['Boolean']>,
};

/** 
 * A modifier used in a search query
 * e.g. In the query "is:open sort:created development",
 * `is:open` and `sort:created` are the modifiers
 **/
export type Search_Options_Modifier = {
   __typename: 'Search_Options_Modifier',
  /** The text of the modifier */
  text?: Maybe<Scalars['String']>,
};

/** 
 * A term used in a search query
 * e.g. In the query "is:open sort:created development",
 * `development` is the only term
 **/
export type Search_Options_Term = {
   __typename: 'Search_Options_Term',
  text?: Maybe<Scalars['String']>,
};

/** The counts for a Board being starred */
export type StarCounts = {
   __typename: 'StarCounts',
  /** The number of Organization Members who have starred this Board */
  organization: Scalars['Int'],
};

/** An instance of a sticker on a card */
export type Sticker = {
   __typename: 'Sticker',
  /** ID of the card sticker */
  id: Scalars['ID'],
  /** Top position of the sticker on the card */
  top: Scalars['Int'],
  /** Left position of the sticker on the card */
  left: Scalars['Int'],
  /** z-index of the sticker on the card */
  zIndex: Scalars['Int'],
  /** Rotations of the sticker on the card */
  rotate: Scalars['Int'],
  /** ID of the image used for the sticker */
  image: Scalars['String'],
  /** URL of the image used for the sticker */
  imageUrl: Scalars['String'],
  /** List of different scalings of the sticker image */
  imageScaled: Array<Sticker_ImageScaled>,
};

/** A scaled version of a cards sticker image */
export type Sticker_ImageScaled = {
   __typename: 'Sticker_ImageScaled',
  /** ID of the sticker image scaled */
  id: Scalars['ID'],
  /** Width of the image */
  width: Scalars['Int'],
  /** Height of the image */
  height: Scalars['Int'],
  /** URL of the image */
  url: Scalars['String'],
  /** Whether or not the image was scaled */
  scaled: Scalars['Boolean'],
  /** Size of the image in bytes. (only present for custom stickers) */
  bytes?: Maybe<Scalars['Int']>,
};

/** A Tag (or Collection as it is known in-app) is a 'category' that can be applied to Boards */
export type Tag = {
   __typename: 'Tag',
  /** ID of the Tag */
  id: Scalars['ID'],
  /** name of the Tag */
  name: Scalars['String'],
};

/** Category for template gallery returned from /resources/templates/categories */
export type TemplateCategory = {
   __typename: 'TemplateCategory',
  /** Translations key for template category */
  key: Scalars['String'],
};

/** An object containing information about a the gallery listing */
export type TemplateGallery = {
   __typename: 'TemplateGallery',
  /** The shape the avatar should be */
  avatarShape: Scalars['String'],
  /** The url for the listing's avatar */
  avatarUrl: Scalars['String'],
  /** The authors name */
  byline: Scalars['String'],
  /** The category the template is in */
  category: Scalars['String'],
  /** The precedence the template has for ordering */
  precedence: Scalars['Int'],
  /** The blurb for the template's gallery listing */
  blurb: Scalars['String'],
  /** The featured status of the board */
  featured: Scalars['Boolean'],
};

/** Data which represents the effects of transferring a team to an enterprise. */
export type TransferrableData = {
   __typename: 'TransferrableData',
  /** Whether the team is transferrable */
  transferrable?: Maybe<Scalars['Boolean']>,
  /** A list of members who will be counted towards billing upon transferring the team */
  newBillableMembers: Array<TransferrableDataMember>,
  /** A list of members who will be removed from the team upon transfering it to the enterprise */
  restrictedMembers: Array<TransferrableDataMember>,
};

/** 
 * Either a billable member of a restricted member (see TransferrableData). It is not a model,
 * but rather just a set of fields of a Member that is solely used for the enteprise dashboard.
 **/
export type TransferrableDataMember = {
   __typename: 'TransferrableDataMember',
  fullName: Scalars['String'],
  username: Scalars['String'],
  initials: Scalars['String'],
  avatarHash?: Maybe<Scalars['String']>,
  avatarUrl?: Maybe<Scalars['String']>,
};

/** 
 * A photo returned from the Unsplash API
 * https://unsplash.com/documentation
 **/
export type UnsplashPhoto = {
   __typename: 'UnsplashPhoto',
  /** ID of the UnsplashPhoto */
  id: Scalars['ID'],
  /** Date and time of when the photo was created, in ISO 8601 format (e.g., 2019-08-21T19:58:40-04:00) */
  created_at: Scalars['String'],
  /** Date and time of when the photo was last updated, in ISO 8601 format (e.g., 2019-08-21T19:58:40-04:00) */
  updated_at: Scalars['String'],
  /** Width of the full size image in pixels */
  width: Scalars['Int'],
  /** Height of the full size image in pixels */
  height: Scalars['Int'],
  /** A color associated with the image, in html hex format (e.g., #DCDBE1) */
  color: Scalars['String'],
  /** Text describing what is shown in the photo */
  description?: Maybe<Scalars['String']>,
  /** Urls pointing to various sizes of the image */
  urls: UnsplashPhoto_Urls,
  /** Links to various ways of accessing this photo (through the API or in a web browser) */
  links: UnsplashPhoto_Links,
  /** List of categories associated with the photo */
  categories: Array<Scalars['String']>,
  /** Number of users that have liked this photo */
  likes: Scalars['Int'],
  /** Information about the Unsplash user who created this photo */
  user: UnsplashPhoto_User,
};

/** 
 * Links to various ways of accessing an Unsplash photo (through the API or in a web browser)
 * https://unsplash.com/documentation#photos
 **/
export type UnsplashPhoto_Links = {
   __typename: 'UnsplashPhoto_Links',
  /** The Unsplash API url for this photo */
  self: Scalars['String'],
  /** Url of the html page for viewing this photo on Unsplash's website */
  html: Scalars['String'],
  /** Url of the image file on Unsplash's website */
  download: Scalars['String'],
  /** Url of the image file on Unsplash's API */
  download_location: Scalars['String'],
};

/** 
 * Urls pointing to various sizes of the UnsplashPhoto image
 * https://unsplash.com/documentation#example-image-use
 **/
export type UnsplashPhoto_Urls = {
   __typename: 'UnsplashPhoto_Urls',
  /** 
 * The photo in jpg format with its maximum dimensions. For performance purposes,
   * we don’t recommend using this as the photos will load slowly for your users.
 **/
  full: Scalars['String'],
  /** The photo in jpg format with a width of 1080 pixels */
  regular: Scalars['String'],
  /** The photo in jpg format with a width of 400 pixels */
  small: Scalars['String'],
  /** The photo in jpg format with a width of 200 pixels */
  thumb: Scalars['String'],
  /** 
 * A base image URL with just the photo path and the ixid parameter for your API
   * application. Use this to easily add additional image parameters to construct
   * your own image URL.
 **/
  raw: Scalars['String'],
};

/** 
 * Information about an Unsplash user's public profile
 * https://unsplash.com/documentation#get-a-users-public-profile
 **/
export type UnsplashPhoto_User = {
   __typename: 'UnsplashPhoto_User',
  /** ID of the UnsplashPhoto_user */
  id: Scalars['ID'],
  /** The user's full name */
  name: Scalars['String'],
  /** Links to various ways of accessing this user's info (through the API or through a web browser) */
  links: UnsplashPhoto_User_Links,
};

/** 
 * Links to various ways of accessing an Unsplash user's public profile info (through the API or through a web browser)
 * https://unsplash.com/documentation#get-a-users-public-profile
 **/
export type UnsplashPhoto_User_Links = {
   __typename: 'UnsplashPhoto_User_Links',
  /** Url of the user's html profile page on Unsplash's website */
  html: Scalars['String'],
};

export type UpdatePluginFields = {
  /** The name of the plugin's author. */
  author?: Maybe<Scalars['String']>,
  /** Capabilities represent areas of the UX that a plugin can hook into. */
  capabilities?: Maybe<Array<Scalars['String']>>,
  /** A list of categories which the plugin will be listed under. */
  categories?: Maybe<Array<Scalars['String']>>,
  /** The URL to the main iframe of the plugin. */
  iframeConnectorUrl?: Maybe<Scalars['String']>,
  /** The URL to the privacy policy of the plugin. */
  privacyUrl?: Maybe<Scalars['String']>,
  /** The support email of a plugin. */
  supportEmail?: Maybe<Scalars['String']>,
  /** The email address of the plugin author. */
  email?: Maybe<Scalars['String']>,
  /** The icon of the plugin. */
  icon?: Maybe<Scalars['String']>,
  /** Whether the plugin stores personal data. */
  storesPersonalData?: Maybe<Scalars['Boolean']>,
  /** API Key associated with this plugin. */
  apiKey?: Maybe<Scalars['String']>,
};
export type BoardExportQueryVariables = {
  idBoard: Scalars['ID'],
  idExport: Scalars['ID']
};


export type BoardExportQuery = (
  { __typename: 'Query' }
  & { board: Maybe<(
    { __typename: 'Board' }
    & Pick<Board, 'idOrganization'>
    & { exports: Array<(
      { __typename: 'Export' }
      & Pick<Export, 'id' | 'size'>
      & { status: (
        { __typename: 'ExportStatus' }
        & Pick<ExportStatus, 'attempts' | 'finished' | 'stage'>
      ) }
    )> }
  )> }
);

export type StartBoardExportMutationVariables = {
  id: Scalars['ID']
};


export type StartBoardExportMutation = (
  { __typename: 'Mutation' }
  & { startBoardExport: Maybe<(
    { __typename: 'Export' }
    & Pick<Export, 'id' | 'size'>
    & { status: (
      { __typename: 'ExportStatus' }
      & Pick<ExportStatus, 'attempts' | 'finished' | 'stage'>
    ) }
  )> }
);

export type MemberChangeAvatarPopoverQueryVariables = {
  id: Scalars['ID']
};


export type MemberChangeAvatarPopoverQuery = (
  { __typename: 'Query' }
  & { member: Maybe<(
    { __typename: 'Member' }
    & Pick<Member, 'id' | 'avatarSource' | 'gravatarHash' | 'initials' | 'uploadedAvatarHash'>
  )> }
);

export type UpdateMemberAvatarSourceMutationVariables = {
  avatarSource: Member_AvatarSource
};


export type UpdateMemberAvatarSourceMutation = (
  { __typename: 'Mutation' }
  & { updateMemberAvatarSource: Maybe<(
    { __typename: 'Member' }
    & Pick<Member, 'id' | 'avatarSource' | 'initials' | 'uploadedAvatarHash'>
  )> }
);

export type UploadMemberAvatarMutationVariables = {
  file: Scalars['FileUpload'],
  uploadProgressCallback?: Maybe<Scalars['FileUploadProgressCallback']>
};


export type UploadMemberAvatarMutation = (
  { __typename: 'Mutation' }
  & { uploadMemberAvatar: Maybe<(
    { __typename: 'Member' }
    & Pick<Member, 'id' | 'avatarSource' | 'initials' | 'uploadedAvatarHash'>
  )> }
);

export type AcceptDeveloperTermsMutationVariables = {
  memberId: Scalars['ID']
};


export type AcceptDeveloperTermsMutation = (
  { __typename: 'Mutation' }
  & { acceptDeveloperTerms: Maybe<(
    { __typename: 'Member_Agreement' }
    & Pick<Member_Agreement, 'id' | 'agreementType'>
  )> }
);

export type AppManagementQueryVariables = {};


export type AppManagementQuery = (
  { __typename: 'Query' }
  & { member: Maybe<(
    { __typename: 'Member' }
    & Pick<Member, 'id'>
    & { agreements: Array<(
      { __typename: 'Member_Agreement' }
      & Pick<Member_Agreement, 'agreementType'>
    )> }
  )> }
);

export type CreatePluginListingMutationVariables = {
  idPlugin: Scalars['ID'],
  locale: Scalars['String'],
  name: Scalars['String'],
  overview: Scalars['String'],
  description: Scalars['String']
};


export type CreatePluginListingMutation = (
  { __typename: 'Mutation' }
  & { createPluginListing: Maybe<(
    { __typename: 'Plugin_Listing' }
    & Pick<Plugin_Listing, 'id' | 'locale' | 'name' | 'overview' | 'description'>
  )> }
);

export type CreatePluginMutationVariables = {
  organizationId: Scalars['ID'],
  agreementId: Scalars['ID'],
  listings: Array<InputPluginListing>,
  iframeConnectorUrl: Scalars['String']
};


export type CreatePluginMutation = (
  { __typename: 'Mutation' }
  & { createPlugin: Maybe<(
    { __typename: 'Plugin' }
    & Pick<Plugin, 'id'>
  )> }
);

export type CreatePluginTeamsQueryVariables = {};


export type CreatePluginTeamsQuery = (
  { __typename: 'Query' }
  & { member: Maybe<(
    { __typename: 'Member' }
    & Pick<Member, 'id'>
    & { agreements: Array<(
      { __typename: 'Member_Agreement' }
      & Pick<Member_Agreement, 'id' | 'agreementType'>
    )>, organizations: Array<(
      { __typename: 'Organization' }
      & Pick<Organization, 'id' | 'displayName'>
      & { memberships: Array<(
        { __typename: 'Organization_Membership' }
        & Pick<Organization_Membership, 'idMember' | 'memberType'>
      )> }
    )> }
  )> }
);

export type DeletePluginMutationVariables = {
  idPlugin: Scalars['ID']
};


export type DeletePluginMutation = (
  { __typename: 'Mutation' }
  & { deletePlugin: Maybe<(
    { __typename: 'Plugin_DeleteResponse' }
    & Pick<Plugin_DeleteResponse, 'success'>
  )> }
);

export type PluginBasicInformationQueryVariables = {
  idPlugin: Scalars['ID']
};


export type PluginBasicInformationQuery = (
  { __typename: 'Query' }
  & { plugin: Maybe<(
    { __typename: 'Plugin' }
    & Pick<Plugin, 'id' | 'iframeConnectorUrl' | 'author' | 'supportEmail' | 'email' | 'categories'>
    & { icon: (
      { __typename: 'Plugin_Icon' }
      & Pick<Plugin_Icon, 'url'>
    ) }
  )> }
);

export type PluginCapabilitiesQueryVariables = {
  idPlugin: Scalars['ID']
};


export type PluginCapabilitiesQuery = (
  { __typename: 'Query' }
  & { plugin: Maybe<(
    { __typename: 'Plugin' }
    & Pick<Plugin, 'id' | 'capabilities'>
  )> }
);

export type PluginDeleteQueryVariables = {
  idPlugin: Scalars['ID']
};


export type PluginDeleteQuery = (
  { __typename: 'Query' }
  & { plugin: Maybe<(
    { __typename: 'Plugin' }
    & Pick<Plugin, 'id' | 'public' | 'name'>
    & { usageBrackets: (
      { __typename: 'Plugin_UsageBrackets' }
      & Pick<Plugin_UsageBrackets, 'boards'>
    ), listings: Maybe<Array<(
      { __typename: 'Plugin_Listings' }
      & Pick<Plugin_Listings, 'locale' | 'name'>
    )>> }
  )> }
);

export type PluginListingsQueryVariables = {
  idPlugin: Scalars['ID']
};


export type PluginListingsQuery = (
  { __typename: 'Query' }
  & { plugin: Maybe<(
    { __typename: 'Plugin' }
    & Pick<Plugin, 'id'>
    & { listings: Maybe<Array<(
      { __typename: 'Plugin_Listings' }
      & Pick<Plugin_Listings, 'id' | 'locale' | 'name' | 'description' | 'overview'>
    )>> }
  )> }
);

export type PluginManagementCategoriesQueryVariables = {};


export type PluginManagementCategoriesQuery = (
  { __typename: 'Query' }
  & Pick<Query, 'pluginCategories'>
);

export type PluginMetricsQueryVariables = {
  idPlugin: Scalars['ID']
};


export type PluginMetricsQuery = (
  { __typename: 'Query' }
  & { plugin: Maybe<(
    { __typename: 'Plugin' }
    & Pick<Plugin, 'name'>
    & { listings: Maybe<Array<(
      { __typename: 'Plugin_Listings' }
      & Pick<Plugin_Listings, 'locale' | 'name'>
    )>>, stats: Array<(
      { __typename: 'Plugin_Stat' }
      & Pick<Plugin_Stat, 'date' | 'boardCount'>
    )> }
  )> }
);

export type PluginPrivacyAndComplianceQueryVariables = {
  idPlugin: Scalars['ID']
};


export type PluginPrivacyAndComplianceQuery = (
  { __typename: 'Query' }
  & { plugin: Maybe<(
    { __typename: 'Plugin' }
    & Pick<Plugin, 'id' | 'privacyUrl' | 'apiKey'>
    & { compliance: Maybe<(
      { __typename: 'Plugin_Compliance' }
      & Pick<Plugin_Compliance, 'storesPersonalData'>
    )> }
  )> }
);

export type PowerUpPageQueryVariables = {
  idPlugin: Scalars['ID']
};


export type PowerUpPageQuery = (
  { __typename: 'Query' }
  & { plugin: Maybe<(
    { __typename: 'Plugin' }
    & Pick<Plugin, 'id' | 'public'>
  )> }
);

export type PowerUpsPageQueryVariables = {};


export type PowerUpsPageQuery = (
  { __typename: 'Query' }
  & { member: Maybe<(
    { __typename: 'Member' }
    & Pick<Member, 'id'>
    & { organizations: Array<(
      { __typename: 'Organization' }
      & Pick<Organization, 'id' | 'name' | 'displayName'>
      & { memberships: Array<(
        { __typename: 'Organization_Membership' }
        & Pick<Organization_Membership, 'idMember' | 'memberType'>
      )>, ownedPlugins: Array<(
        { __typename: 'Plugin' }
        & Pick<Plugin, 'id' | 'name' | 'public'>
        & { icon: (
          { __typename: 'Plugin_Icon' }
          & Pick<Plugin_Icon, 'url'>
        ), listings: Maybe<Array<(
          { __typename: 'Plugin_Listings' }
          & Pick<Plugin_Listings, 'name' | 'locale'>
        )>> }
      )> }
    )> }
  )> }
);

export type UpdatePluginBasicInformationMutationVariables = {
  idPlugin: Scalars['ID'],
  author?: Maybe<Scalars['String']>,
  iframeConnectorUrl?: Maybe<Scalars['String']>,
  icon?: Maybe<Scalars['String']>,
  email?: Maybe<Scalars['String']>,
  supportEmail?: Maybe<Scalars['String']>,
  categories?: Maybe<Array<Scalars['String']>>
};


export type UpdatePluginBasicInformationMutation = (
  { __typename: 'Mutation' }
  & { updatePlugin: Maybe<(
    { __typename: 'Plugin' }
    & Pick<Plugin, 'id' | 'iframeConnectorUrl' | 'author' | 'supportEmail' | 'email' | 'categories'>
    & { icon: (
      { __typename: 'Plugin_Icon' }
      & Pick<Plugin_Icon, 'url'>
    ) }
  )> }
);

export type UpdatePluginCapabilitiesMutationVariables = {
  idPlugin: Scalars['ID'],
  capabilities?: Maybe<Array<Scalars['String']>>
};


export type UpdatePluginCapabilitiesMutation = (
  { __typename: 'Mutation' }
  & { updatePlugin: Maybe<(
    { __typename: 'Plugin' }
    & Pick<Plugin, 'id' | 'capabilities'>
  )> }
);

export type UpdatePluginListingMutationVariables = {
  idPlugin: Scalars['ID'],
  pluginListingId: Scalars['ID'],
  locale?: Maybe<Scalars['String']>,
  name?: Maybe<Scalars['String']>,
  overview?: Maybe<Scalars['String']>,
  description?: Maybe<Scalars['String']>
};


export type UpdatePluginListingMutation = (
  { __typename: 'Mutation' }
  & { updatePluginListing: Maybe<(
    { __typename: 'Plugin_Listing' }
    & Pick<Plugin_Listing, 'id' | 'locale' | 'name' | 'overview' | 'description'>
  )> }
);

export type UpdatePluginPrivacyAndComplianceMutationVariables = {
  idPlugin: Scalars['ID'],
  privacyUrl?: Maybe<Scalars['String']>,
  apiKey?: Maybe<Scalars['String']>,
  storesPersonalData?: Maybe<Scalars['Boolean']>
};


export type UpdatePluginPrivacyAndComplianceMutation = (
  { __typename: 'Mutation' }
  & { updatePlugin: Maybe<(
    { __typename: 'Plugin' }
    & Pick<Plugin, 'id' | 'privacyUrl' | 'apiKey'>
    & { compliance: Maybe<(
      { __typename: 'Plugin_Compliance' }
      & Pick<Plugin_Compliance, 'storesPersonalData'>
    )> }
  )> }
);

export type AtlassianAccountOnboardingQueryVariables = {
  memberId: Scalars['ID']
};


export type AtlassianAccountOnboardingQuery = (
  { __typename: 'Query' }
  & { member: Maybe<(
    { __typename: 'Member' }
    & Pick<Member, 'id' | 'aaId' | 'email' | 'aaEmail' | 'aaEnrolledDate' | 'isAaMastered' | 'fullName'>
    & { enterprises: Array<(
      { __typename: 'Enterprise' }
      & Pick<Enterprise, 'id' | 'displayName'>
    )>, logins: Array<(
      { __typename: 'Login' }
      & Pick<Login, 'id' | 'primary' | 'email'>
    )> }
  )> }
);

export type PrepMemberForAtlassianAccountOnboardingMutationVariables = {
  memberId: Scalars['ID'],
  aaLoginId: Scalars['ID'],
  nonAaLoginIds: Array<Scalars['ID']>
};


export type PrepMemberForAtlassianAccountOnboardingMutation = (
  { __typename: 'Mutation' }
  & { prepMemberForAtlassianAccountOnboarding: Maybe<(
    { __typename: 'Member' }
    & Pick<Member, 'id' | 'aaId' | 'email' | 'aaEmail' | 'isAaMastered'>
    & { logins: Array<(
      { __typename: 'Login' }
      & Pick<Login, 'id' | 'primary' | 'email'>
    )> }
  )> }
);

export type BoardSelectorQueryVariables = {};


export type BoardSelectorQuery = (
  { __typename: 'Query' }
  & { member: Maybe<(
    { __typename: 'Member' }
    & { boards: Array<(
      { __typename: 'Board' }
      & Pick<Board, 'id' | 'name' | 'url' | 'idOrganization'>
      & { prefs: Maybe<(
        { __typename: 'Board_Prefs' }
        & Pick<Board_Prefs, 'background' | 'backgroundColor'>
        & { backgroundImageScaled: Maybe<Array<(
          { __typename: 'Board_Prefs_BackgroundImageScaled' }
          & Pick<Board_Prefs_BackgroundImageScaled, 'url' | 'width' | 'height'>
        )>> }
      )>, memberships: Array<(
        { __typename: 'Board_Membership' }
        & Pick<Board_Membership, 'idMember' | 'memberType'>
      )> }
    )>, organizations: Array<(
      { __typename: 'Organization' }
      & Pick<Organization, 'id' | 'name' | 'displayName'>
    )> }
  )> }
);

export type CardBackBannerQueryVariables = {
  idCard: Scalars['ID']
};


export type CardBackBannerQuery = (
  { __typename: 'Query' }
  & { card: Maybe<(
    { __typename: 'Card' }
    & Pick<Card, 'id' | 'closed' | 'isTemplate'>
    & { list: (
      { __typename: 'List' }
      & Pick<List, 'closed'>
    ), cover: Maybe<(
      { __typename: 'Card_Cover' }
      & Pick<Card_Cover, 'idAttachment' | 'color' | 'idUploadedBackground'>
    )>, stickers: Array<(
      { __typename: 'Sticker' }
      & Pick<Sticker, 'id'>
    )> }
  )> }
);

export type SearchUnsplashQueryVariables = {
  query?: Maybe<Scalars['String']>,
  page?: Maybe<Scalars['Int']>,
  perPage?: Maybe<Scalars['Int']>
};


export type SearchUnsplashQuery = (
  { __typename: 'Query' }
  & { unsplashPhotos: Array<(
    { __typename: 'UnsplashPhoto' }
    & Pick<UnsplashPhoto, 'id'>
    & { urls: (
      { __typename: 'UnsplashPhoto_Urls' }
      & Pick<UnsplashPhoto_Urls, 'thumb' | 'raw'>
    ), links: (
      { __typename: 'UnsplashPhoto_Links' }
      & Pick<UnsplashPhoto_Links, 'download_location'>
    ), user: (
      { __typename: 'UnsplashPhoto_User' }
      & Pick<UnsplashPhoto_User, 'id' | 'name'>
      & { links: (
        { __typename: 'UnsplashPhoto_User_Links' }
        & Pick<UnsplashPhoto_User_Links, 'html'>
      ) }
    ) }
  )> }
);

export type SelectCoverQueryVariables = {
  cardId: Scalars['ID']
};


export type SelectCoverQuery = (
  { __typename: 'Query' }
  & { card: Maybe<(
    { __typename: 'Card' }
    & Pick<Card, 'id' | 'idAttachmentCover'>
    & { cover: Maybe<(
      { __typename: 'Card_Cover' }
      & Pick<Card_Cover, 'idAttachment' | 'idUploadedBackground' | 'color' | 'edgeColor'>
      & { scaled: Maybe<Array<(
        { __typename: 'Card_Cover_Scaled' }
        & Pick<Card_Cover_Scaled, 'scaled' | 'width' | 'height' | 'url'>
      )>> }
    )>, attachments: Array<(
      { __typename: 'Attachment' }
      & Pick<Attachment, 'id' | 'edgeColor'>
      & { previews: Maybe<Array<(
        { __typename: 'Attachment_Preview' }
        & Pick<Attachment_Preview, 'scaled' | 'width' | 'height' | 'url'>
      )>> }
    )> }
  )> }
);

export type UpdateCardCoverMutationVariables = {
  cardId: Scalars['ID'],
  cover?: Maybe<InputCover>
};


export type UpdateCardCoverMutation = (
  { __typename: 'Mutation' }
  & { updateCardCover: Maybe<(
    { __typename: 'Card' }
    & Pick<Card, 'id' | 'idAttachmentCover'>
    & { cover: Maybe<(
      { __typename: 'Card_Cover' }
      & Pick<Card_Cover, 'idAttachment' | 'idUploadedBackground' | 'color'>
      & { scaled: Maybe<Array<(
        { __typename: 'Card_Cover_Scaled' }
        & Pick<Card_Cover_Scaled, 'url' | 'width' | 'height' | 'scaled'>
      )>> }
    )> }
  )> }
);

export type UploadCoverMutationVariables = {
  cardId: Scalars['ID'],
  file: Scalars['FileUpload']
};


export type UploadCoverMutation = (
  { __typename: 'Mutation' }
  & { uploadCardCover: Maybe<(
    { __typename: 'Attachment' }
    & Pick<Attachment, 'id'>
    & { previews: Maybe<Array<(
      { __typename: 'Attachment_Preview' }
      & Pick<Attachment_Preview, 'url'>
    )>> }
  )> }
);

export type CardTemplateQueryVariables = {
  cardId: Scalars['ID']
};


export type CardTemplateQuery = (
  { __typename: 'Query' }
  & { card: Maybe<(
    { __typename: 'Card' }
    & Pick<Card, 'id' | 'idBoard' | 'shortLink' | 'name' | 'isTemplate' | 'closed' | 'idList' | 'idChecklists' | 'idLabels' | 'idMembers'>
    & { attachments: Array<(
      { __typename: 'Attachment' }
      & Pick<Attachment, 'id'>
    )>, stickers: Array<(
      { __typename: 'Sticker' }
      & Pick<Sticker, 'id'>
    )> }
  )> }
);

export type CardTemplatesQueryVariables = {
  boardId: Scalars['ID']
};


export type CardTemplatesQuery = (
  { __typename: 'Query' }
  & { board: Maybe<(
    { __typename: 'Board' }
    & Pick<Board, 'id'>
    & { members: Array<(
      { __typename: 'Member' }
      & Pick<Member, 'id' | 'avatarUrl' | 'initials'>
    )>, cards: Array<(
      { __typename: 'Card' }
      & Pick<Card, 'id' | 'idBoard' | 'shortLink' | 'name' | 'isTemplate' | 'closed' | 'idList' | 'idChecklists' | 'idLabels' | 'idMembers'>
      & { attachments: Array<(
        { __typename: 'Attachment' }
        & Pick<Attachment, 'id'>
      )>, stickers: Array<(
        { __typename: 'Sticker' }
        & Pick<Sticker, 'id' | 'top' | 'left' | 'rotate' | 'zIndex' | 'image' | 'imageUrl'>
        & { imageScaled: Array<(
          { __typename: 'Sticker_ImageScaled' }
          & Pick<Sticker_ImageScaled, 'id' | 'width' | 'height' | 'url' | 'scaled'>
        )> }
      )>, labels: Array<(
        { __typename: 'Label' }
        & Pick<Label, 'id' | 'name' | 'color' | 'idBoard'>
      )>, cover: Maybe<(
        { __typename: 'Card_Cover' }
        & Pick<Card_Cover, 'edgeColor'>
        & { scaled: Maybe<Array<(
          { __typename: 'Card_Cover_Scaled' }
          & Pick<Card_Cover_Scaled, 'url' | 'width' | 'height' | 'scaled'>
        )>> }
      )>, badges: (
        { __typename: 'Card_Badges' }
        & Pick<Card_Badges, 'attachments' | 'checkItems' | 'description'>
        & { attachmentsByType: (
          { __typename: 'Card_Badges_AttachmentsByType' }
          & { trello: (
            { __typename: 'Card_Badges_AttachmentsByType_Trello' }
            & Pick<Card_Badges_AttachmentsByType_Trello, 'board' | 'card'>
          ) }
        ) }
      ) }
    )> }
  )> }
);

export type CreateCardFromTemplateListsQueryVariables = {
  boardId: Scalars['ID']
};


export type CreateCardFromTemplateListsQuery = (
  { __typename: 'Query' }
  & { board: Maybe<(
    { __typename: 'Board' }
    & { lists: Array<(
      { __typename: 'List' }
      & Pick<List, 'id' | 'name' | 'closed'>
    )> }
  )> }
);

export type CreateCardFromTemplateMutationVariables = {
  idCardSource: Scalars['ID'],
  idList: Scalars['ID'],
  name?: Maybe<Scalars['String']>,
  keepFromSource?: Maybe<Array<Scalars['String']>>
};


export type CreateCardFromTemplateMutation = (
  { __typename: 'Mutation' }
  & { copyCard: Maybe<(
    { __typename: 'Card' }
    & Pick<Card, 'id' | 'shortLink'>
  )> }
);

export type CreateCardTemplateMutationVariables = {
  listId: Scalars['ID'],
  name: Scalars['String'],
  closed?: Maybe<Scalars['Boolean']>
};


export type CreateCardTemplateMutation = (
  { __typename: 'Mutation' }
  & { createCardTemplate: Maybe<(
    { __typename: 'Card' }
    & Pick<Card, 'id' | 'idBoard' | 'shortLink' | 'name' | 'isTemplate' | 'closed' | 'idList' | 'idChecklists' | 'idLabels' | 'idMembers'>
    & { attachments: Array<(
      { __typename: 'Attachment' }
      & Pick<Attachment, 'id'>
    )>, stickers: Array<(
      { __typename: 'Sticker' }
      & Pick<Sticker, 'id' | 'top' | 'left' | 'rotate' | 'zIndex' | 'image' | 'imageUrl'>
      & { imageScaled: Array<(
        { __typename: 'Sticker_ImageScaled' }
        & Pick<Sticker_ImageScaled, 'id' | 'width' | 'height' | 'url' | 'scaled'>
      )> }
    )>, labels: Array<(
      { __typename: 'Label' }
      & Pick<Label, 'id' | 'name' | 'color' | 'idBoard'>
    )>, cover: Maybe<(
      { __typename: 'Card_Cover' }
      & Pick<Card_Cover, 'edgeColor'>
      & { scaled: Maybe<Array<(
        { __typename: 'Card_Cover_Scaled' }
        & Pick<Card_Cover_Scaled, 'url' | 'width' | 'height' | 'scaled'>
      )>> }
    )>, badges: (
      { __typename: 'Card_Badges' }
      & Pick<Card_Badges, 'attachments' | 'checkItems' | 'description'>
      & { attachmentsByType: (
        { __typename: 'Card_Badges_AttachmentsByType' }
        & { trello: (
          { __typename: 'Card_Badges_AttachmentsByType_Trello' }
          & Pick<Card_Badges_AttachmentsByType_Trello, 'board' | 'card'>
        ) }
      ) }
    ) }
  )> }
);

export type DeleteCardTemplateMutationVariables = {
  idCard: Scalars['ID']
};


export type DeleteCardTemplateMutation = (
  { __typename: 'Mutation' }
  & { deleteCard: Maybe<(
    { __typename: 'Card_DeleteResponse' }
    & Pick<Card_DeleteResponse, 'success'>
  )> }
);

export type EmailSniperLinkQueryQueryVariables = {
  email: Scalars['String']
};


export type EmailSniperLinkQueryQuery = (
  { __typename: 'Query' }
  & { emailProvider: (
    { __typename: 'EmailProvider' }
    & Pick<EmailProvider, 'name' | 'url'>
  ) }
);

export type ClaimOrganizationMutationVariables = {
  idEnterprise: Scalars['ID'],
  idOrganization: Scalars['ID']
};


export type ClaimOrganizationMutation = (
  { __typename: 'Mutation' }
  & { claimOrganization: (
    { __typename: 'Organization' }
    & Pick<Organization, 'id'>
  ) }
);

export type ClaimableOrganizationAdminsQueryVariables = {
  ids: Array<Scalars['ID']>
};


export type ClaimableOrganizationAdminsQuery = (
  { __typename: 'Query' }
  & { members: Array<(
    { __typename: 'Member' }
    & Pick<Member, 'id' | 'username' | 'avatarSource' | 'avatarHash' | 'initials' | 'fullName' | 'products'>
    & { nonPublic: Maybe<(
      { __typename: 'Member_NonPublic' }
      & Pick<Member_NonPublic, 'initials' | 'fullName' | 'avatarHash'>
    )> }
  )> }
);

export type ClaimableOrganizationTransferrableDataQueryVariables = {
  idOrganization: Scalars['ID'],
  idEnterprise: Scalars['ID']
};


export type ClaimableOrganizationTransferrableDataQuery = (
  { __typename: 'Query' }
  & { enterprise: Maybe<(
    { __typename: 'Enterprise' }
    & { transferrableData: (
      { __typename: 'TransferrableData' }
      & Pick<TransferrableData, 'transferrable'>
      & { newBillableMembers: Array<(
        { __typename: 'TransferrableDataMember' }
        & Pick<TransferrableDataMember, 'fullName' | 'username' | 'initials' | 'avatarHash' | 'avatarUrl'>
      )>, restrictedMembers: Array<(
        { __typename: 'TransferrableDataMember' }
        & Pick<TransferrableDataMember, 'fullName' | 'username' | 'initials' | 'avatarHash' | 'avatarUrl'>
      )> }
    ) }
  )> }
);

export type ClaimableOrganizationsQueryVariables = {
  id: Scalars['ID']
};


export type ClaimableOrganizationsQuery = (
  { __typename: 'Query' }
  & { enterprise: Maybe<(
    { __typename: 'Enterprise' }
    & { licenses: (
      { __typename: 'Enterprise_Licenses' }
      & Pick<Enterprise_Licenses, 'maxMembers' | 'totalMembers'>
    ), claimableOrganizations: (
      { __typename: 'ClaimableOrganizations' }
      & Pick<ClaimableOrganizations, 'count'>
      & { organizations: Array<(
        { __typename: 'ClaimableOrganization' }
        & Pick<ClaimableOrganization, 'id' | 'products' | 'name' | 'displayName' | 'idActiveAdmins' | 'activeMembershipCount'>
      )> }
    ) }
  )> }
);

export type DismissBannerMutationVariables = {
  memberId: Scalars['ID'],
  messageId: Scalars['ID']
};


export type DismissBannerMutation = (
  { __typename: 'Mutation' }
  & { addOneTimeMessagesDismissed: Maybe<(
    { __typename: 'Member' }
    & Pick<Member, 'id' | 'oneTimeMessagesDismissed'>
  )> }
);

export type FreeTeamLimitQueryVariables = {
  memberId: Scalars['ID']
};


export type FreeTeamLimitQuery = (
  { __typename: 'Query' }
  & { member: Maybe<(
    { __typename: 'Member' }
    & Pick<Member, 'id' | 'email' | 'oneTimeMessagesDismissed'>
  )> }
);

export type LanguagePickerQueryVariables = {
  memberId: Scalars['ID']
};


export type LanguagePickerQuery = (
  { __typename: 'Query' }
  & { member: Maybe<(
    { __typename: 'Member' }
    & Pick<Member, 'id'>
    & { prefs: Maybe<(
      { __typename: 'Member_Prefs' }
      & Pick<Member_Prefs, 'locale'>
    )> }
  )> }
);

export type UpdateUserLocaleMutationVariables = {
  memberId: Scalars['ID'],
  locale: Scalars['String']
};


export type UpdateUserLocaleMutation = (
  { __typename: 'Mutation' }
  & { updateUserLocale: Maybe<(
    { __typename: 'Member' }
    & Pick<Member, 'id'>
    & { prefs: Maybe<(
      { __typename: 'Member_Prefs' }
      & Pick<Member_Prefs, 'locale'>
    )> }
  )> }
);

export type MemberAvatarQueryVariables = {
  memberId: Scalars['ID']
};


export type MemberAvatarQuery = (
  { __typename: 'Query' }
  & { member: Maybe<(
    { __typename: 'Member' }
    & Pick<Member, 'id' | 'username' | 'avatarSource' | 'avatarHash' | 'initials' | 'fullName' | 'products'>
    & { nonPublic: Maybe<(
      { __typename: 'Member_NonPublic' }
      & Pick<Member_NonPublic, 'initials' | 'fullName' | 'avatarHash'>
    )> }
  )> }
);

export type MemberBillingViewQueryVariables = {
  memberId: Scalars['ID']
};


export type MemberBillingViewQuery = (
  { __typename: 'Query' }
  & { member: Maybe<(
    { __typename: 'Member' }
    & Pick<Member, 'id' | 'products'>
    & { paidAccount: (
      { __typename: 'PaidAccount' }
      & Pick<PaidAccount, 'standing'>
    ) }
  )> }
);

export type MoonshotBillingQueryVariables = {};


export type MoonshotBillingQuery = (
  { __typename: 'Query' }
  & { member: Maybe<(
    { __typename: 'Member' }
    & Pick<Member, 'confirmed' | 'email'>
    & { organizations: Array<(
      { __typename: 'Organization' }
      & Pick<Organization, 'activeBillableMemberCount' | 'billableCollaboratorCount' | 'billableMemberCount' | 'displayName' | 'id' | 'logoHash'>
      & { memberships: Array<(
        { __typename: 'Organization_Membership' }
        & Pick<Organization_Membership, 'idMember' | 'unconfirmed'>
      )>, paidAccount: (
        { __typename: 'PaidAccount' }
        & Pick<PaidAccount, 'billingDates' | 'contactFullName' | 'contactEmail' | 'contactLocale'>
      ) }
    )> }
  )> }
);

export type MoonshotUpdateCampaignMutationVariables = {
  id: Scalars['ID'],
  currentStep?: Maybe<Scalars['String']>,
  dateDismissed?: Maybe<Scalars['String']>,
  isDismissed?: Maybe<Scalars['Boolean']>
};


export type MoonshotUpdateCampaignMutation = (
  { __typename: 'Mutation' }
  & { updateCampaign: Maybe<(
    { __typename: 'Campaign' }
    & Pick<Campaign, 'id' | 'dateDismissed' | 'currentStep' | 'name'>
  )> }
);

export type MoonshotCampaignQueryVariables = {};


export type MoonshotCampaignQuery = (
  { __typename: 'Query' }
  & { member: Maybe<(
    { __typename: 'Member' }
    & Pick<Member, 'idOrganizations'>
    & { organizations: Array<(
      { __typename: 'Organization' }
      & Pick<Organization, 'url'>
    )>, campaigns: Array<(
      { __typename: 'Campaign' }
      & Pick<Campaign, 'id' | 'name' | 'currentStep' | 'dateDismissed'>
    )> }
  )> }
);

export type MoonshotCopyBoardMutationVariables = {
  organizationId: Scalars['ID'],
  boardId: Scalars['ID']
};


export type MoonshotCopyBoardMutation = (
  { __typename: 'Mutation' }
  & { copyBoardToOrg: Maybe<(
    { __typename: 'Board' }
    & Pick<Board, 'id'>
  )> }
);

export type MoonshotCreateTeamSubmitMutationVariables = {
  displayName: Scalars['String'],
  type: Scalars['String'],
  desc?: Maybe<Scalars['String']>,
  enterprise?: Maybe<Scalars['String']>,
  allAdminsEnabled?: Maybe<Scalars['Boolean']>
};


export type MoonshotCreateTeamSubmitMutation = (
  { __typename: 'Mutation' }
  & { createOrganization: Maybe<(
    { __typename: 'Organization' }
    & Pick<Organization, 'id'>
  )> }
);

export type MoonshotCreateTeamQueryVariables = {
  memberId: Scalars['ID']
};


export type MoonshotCreateTeamQuery = (
  { __typename: 'Query' }
  & { member: Maybe<(
    { __typename: 'Member' }
    & Pick<Member, 'fullName'>
  )> }
);

export type MoonshotEmailVerificationAddEmailMutationVariables = {
  email: Scalars['String']
};


export type MoonshotEmailVerificationAddEmailMutation = (
  { __typename: 'Mutation' }
  & { addMemberEmail: Maybe<(
    { __typename: 'Member' }
    & Pick<Member, 'email'>
  )> }
);

export type MoonshotEmailVerificationResendEmailMutationVariables = {
  email: Scalars['String']
};


export type MoonshotEmailVerificationResendEmailMutation = (
  { __typename: 'Mutation' }
  & { resendVerificationEmail: Maybe<(
    { __typename: 'Member' }
    & Pick<Member, 'email'>
  )> }
);

export type MoonshotInviteTeamMembersMutationVariables = {
  orgId: Scalars['ID'],
  users: Array<Maybe<MemberOrEmail>>,
  invitationMessage: Scalars['String']
};


export type MoonshotInviteTeamMembersMutation = (
  { __typename: 'Mutation' }
  & { addMembersToOrg: Maybe<(
    { __typename: 'InviteMember_Response' }
    & Pick<InviteMember_Response, 'success' | 'error'>
  )> }
);

export type MoonshotInviteTeamMembersGetOrgQueryVariables = {
  orgId: Scalars['ID']
};


export type MoonshotInviteTeamMembersGetOrgQuery = (
  { __typename: 'Query' }
  & { organization: Maybe<(
    { __typename: 'Organization' }
    & Pick<Organization, 'id' | 'name' | 'displayName' | 'url' | 'logoHash'>
  )> }
);

export type MoonshotPopoverQueryVariables = {};


export type MoonshotPopoverQuery = (
  { __typename: 'Query' }
  & { member: Maybe<(
    { __typename: 'Member' }
    & { boards: Array<(
      { __typename: 'Board' }
      & Pick<Board, 'id' | 'idOrganization' | 'shortLink'>
    )>, organizations: Array<(
      { __typename: 'Organization' }
      & Pick<Organization, 'id' | 'name' | 'products'>
      & { memberships: Array<(
        { __typename: 'Organization_Membership' }
        & Pick<Organization_Membership, 'idMember'>
      )> }
    )>, campaigns: Array<(
      { __typename: 'Campaign' }
      & Pick<Campaign, 'id' | 'name' | 'dateDismissed'>
    )> }
  )> }
);

export type MoonshotSuccessQueryVariables = {
  memberId: Scalars['ID']
};


export type MoonshotSuccessQuery = (
  { __typename: 'Query' }
  & { member: Maybe<(
    { __typename: 'Member' }
    & { organizations: Array<(
      { __typename: 'Organization' }
      & Pick<Organization, 'id' | 'displayName' | 'url'>
    )> }
  )> }
);

export type MoveCardPopoverQueryVariables = {
  boardId: Scalars['ID']
};


export type MoveCardPopoverQuery = (
  { __typename: 'Query' }
  & { board: Maybe<(
    { __typename: 'Board' }
    & { lists: Array<(
      { __typename: 'List' }
      & Pick<List, 'id' | 'name'>
    )>, cards: Array<(
      { __typename: 'Card' }
      & Pick<Card, 'id' | 'idList'>
    )> }
  )> }
);

export type DeleteOneTimeMessagesDismissedMutationVariables = {
  memberId: Scalars['ID'],
  message: Scalars['String']
};


export type DeleteOneTimeMessagesDismissedMutation = (
  { __typename: 'Mutation' }
  & { deleteOneTimeMessagesDismissed: Maybe<(
    { __typename: 'Member' }
    & Pick<Member, 'id' | 'oneTimeMessagesDismissed'>
  )> }
);

export type OneTimeMessagesDismissedQueryVariables = {
  memberId: Scalars['ID']
};


export type OneTimeMessagesDismissedQuery = (
  { __typename: 'Query' }
  & { member: Maybe<(
    { __typename: 'Member' }
    & Pick<Member, 'id' | 'oneTimeMessagesDismissed'>
  )> }
);

export type EnablePluginMutationVariables = {
  boardId: Scalars['ID'],
  pluginId: Scalars['ID']
};


export type EnablePluginMutation = (
  { __typename: 'Mutation' }
  & { enablePlugin: Maybe<(
    { __typename: 'Plugin_EnableResponse' }
    & Pick<Plugin_EnableResponse, 'success' | 'error'>
  )> }
);

export type PowerUpDirectoryCategoriesQueryVariables = {};


export type PowerUpDirectoryCategoriesQuery = (
  { __typename: 'Query' }
  & Pick<Query, 'pluginCategories'>
);

export type PublicPluginQueryVariables = {};


export type PublicPluginQuery = (
  { __typename: 'Query' }
  & { publicPlugins: Array<(
    { __typename: 'Plugin' }
    & Pick<Plugin, 'id' | 'idOrganizationOwner' | 'author' | 'categories' | 'privacyUrl' | 'public' | 'moderatedState' | 'tags' | 'isCompliantWithPrivacyStandards' | 'heroImageUrl'>
    & { icon: (
      { __typename: 'Plugin_Icon' }
      & Pick<Plugin_Icon, 'url'>
    ), listing: Maybe<(
      { __typename: 'Plugin_Listing' }
      & Pick<Plugin_Listing, 'name' | 'description' | 'overview'>
    )>, usageBrackets: (
      { __typename: 'Plugin_UsageBrackets' }
      & Pick<Plugin_UsageBrackets, 'boards'>
    ) }
  )> }
);

export type AnnouncementsQueryVariables = {
  filter?: Maybe<Scalars['String']>
};


export type AnnouncementsQuery = (
  { __typename: 'Query' }
  & { announcements: Array<(
    { __typename: 'Announcement' }
    & Pick<Announcement, 'id' | 'title' | 'html' | 'url' | 'locale' | 'type'>
  )> }
);

export type DismissAnnouncementMutationVariables = {
  announcementId: Scalars['ID']
};


export type DismissAnnouncementMutation = (
  { __typename: 'Mutation' }
  & { dismissAnnouncement: Maybe<(
    { __typename: 'Announcement_DismissResponse' }
    & Pick<Announcement_DismissResponse, 'success'>
  )> }
);

export type TeamBillingViewQueryVariables = {
  memberId: Scalars['ID'],
  orgId: Scalars['ID']
};


export type TeamBillingViewQuery = (
  { __typename: 'Query' }
  & { member: Maybe<(
    { __typename: 'Member' }
    & Pick<Member, 'id' | 'idPremOrgsAdmin' | 'memberType'>
  )>, organization: Maybe<(
    { __typename: 'Organization' }
    & Pick<Organization, 'id' | 'idEnterprise' | 'activeBillableMemberCount' | 'billableCollaboratorCount' | 'billableMemberCount'>
    & { enterprise: Maybe<(
      { __typename: 'Enterprise' }
      & Pick<Enterprise, 'id' | 'idAdmins'>
    )>, memberships: Array<(
      { __typename: 'Organization_Membership' }
      & Pick<Organization_Membership, 'id' | 'idMember' | 'memberType' | 'unconfirmed' | 'deactivated'>
    )>, paidAccount: (
      { __typename: 'PaidAccount' }
      & Pick<PaidAccount, 'standing' | 'billingDates'>
    ) }
  )> }
);

export type ByCardStatusQueryVariables = {
  orgId: Scalars['ID'],
  dueDateSince?: Maybe<Scalars['String']>,
  dueDateUntil?: Maybe<Scalars['String']>,
  refreshTime?: Maybe<Scalars['Int']>,
  idMembers?: Maybe<Array<Scalars['ID']>>,
  idBoards?: Maybe<Array<Scalars['ID']>>,
  idLabels?: Maybe<Array<Scalars['ID']>>
};


export type ByCardStatusQuery = (
  { __typename: 'Query' }
  & { organization: Maybe<(
    { __typename: 'Organization' }
    & Pick<Organization, 'id'>
    & { stats: (
      { __typename: 'Organization_Stats' }
      & { cards: (
        { __typename: 'Organization_Stats_Cards' }
        & Pick<Organization_Stats_Cards, 'incomplete'>
        & { stats: Array<(
          { __typename: 'Organization_Stats_Cards_Stat' }
          & { overdue: (
            { __typename: 'Organization_Stats_Cards_Stat_Overdue' }
            & Pick<Organization_Stats_Cards_Stat_Overdue, 'count' | 'ids'>
          ), upcoming: (
            { __typename: 'Organization_Stats_Cards_Stat_Upcoming' }
            & Pick<Organization_Stats_Cards_Stat_Upcoming, 'count' | 'ids'>
          ), done: (
            { __typename: 'Organization_Stats_Cards_Stat_Done' }
            & Pick<Organization_Stats_Cards_Stat_Done, 'count'>
          ), noDueDate: (
            { __typename: 'Organization_Stats_Cards_Stat_NoDueDate' }
            & Pick<Organization_Stats_Cards_Stat_NoDueDate, 'count'>
          ) }
        )> }
      ) }
    ) }
  )> }
);

export type ByMemberQueryVariables = {
  orgId: Scalars['ID'],
  refreshTime?: Maybe<Scalars['Int']>,
  idMembers?: Maybe<Array<Scalars['ID']>>,
  idBoards?: Maybe<Array<Scalars['ID']>>,
  idLabels?: Maybe<Array<Scalars['ID']>>
};


export type ByMemberQuery = (
  { __typename: 'Query' }
  & { organization: Maybe<(
    { __typename: 'Organization' }
    & { stats: (
      { __typename: 'Organization_Stats' }
      & { cards: (
        { __typename: 'Organization_Stats_Cards' }
        & Pick<Organization_Stats_Cards, 'incomplete'>
        & { stats: Array<(
          { __typename: 'Organization_Stats_Cards_Stat' }
          & Pick<Organization_Stats_Cards_Stat, 'idMember'>
          & { overdue: (
            { __typename: 'Organization_Stats_Cards_Stat_Overdue' }
            & Pick<Organization_Stats_Cards_Stat_Overdue, 'count'>
          ), upcoming: (
            { __typename: 'Organization_Stats_Cards_Stat_Upcoming' }
            & Pick<Organization_Stats_Cards_Stat_Upcoming, 'count'>
          ), done: (
            { __typename: 'Organization_Stats_Cards_Stat_Done' }
            & Pick<Organization_Stats_Cards_Stat_Done, 'count'>
          ), noDueDate: (
            { __typename: 'Organization_Stats_Cards_Stat_NoDueDate' }
            & Pick<Organization_Stats_Cards_Stat_NoDueDate, 'count'>
          ) }
        )> }
      ) }
    ), members: Array<(
      { __typename: 'Member' }
      & Pick<Member, 'id' | 'fullName' | 'avatarHash' | 'initials' | 'username'>
    )> }
  )> }
);

export type InitialMembersQueryVariables = {
  orgId: Scalars['ID']
};


export type InitialMembersQuery = (
  { __typename: 'Query' }
  & { organization: Maybe<(
    { __typename: 'Organization' }
    & { members: Array<(
      { __typename: 'Member' }
      & Pick<Member, 'id' | 'fullName' | 'username' | 'avatarHash' | 'initials'>
    )> }
  )> }
);

export type TeamReportBoardsQueryVariables = {
  orgId: Scalars['ID'],
  startIndex?: Maybe<Scalars['Int']>,
  count?: Maybe<Scalars['Int']>
};


export type TeamReportBoardsQuery = (
  { __typename: 'Query' }
  & { organization: Maybe<(
    { __typename: 'Organization' }
    & { boards: Array<(
      { __typename: 'Board' }
      & Pick<Board, 'id' | 'name'>
      & { prefs: Maybe<(
        { __typename: 'Board_Prefs' }
        & Pick<Board_Prefs, 'backgroundColor' | 'backgroundTile' | 'backgroundImage' | 'permissionLevel'>
        & { backgroundImageScaled: Maybe<Array<(
          { __typename: 'Board_Prefs_BackgroundImageScaled' }
          & Pick<Board_Prefs_BackgroundImageScaled, 'width' | 'height' | 'url'>
        )>> }
      )> }
    )> }
  )> }
);

export type TeamReportBoardsSearchQueryVariables = {
  query: Scalars['String'],
  idOrganizations?: Maybe<Array<Scalars['ID']>>
};


export type TeamReportBoardsSearchQuery = (
  { __typename: 'Query' }
  & { search: (
    { __typename: 'Search' }
    & { boards: Array<(
      { __typename: 'Board' }
      & Pick<Board, 'id' | 'name'>
      & { prefs: Maybe<(
        { __typename: 'Board_Prefs' }
        & Pick<Board_Prefs, 'backgroundColor' | 'backgroundTile' | 'backgroundImage'>
        & { backgroundImageScaled: Maybe<Array<(
          { __typename: 'Board_Prefs_BackgroundImageScaled' }
          & Pick<Board_Prefs_BackgroundImageScaled, 'width' | 'height' | 'url'>
        )>> }
      )> }
    )> }
  ) }
);

export type TeamReportByLabelQueryVariables = {
  orgId: Scalars['ID'],
  refreshTime?: Maybe<Scalars['Int']>,
  idMembers?: Maybe<Array<Scalars['ID']>>,
  idBoards?: Maybe<Array<Scalars['ID']>>,
  idLabels?: Maybe<Array<Scalars['ID']>>
};


export type TeamReportByLabelQuery = (
  { __typename: 'Query' }
  & { organization: Maybe<(
    { __typename: 'Organization' }
    & Pick<Organization, 'id'>
    & { stats: (
      { __typename: 'Organization_Stats' }
      & { cards: (
        { __typename: 'Organization_Stats_Cards' }
        & Pick<Organization_Stats_Cards, 'incomplete'>
        & { stats: Array<(
          { __typename: 'Organization_Stats_Cards_Stat' }
          & Pick<Organization_Stats_Cards_Stat, 'labelName'>
          & { overdue: (
            { __typename: 'Organization_Stats_Cards_Stat_Overdue' }
            & Pick<Organization_Stats_Cards_Stat_Overdue, 'count'>
          ), upcoming: (
            { __typename: 'Organization_Stats_Cards_Stat_Upcoming' }
            & Pick<Organization_Stats_Cards_Stat_Upcoming, 'count'>
          ), done: (
            { __typename: 'Organization_Stats_Cards_Stat_Done' }
            & Pick<Organization_Stats_Cards_Stat_Done, 'count'>
          ), noDueDate: (
            { __typename: 'Organization_Stats_Cards_Stat_NoDueDate' }
            & Pick<Organization_Stats_Cards_Stat_NoDueDate, 'count'>
          ) }
        )> }
      ) }
    ) }
  )> }
);

export type TeamReportCardsQueryVariables = {
  ids: Array<Scalars['ID']>
};


export type TeamReportCardsQuery = (
  { __typename: 'Query' }
  & { cards: Array<(
    { __typename: 'Card' }
    & Pick<Card, 'due' | 'dueComplete' | 'name' | 'url' | 'id'>
    & { board: (
      { __typename: 'Board' }
      & Pick<Board, 'id' | 'name' | 'url'>
      & { prefs: Maybe<(
        { __typename: 'Board_Prefs' }
        & Pick<Board_Prefs, 'backgroundBottomColor' | 'backgroundColor' | 'backgroundImage' | 'backgroundBrightness'>
      )> }
    ), list: (
      { __typename: 'List' }
      & Pick<List, 'name'>
    ) }
  )> }
);

export type TeamReportLabelNamesQueryVariables = {
  orgId: Scalars['ID']
};


export type TeamReportLabelNamesQuery = (
  { __typename: 'Query' }
  & { organization: Maybe<(
    { __typename: 'Organization' }
    & Pick<Organization, 'id'>
    & { stats: (
      { __typename: 'Organization_Stats' }
      & { labelNames: (
        { __typename: 'Organization_Stats_LabelNames' }
        & Pick<Organization_Stats_LabelNames, 'incomplete'>
        & { stats: Array<(
          { __typename: 'Organization_Stats_LabelName_Stat' }
          & Pick<Organization_Stats_LabelName_Stat, 'count' | 'ids' | 'name' | 'totalUses'>
        )> }
      ) }
    ) }
  )> }
);

export type TeamReportOrganizationQueryVariables = {
  orgId: Scalars['ID']
};


export type TeamReportOrganizationQuery = (
  { __typename: 'Query' }
  & { organization: Maybe<(
    { __typename: 'Organization' }
    & Pick<Organization, 'id'>
  )> }
);

export type TeamfulCollaborationAddBoardsQueryVariables = {};


export type TeamfulCollaborationAddBoardsQuery = (
  { __typename: 'Query' }
  & { member: Maybe<(
    { __typename: 'Member' }
    & Pick<Member, 'id'>
    & { enterprises: Array<(
      { __typename: 'Enterprise' }
      & Pick<Enterprise, 'id'>
    )>, boards: Array<(
      { __typename: 'Board' }
      & Pick<Board, 'enterpriseOwned' | 'idOrganization' | 'name' | 'id'>
      & { memberships: Array<(
        { __typename: 'Board_Membership' }
        & Pick<Board_Membership, 'idMember' | 'memberType' | 'unconfirmed'>
      )>, prefs: Maybe<(
        { __typename: 'Board_Prefs' }
        & Pick<Board_Prefs, 'backgroundColor' | 'backgroundImage'>
      )> }
    )> }
  )> }
);

export type TeamfulCollaborationMoveBoardToOrgMutationVariables = {
  boardId: Scalars['ID'],
  orgId?: Maybe<Scalars['ID']>
};


export type TeamfulCollaborationMoveBoardToOrgMutation = (
  { __typename: 'Mutation' }
  & { updateBoardOrg: Maybe<(
    { __typename: 'Board' }
    & Pick<Board, 'id'>
  )> }
);

export type TeamfulCollaborationAddPeopleToOrgMutationVariables = {
  orgId: Scalars['ID'],
  users: Array<Maybe<MemberOrEmail>>
};


export type TeamfulCollaborationAddPeopleToOrgMutation = (
  { __typename: 'Mutation' }
  & { addMembersToOrg: Maybe<(
    { __typename: 'InviteMember_Response' }
    & Pick<InviteMember_Response, 'success' | 'error'>
  )> }
);

export type TeamfulCollaborationAddPeopleQueryVariables = {
  orgId: Scalars['ID']
};


export type TeamfulCollaborationAddPeopleQuery = (
  { __typename: 'Query' }
  & { organization: Maybe<(
    { __typename: 'Organization' }
    & { boards: Array<(
      { __typename: 'Board' }
      & { memberships: Array<(
        { __typename: 'Board_Membership' }
        & Pick<Board_Membership, 'idMember' | 'unconfirmed'>
      )> }
    )>, members: Array<(
      { __typename: 'Member' }
      & Pick<Member, 'id'>
    )> }
  )> }
);

export type TeamfulCollaborationAddPeopleSortQueryVariables = {
  memberIds: Array<Scalars['ID']>
};


export type TeamfulCollaborationAddPeopleSortQuery = (
  { __typename: 'Query' }
  & { members: Array<(
    { __typename: 'Member' }
    & Pick<Member, 'id' | 'fullName'>
    & { nonPublic: Maybe<(
      { __typename: 'Member_NonPublic' }
      & Pick<Member_NonPublic, 'fullName'>
    )> }
  )> }
);

export type TeamfulCollaborationSuccessMessageQueryVariables = {
  orgId: Scalars['ID']
};


export type TeamfulCollaborationSuccessMessageQuery = (
  { __typename: 'Query' }
  & { organization: Maybe<(
    { __typename: 'Organization' }
    & Pick<Organization, 'id' | 'displayName' | 'name'>
    & { members: Array<(
      { __typename: 'Member' }
      & Pick<Member, 'id' | 'username' | 'avatarSource' | 'avatarHash' | 'initials' | 'fullName' | 'products'>
      & { nonPublic: Maybe<(
        { __typename: 'Member_NonPublic' }
        & Pick<Member_NonPublic, 'initials' | 'fullName' | 'avatarHash'>
      )> }
    )> }
  )> }
);

export type TeamlessCollaborationCreateTeamAddMembersMutationVariables = {
  orgId: Scalars['ID'],
  users: Array<Maybe<MemberOrEmail>>
};


export type TeamlessCollaborationCreateTeamAddMembersMutation = (
  { __typename: 'Mutation' }
  & { addMembersToOrg: Maybe<(
    { __typename: 'InviteMember_Response' }
    & Pick<InviteMember_Response, 'success' | 'error'>
  )> }
);

export type TeamlessCollaborationCreateTeamMembersQueryVariables = {
  boardId: Scalars['ID']
};


export type TeamlessCollaborationCreateTeamMembersQuery = (
  { __typename: 'Query' }
  & { board: Maybe<(
    { __typename: 'Board' }
    & Pick<Board, 'id'>
    & { members: Array<(
      { __typename: 'Member' }
      & Pick<Member, 'confirmed' | 'fullName' | 'id'>
      & { nonPublic: Maybe<(
        { __typename: 'Member_NonPublic' }
        & Pick<Member_NonPublic, 'fullName'>
      )> }
    )> }
  )> }
);

export type TeamlessCollaborationCreateTeamSubmitMutationVariables = {
  displayName: Scalars['String'],
  type: Scalars['String'],
  desc?: Maybe<Scalars['String']>,
  enterprise?: Maybe<Scalars['String']>,
  allAdminsEnabled?: Maybe<Scalars['Boolean']>
};


export type TeamlessCollaborationCreateTeamSubmitMutation = (
  { __typename: 'Mutation' }
  & { createOrganization: Maybe<(
    { __typename: 'Organization' }
    & Pick<Organization, 'id' | 'name'>
  )> }
);

export type TeamlessCollaborationPromptQueryVariables = {
  boardId: Scalars['ID']
};


export type TeamlessCollaborationPromptQuery = (
  { __typename: 'Query' }
  & { board: Maybe<(
    { __typename: 'Board' }
    & Pick<Board, 'id' | 'idOrganization'>
    & { members: Array<(
      { __typename: 'Member' }
      & Pick<Member, 'confirmed' | 'id'>
    )>, memberships: Array<(
      { __typename: 'Board_Membership' }
      & Pick<Board_Membership, 'idMember' | 'memberType'>
    )> }
  )>, member: Maybe<(
    { __typename: 'Member' }
    & Pick<Member, 'id'>
    & { enterprises: Array<(
      { __typename: 'Enterprise' }
      & Pick<Enterprise, 'id'>
    )> }
  )> }
);

export type TemplateBackgroundImageScaleQueryVariables = {
  idBoard: Scalars['ID']
};


export type TemplateBackgroundImageScaleQuery = (
  { __typename: 'Query' }
  & { board: Maybe<(
    { __typename: 'Board' }
    & { prefs: Maybe<(
      { __typename: 'Board_Prefs' }
      & { backgroundImageScaled: Maybe<Array<(
        { __typename: 'Board_Prefs_BackgroundImageScaled' }
        & Pick<Board_Prefs_BackgroundImageScaled, 'width' | 'height' | 'url'>
      )>> }
    )> }
  )> }
);

export type TemplateCategoriesQueryVariables = {};


export type TemplateCategoriesQuery = (
  { __typename: 'Query' }
  & { templateCategories: Array<(
    { __typename: 'TemplateCategory' }
    & Pick<TemplateCategory, 'key'>
  )> }
);

export type TemplateGalleryQueryVariables = {};


export type TemplateGalleryQuery = (
  { __typename: 'Query' }
  & { templateGallery: Array<(
    { __typename: 'Board' }
    & Pick<Board, 'desc' | 'id' | 'idOrganization' | 'name' | 'shortLink'>
    & { prefs: Maybe<(
      { __typename: 'Board_Prefs' }
      & Pick<Board_Prefs, 'background' | 'backgroundColor' | 'backgroundImage'>
      & { backgroundImageScaled: Maybe<Array<(
        { __typename: 'Board_Prefs_BackgroundImageScaled' }
        & Pick<Board_Prefs_BackgroundImageScaled, 'width' | 'height' | 'url'>
      )>> }
    )>, templateGallery: Maybe<(
      { __typename: 'TemplateGallery' }
      & Pick<TemplateGallery, 'avatarUrl' | 'avatarShape' | 'byline' | 'category' | 'precedence' | 'blurb' | 'featured'>
    )> }
  )> }
);

export type TemplatesStoryQueryVariables = {
  boardId: Scalars['ID']
};


export type TemplatesStoryQuery = (
  { __typename: 'Query' }
  & { board: Maybe<(
    { __typename: 'Board' }
    & Pick<Board, 'desc' | 'id' | 'name' | 'shortUrl'>
    & { members: Array<(
      { __typename: 'Member' }
      & Pick<Member, 'avatarHash' | 'avatarUrl' | 'fullName' | 'initials'>
    )>, organization: Maybe<(
      { __typename: 'Organization' }
      & Pick<Organization, 'displayName' | 'logoHash' | 'name'>
    )>, plugins: Array<(
      { __typename: 'Plugin' }
      & Pick<Plugin, 'id'>
      & { icon: (
        { __typename: 'Plugin_Icon' }
        & Pick<Plugin_Icon, 'url'>
      ), listing: Maybe<(
        { __typename: 'Plugin_Listing' }
        & Pick<Plugin_Listing, 'name' | 'description' | 'overview'>
      )> }
    )>, prefs: Maybe<(
      { __typename: 'Board_Prefs' }
      & Pick<Board_Prefs, 'isTemplate' | 'background' | 'backgroundColor' | 'backgroundImage'>
    )>, templateGallery: Maybe<(
      { __typename: 'TemplateGallery' }
      & Pick<TemplateGallery, 'avatarUrl' | 'avatarShape' | 'byline'>
    )> }
  )> }
);

export type UpgradePromptDismissMessageMutationVariables = {
  memberId: Scalars['ID'],
  messageId: Scalars['ID']
};


export type UpgradePromptDismissMessageMutation = (
  { __typename: 'Mutation' }
  & { addOneTimeMessagesDismissed: Maybe<(
    { __typename: 'Member' }
    & Pick<Member, 'id' | 'oneTimeMessagesDismissed'>
  )> }
);

export type UpgradePromptQueryVariables = {
  memberId: Scalars['ID'],
  orgId: Scalars['ID']
};


export type UpgradePromptQuery = (
  { __typename: 'Query' }
  & { member: Maybe<(
    { __typename: 'Member' }
    & Pick<Member, 'id' | 'oneTimeMessagesDismissed'>
  )>, organization: Maybe<(
    { __typename: 'Organization' }
    & Pick<Organization, 'products'>
  )> }
);

export const BoardExportDocument: DocumentNode = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BoardExport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idBoard"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idExport"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"board"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idBoard"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"},"arguments":[]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idOrganization"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"exports"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idExport"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"status"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attempts"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"finished"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"stage"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"size"},"arguments":[],"directives":[]}]}}]}}]}}]};

    export function useBoardExportQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<BoardExportQuery, BoardExportQueryVariables>) {
      return ApolloReactHooks.useQuery<BoardExportQuery, BoardExportQueryVariables>(BoardExportDocument, baseOptions);
    }
      export function useBoardExportLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BoardExportQuery, BoardExportQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<BoardExportQuery, BoardExportQueryVariables>(BoardExportDocument, baseOptions);
      }
      
export type BoardExportQueryHookResult = ReturnType<typeof useBoardExportQuery>;
export type BoardExportQueryResult = ApolloReactCommon.QueryResult<BoardExportQuery, BoardExportQueryVariables>;
export const StartBoardExportDocument: DocumentNode = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"StartBoardExport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startBoardExport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"},"arguments":[]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"status"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attempts"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"finished"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"stage"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"size"},"arguments":[],"directives":[]}]}}]}}]};
export type StartBoardExportMutationFn = ApolloReactCommon.MutationFunction<StartBoardExportMutation, StartBoardExportMutationVariables>;

    export function useStartBoardExportMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<StartBoardExportMutation, StartBoardExportMutationVariables>) {
      return ApolloReactHooks.useMutation<StartBoardExportMutation, StartBoardExportMutationVariables>(StartBoardExportDocument, baseOptions);
    }
export type StartBoardExportMutationHookResult = ReturnType<typeof useStartBoardExportMutation>;
export type StartBoardExportMutationResult = ApolloReactCommon.MutationResult<StartBoardExportMutation>;
export type StartBoardExportMutationOptions = ApolloReactCommon.BaseMutationOptions<StartBoardExportMutation, StartBoardExportMutationVariables>;
export const MemberChangeAvatarPopoverDocument: DocumentNode = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MemberChangeAvatarPopover"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"member"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"},"arguments":[]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"avatarSource"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"gravatarHash"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"initials"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"uploadedAvatarHash"},"arguments":[],"directives":[]}]}}]}}]};

    export function useMemberChangeAvatarPopoverQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<MemberChangeAvatarPopoverQuery, MemberChangeAvatarPopoverQueryVariables>) {
      return ApolloReactHooks.useQuery<MemberChangeAvatarPopoverQuery, MemberChangeAvatarPopoverQueryVariables>(MemberChangeAvatarPopoverDocument, baseOptions);
    }
      export function useMemberChangeAvatarPopoverLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MemberChangeAvatarPopoverQuery, MemberChangeAvatarPopoverQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<MemberChangeAvatarPopoverQuery, MemberChangeAvatarPopoverQueryVariables>(MemberChangeAvatarPopoverDocument, baseOptions);
      }
      
export type MemberChangeAvatarPopoverQueryHookResult = ReturnType<typeof useMemberChangeAvatarPopoverQuery>;
export type MemberChangeAvatarPopoverQueryResult = ApolloReactCommon.QueryResult<MemberChangeAvatarPopoverQuery, MemberChangeAvatarPopoverQueryVariables>;
export const UpdateMemberAvatarSourceDocument: DocumentNode = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateMemberAvatarSource"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"avatarSource"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Member_AvatarSource"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateMemberAvatarSource"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"avatarSource"},"value":{"kind":"Variable","name":{"kind":"Name","value":"avatarSource"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"},"arguments":[]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"avatarSource"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"initials"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"uploadedAvatarHash"},"arguments":[],"directives":[]}]}}]}}]};
export type UpdateMemberAvatarSourceMutationFn = ApolloReactCommon.MutationFunction<UpdateMemberAvatarSourceMutation, UpdateMemberAvatarSourceMutationVariables>;

    export function useUpdateMemberAvatarSourceMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateMemberAvatarSourceMutation, UpdateMemberAvatarSourceMutationVariables>) {
      return ApolloReactHooks.useMutation<UpdateMemberAvatarSourceMutation, UpdateMemberAvatarSourceMutationVariables>(UpdateMemberAvatarSourceDocument, baseOptions);
    }
export type UpdateMemberAvatarSourceMutationHookResult = ReturnType<typeof useUpdateMemberAvatarSourceMutation>;
export type UpdateMemberAvatarSourceMutationResult = ApolloReactCommon.MutationResult<UpdateMemberAvatarSourceMutation>;
export type UpdateMemberAvatarSourceMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateMemberAvatarSourceMutation, UpdateMemberAvatarSourceMutationVariables>;
export const UploadMemberAvatarDocument: DocumentNode = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UploadMemberAvatar"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"file"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FileUpload"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"uploadProgressCallback"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FileUploadProgressCallback"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uploadMemberAvatar"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"file"},"value":{"kind":"Variable","name":{"kind":"Name","value":"file"}}},{"kind":"Argument","name":{"kind":"Name","value":"uploadProgressCallback"},"value":{"kind":"Variable","name":{"kind":"Name","value":"uploadProgressCallback"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"},"arguments":[]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"avatarSource"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"initials"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"uploadedAvatarHash"},"arguments":[],"directives":[]}]}}]}}]};
export type UploadMemberAvatarMutationFn = ApolloReactCommon.MutationFunction<UploadMemberAvatarMutation, UploadMemberAvatarMutationVariables>;

    export function useUploadMemberAvatarMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UploadMemberAvatarMutation, UploadMemberAvatarMutationVariables>) {
      return ApolloReactHooks.useMutation<UploadMemberAvatarMutation, UploadMemberAvatarMutationVariables>(UploadMemberAvatarDocument, baseOptions);
    }
export type UploadMemberAvatarMutationHookResult = ReturnType<typeof useUploadMemberAvatarMutation>;
export type UploadMemberAvatarMutationResult = ApolloReactCommon.MutationResult<UploadMemberAvatarMutation>;
export type UploadMemberAvatarMutationOptions = ApolloReactCommon.BaseMutationOptions<UploadMemberAvatarMutation, UploadMemberAvatarMutationVariables>;
export const AcceptDeveloperTermsDocument: DocumentNode = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AcceptDeveloperTerms"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"acceptDeveloperTerms"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"memberId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"},"arguments":[]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"agreementType"},"arguments":[],"directives":[]}]}}]}}]};
export type AcceptDeveloperTermsMutationFn = ApolloReactCommon.MutationFunction<AcceptDeveloperTermsMutation, AcceptDeveloperTermsMutationVariables>;

    export function useAcceptDeveloperTermsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AcceptDeveloperTermsMutation, AcceptDeveloperTermsMutationVariables>) {
      return ApolloReactHooks.useMutation<AcceptDeveloperTermsMutation, AcceptDeveloperTermsMutationVariables>(AcceptDeveloperTermsDocument, baseOptions);
    }
export type AcceptDeveloperTermsMutationHookResult = ReturnType<typeof useAcceptDeveloperTermsMutation>;
export type AcceptDeveloperTermsMutationResult = ApolloReactCommon.MutationResult<AcceptDeveloperTermsMutation>;
export type AcceptDeveloperTermsMutationOptions = ApolloReactCommon.BaseMutationOptions<AcceptDeveloperTermsMutation, AcceptDeveloperTermsMutationVariables>;
export const AppManagementDocument: DocumentNode = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AppManagement"},"variableDefinitions":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"member"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"StringValue","value":"me","block":false}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"},"arguments":[]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"agreements"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agreementType"},"arguments":[],"directives":[]}]}}]}}]}}]};

    export function useAppManagementQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AppManagementQuery, AppManagementQueryVariables>) {
      return ApolloReactHooks.useQuery<AppManagementQuery, AppManagementQueryVariables>(AppManagementDocument, baseOptions);
    }
      export function useAppManagementLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AppManagementQuery, AppManagementQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<AppManagementQuery, AppManagementQueryVariables>(AppManagementDocument, baseOptions);
      }
      
export type AppManagementQueryHookResult = ReturnType<typeof useAppManagementQuery>;
export type AppManagementQueryResult = ApolloReactCommon.QueryResult<AppManagementQuery, AppManagementQueryVariables>;
export const CreatePluginListingDocument: DocumentNode = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreatePluginListing"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idPlugin"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locale"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"overview"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"description"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createPluginListing"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pluginId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idPlugin"}}},{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locale"}}},{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"Argument","name":{"kind":"Name","value":"overview"},"value":{"kind":"Variable","name":{"kind":"Name","value":"overview"}}},{"kind":"Argument","name":{"kind":"Name","value":"description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"description"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"},"arguments":[]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"locale"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"overview"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]}]}}]}}]};
export type CreatePluginListingMutationFn = ApolloReactCommon.MutationFunction<CreatePluginListingMutation, CreatePluginListingMutationVariables>;

    export function useCreatePluginListingMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreatePluginListingMutation, CreatePluginListingMutationVariables>) {
      return ApolloReactHooks.useMutation<CreatePluginListingMutation, CreatePluginListingMutationVariables>(CreatePluginListingDocument, baseOptions);
    }
export type CreatePluginListingMutationHookResult = ReturnType<typeof useCreatePluginListingMutation>;
export type CreatePluginListingMutationResult = ApolloReactCommon.MutationResult<CreatePluginListingMutation>;
export type CreatePluginListingMutationOptions = ApolloReactCommon.BaseMutationOptions<CreatePluginListingMutation, CreatePluginListingMutationVariables>;
export const CreatePluginDocument: DocumentNode = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreatePlugin"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"agreementId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"listings"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"InputPluginListing"}}}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"iframeConnectorUrl"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createPlugin"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"agreementId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"agreementId"}}},{"kind":"Argument","name":{"kind":"Name","value":"listings"},"value":{"kind":"Variable","name":{"kind":"Name","value":"listings"}}},{"kind":"Argument","name":{"kind":"Name","value":"iframeConnectorUrl"},"value":{"kind":"Variable","name":{"kind":"Name","value":"iframeConnectorUrl"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"},"arguments":[]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]}]}}]}}]};
export type CreatePluginMutationFn = ApolloReactCommon.MutationFunction<CreatePluginMutation, CreatePluginMutationVariables>;

    export function useCreatePluginMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreatePluginMutation, CreatePluginMutationVariables>) {
      return ApolloReactHooks.useMutation<CreatePluginMutation, CreatePluginMutationVariables>(CreatePluginDocument, baseOptions);
    }
export type CreatePluginMutationHookResult = ReturnType<typeof useCreatePluginMutation>;
export type CreatePluginMutationResult = ApolloReactCommon.MutationResult<CreatePluginMutation>;
export type CreatePluginMutationOptions = ApolloReactCommon.BaseMutationOptions<CreatePluginMutation, CreatePluginMutationVariables>;
export const CreatePluginTeamsDocument: DocumentNode = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CreatePluginTeams"},"variableDefinitions":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"member"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"StringValue","value":"me","block":false}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"},"arguments":[]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"agreements"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"agreementType"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"organizations"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"displayName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"memberships"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idMember"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"memberType"},"arguments":[],"directives":[]}]}}]}}]}}]}}]};

    export function useCreatePluginTeamsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CreatePluginTeamsQuery, CreatePluginTeamsQueryVariables>) {
      return ApolloReactHooks.useQuery<CreatePluginTeamsQuery, CreatePluginTeamsQueryVariables>(CreatePluginTeamsDocument, baseOptions);
    }
      export function useCreatePluginTeamsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CreatePluginTeamsQuery, CreatePluginTeamsQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<CreatePluginTeamsQuery, CreatePluginTeamsQueryVariables>(CreatePluginTeamsDocument, baseOptions);
      }
      
export type CreatePluginTeamsQueryHookResult = ReturnType<typeof useCreatePluginTeamsQuery>;
export type CreatePluginTeamsQueryResult = ApolloReactCommon.QueryResult<CreatePluginTeamsQuery, CreatePluginTeamsQueryVariables>;
export const DeletePluginDocument: DocumentNode = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeletePlugin"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idPlugin"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deletePlugin"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pluginId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idPlugin"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"},"arguments":[]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"},"arguments":[],"directives":[]}]}}]}}]};
export type DeletePluginMutationFn = ApolloReactCommon.MutationFunction<DeletePluginMutation, DeletePluginMutationVariables>;

    export function useDeletePluginMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeletePluginMutation, DeletePluginMutationVariables>) {
      return ApolloReactHooks.useMutation<DeletePluginMutation, DeletePluginMutationVariables>(DeletePluginDocument, baseOptions);
    }
export type DeletePluginMutationHookResult = ReturnType<typeof useDeletePluginMutation>;
export type DeletePluginMutationResult = ApolloReactCommon.MutationResult<DeletePluginMutation>;
export type DeletePluginMutationOptions = ApolloReactCommon.BaseMutationOptions<DeletePluginMutation, DeletePluginMutationVariables>;
export const PluginBasicInformationDocument: DocumentNode = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PluginBasicInformation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idPlugin"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"plugin"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idPlugin"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"},"arguments":[]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"iframeConnectorUrl"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"icon"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"author"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"supportEmail"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"email"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"categories"},"arguments":[],"directives":[]}]}}]}}]};

    export function usePluginBasicInformationQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<PluginBasicInformationQuery, PluginBasicInformationQueryVariables>) {
      return ApolloReactHooks.useQuery<PluginBasicInformationQuery, PluginBasicInformationQueryVariables>(PluginBasicInformationDocument, baseOptions);
    }
      export function usePluginBasicInformationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PluginBasicInformationQuery, PluginBasicInformationQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<PluginBasicInformationQuery, PluginBasicInformationQueryVariables>(PluginBasicInformationDocument, baseOptions);
      }
      
export type PluginBasicInformationQueryHookResult = ReturnType<typeof usePluginBasicInformationQuery>;
export type PluginBasicInformationQueryResult = ApolloReactCommon.QueryResult<PluginBasicInformationQuery, PluginBasicInformationQueryVariables>;
export const PluginCapabilitiesDocument: DocumentNode = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PluginCapabilities"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idPlugin"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"plugin"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idPlugin"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"},"arguments":[]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"capabilities"},"arguments":[],"directives":[]}]}}]}}]};

    export function usePluginCapabilitiesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<PluginCapabilitiesQuery, PluginCapabilitiesQueryVariables>) {
      return ApolloReactHooks.useQuery<PluginCapabilitiesQuery, PluginCapabilitiesQueryVariables>(PluginCapabilitiesDocument, baseOptions);
    }
      export function usePluginCapabilitiesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PluginCapabilitiesQuery, PluginCapabilitiesQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<PluginCapabilitiesQuery, PluginCapabilitiesQueryVariables>(PluginCapabilitiesDocument, baseOptions);
      }
      
export type PluginCapabilitiesQueryHookResult = ReturnType<typeof usePluginCapabilitiesQuery>;
export type PluginCapabilitiesQueryResult = ApolloReactCommon.QueryResult<PluginCapabilitiesQuery, PluginCapabilitiesQueryVariables>;
export const PluginDeleteDocument: DocumentNode = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PluginDelete"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idPlugin"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"plugin"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idPlugin"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"},"arguments":[]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"public"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"usageBrackets"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"boards"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"listings"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locale"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]}]}}]}}]}}]};

    export function usePluginDeleteQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<PluginDeleteQuery, PluginDeleteQueryVariables>) {
      return ApolloReactHooks.useQuery<PluginDeleteQuery, PluginDeleteQueryVariables>(PluginDeleteDocument, baseOptions);
    }
      export function usePluginDeleteLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PluginDeleteQuery, PluginDeleteQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<PluginDeleteQuery, PluginDeleteQueryVariables>(PluginDeleteDocument, baseOptions);
      }
      
export type PluginDeleteQueryHookResult = ReturnType<typeof usePluginDeleteQuery>;
export type PluginDeleteQueryResult = ApolloReactCommon.QueryResult<PluginDeleteQuery, PluginDeleteQueryVariables>;
export const PluginListingsDocument: DocumentNode = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PluginListings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idPlugin"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"plugin"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idPlugin"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"},"arguments":[]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"listings"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"locale"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"overview"},"arguments":[],"directives":[]}]}}]}}]}}]};

    export function usePluginListingsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<PluginListingsQuery, PluginListingsQueryVariables>) {
      return ApolloReactHooks.useQuery<PluginListingsQuery, PluginListingsQueryVariables>(PluginListingsDocument, baseOptions);
    }
      export function usePluginListingsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PluginListingsQuery, PluginListingsQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<PluginListingsQuery, PluginListingsQueryVariables>(PluginListingsDocument, baseOptions);
      }
      
export type PluginListingsQueryHookResult = ReturnType<typeof usePluginListingsQuery>;
export type PluginListingsQueryResult = ApolloReactCommon.QueryResult<PluginListingsQuery, PluginListingsQueryVariables>;
export const PluginManagementCategoriesDocument: DocumentNode = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PluginManagementCategories"},"variableDefinitions":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pluginCategories"},"arguments":[],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"},"arguments":[]}]}]}}]};

    export function usePluginManagementCategoriesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<PluginManagementCategoriesQuery, PluginManagementCategoriesQueryVariables>) {
      return ApolloReactHooks.useQuery<PluginManagementCategoriesQuery, PluginManagementCategoriesQueryVariables>(PluginManagementCategoriesDocument, baseOptions);
    }
      export function usePluginManagementCategoriesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PluginManagementCategoriesQuery, PluginManagementCategoriesQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<PluginManagementCategoriesQuery, PluginManagementCategoriesQueryVariables>(PluginManagementCategoriesDocument, baseOptions);
      }
      
export type PluginManagementCategoriesQueryHookResult = ReturnType<typeof usePluginManagementCategoriesQuery>;
export type PluginManagementCategoriesQueryResult = ApolloReactCommon.QueryResult<PluginManagementCategoriesQuery, PluginManagementCategoriesQueryVariables>;
export const PluginMetricsDocument: DocumentNode = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PluginMetrics"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idPlugin"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"plugin"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idPlugin"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"},"arguments":[]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"listings"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locale"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"stats"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"boardCount"},"arguments":[],"directives":[]}]}}]}}]}}]};

    export function usePluginMetricsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<PluginMetricsQuery, PluginMetricsQueryVariables>) {
      return ApolloReactHooks.useQuery<PluginMetricsQuery, PluginMetricsQueryVariables>(PluginMetricsDocument, baseOptions);
    }
      export function usePluginMetricsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PluginMetricsQuery, PluginMetricsQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<PluginMetricsQuery, PluginMetricsQueryVariables>(PluginMetricsDocument, baseOptions);
      }
      
export type PluginMetricsQueryHookResult = ReturnType<typeof usePluginMetricsQuery>;
export type PluginMetricsQueryResult = ApolloReactCommon.QueryResult<PluginMetricsQuery, PluginMetricsQueryVariables>;
export const PluginPrivacyAndComplianceDocument: DocumentNode = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PluginPrivacyAndCompliance"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idPlugin"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"plugin"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idPlugin"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"},"arguments":[]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"privacyUrl"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"compliance"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"storesPersonalData"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"apiKey"},"arguments":[],"directives":[]}]}}]}}]};

    export function usePluginPrivacyAndComplianceQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<PluginPrivacyAndComplianceQuery, PluginPrivacyAndComplianceQueryVariables>) {
      return ApolloReactHooks.useQuery<PluginPrivacyAndComplianceQuery, PluginPrivacyAndComplianceQueryVariables>(PluginPrivacyAndComplianceDocument, baseOptions);
    }
      export function usePluginPrivacyAndComplianceLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PluginPrivacyAndComplianceQuery, PluginPrivacyAndComplianceQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<PluginPrivacyAndComplianceQuery, PluginPrivacyAndComplianceQueryVariables>(PluginPrivacyAndComplianceDocument, baseOptions);
      }
      
export type PluginPrivacyAndComplianceQueryHookResult = ReturnType<typeof usePluginPrivacyAndComplianceQuery>;
export type PluginPrivacyAndComplianceQueryResult = ApolloReactCommon.QueryResult<PluginPrivacyAndComplianceQuery, PluginPrivacyAndComplianceQueryVariables>;
export const PowerUpPageDocument: DocumentNode = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PowerUpPage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idPlugin"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"plugin"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idPlugin"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"},"arguments":[]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"public"},"arguments":[],"directives":[]}]}}]}}]};

    export function usePowerUpPageQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<PowerUpPageQuery, PowerUpPageQueryVariables>) {
      return ApolloReactHooks.useQuery<PowerUpPageQuery, PowerUpPageQueryVariables>(PowerUpPageDocument, baseOptions);
    }
      export function usePowerUpPageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PowerUpPageQuery, PowerUpPageQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<PowerUpPageQuery, PowerUpPageQueryVariables>(PowerUpPageDocument, baseOptions);
      }
      
export type PowerUpPageQueryHookResult = ReturnType<typeof usePowerUpPageQuery>;
export type PowerUpPageQueryResult = ApolloReactCommon.QueryResult<PowerUpPageQuery, PowerUpPageQueryVariables>;
export const PowerUpsPageDocument: DocumentNode = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PowerUpsPage"},"variableDefinitions":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"member"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"StringValue","value":"me","block":false}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"},"arguments":[]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"organizations"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"displayName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"memberships"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idMember"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"memberType"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"ownedPlugins"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"public"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"icon"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"listings"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"locale"},"arguments":[],"directives":[]}]}}]}}]}}]}}]}}]};

    export function usePowerUpsPageQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<PowerUpsPageQuery, PowerUpsPageQueryVariables>) {
      return ApolloReactHooks.useQuery<PowerUpsPageQuery, PowerUpsPageQueryVariables>(PowerUpsPageDocument, baseOptions);
    }
      export function usePowerUpsPageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PowerUpsPageQuery, PowerUpsPageQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<PowerUpsPageQuery, PowerUpsPageQueryVariables>(PowerUpsPageDocument, baseOptions);
      }
      
export type PowerUpsPageQueryHookResult = ReturnType<typeof usePowerUpsPageQuery>;
export type PowerUpsPageQueryResult = ApolloReactCommon.QueryResult<PowerUpsPageQuery, PowerUpsPageQueryVariables>;
export const UpdatePluginBasicInformationDocument: DocumentNode = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdatePluginBasicInformation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idPlugin"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"author"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"iframeConnectorUrl"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"icon"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"supportEmail"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"categories"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatePlugin"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pluginId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idPlugin"}}},{"kind":"Argument","name":{"kind":"Name","value":"fields"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"author"},"value":{"kind":"Variable","name":{"kind":"Name","value":"author"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"iframeConnectorUrl"},"value":{"kind":"Variable","name":{"kind":"Name","value":"iframeConnectorUrl"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"icon"},"value":{"kind":"Variable","name":{"kind":"Name","value":"icon"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"supportEmail"},"value":{"kind":"Variable","name":{"kind":"Name","value":"supportEmail"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"categories"},"value":{"kind":"Variable","name":{"kind":"Name","value":"categories"}}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"},"arguments":[]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"iframeConnectorUrl"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"icon"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"author"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"supportEmail"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"email"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"categories"},"arguments":[],"directives":[]}]}}]}}]};
export type UpdatePluginBasicInformationMutationFn = ApolloReactCommon.MutationFunction<UpdatePluginBasicInformationMutation, UpdatePluginBasicInformationMutationVariables>;

    export function useUpdatePluginBasicInformationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdatePluginBasicInformationMutation, UpdatePluginBasicInformationMutationVariables>) {
      return ApolloReactHooks.useMutation<UpdatePluginBasicInformationMutation, UpdatePluginBasicInformationMutationVariables>(UpdatePluginBasicInformationDocument, baseOptions);
    }
export type UpdatePluginBasicInformationMutationHookResult = ReturnType<typeof useUpdatePluginBasicInformationMutation>;
export type UpdatePluginBasicInformationMutationResult = ApolloReactCommon.MutationResult<UpdatePluginBasicInformationMutation>;
export type UpdatePluginBasicInformationMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdatePluginBasicInformationMutation, UpdatePluginBasicInformationMutationVariables>;
export const UpdatePluginCapabilitiesDocument: DocumentNode = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdatePluginCapabilities"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idPlugin"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"capabilities"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatePlugin"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pluginId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idPlugin"}}},{"kind":"Argument","name":{"kind":"Name","value":"fields"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"capabilities"},"value":{"kind":"Variable","name":{"kind":"Name","value":"capabilities"}}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"},"arguments":[]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"capabilities"},"arguments":[],"directives":[]}]}}]}}]};
export type UpdatePluginCapabilitiesMutationFn = ApolloReactCommon.MutationFunction<UpdatePluginCapabilitiesMutation, UpdatePluginCapabilitiesMutationVariables>;

    export function useUpdatePluginCapabilitiesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdatePluginCapabilitiesMutation, UpdatePluginCapabilitiesMutationVariables>) {
      return ApolloReactHooks.useMutation<UpdatePluginCapabilitiesMutation, UpdatePluginCapabilitiesMutationVariables>(UpdatePluginCapabilitiesDocument, baseOptions);
    }
export type UpdatePluginCapabilitiesMutationHookResult = ReturnType<typeof useUpdatePluginCapabilitiesMutation>;
export type UpdatePluginCapabilitiesMutationResult = ApolloReactCommon.MutationResult<UpdatePluginCapabilitiesMutation>;
export type UpdatePluginCapabilitiesMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdatePluginCapabilitiesMutation, UpdatePluginCapabilitiesMutationVariables>;
export const UpdatePluginListingDocument: DocumentNode = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdatePluginListing"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idPlugin"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pluginListingId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locale"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"overview"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"description"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatePluginListing"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pluginId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idPlugin"}}},{"kind":"Argument","name":{"kind":"Name","value":"pluginListingId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pluginListingId"}}},{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locale"}}},{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"Argument","name":{"kind":"Name","value":"overview"},"value":{"kind":"Variable","name":{"kind":"Name","value":"overview"}}},{"kind":"Argument","name":{"kind":"Name","value":"description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"description"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"},"arguments":[]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"locale"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"overview"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]}]}}]}}]};
export type UpdatePluginListingMutationFn = ApolloReactCommon.MutationFunction<UpdatePluginListingMutation, UpdatePluginListingMutationVariables>;

    export function useUpdatePluginListingMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdatePluginListingMutation, UpdatePluginListingMutationVariables>) {
      return ApolloReactHooks.useMutation<UpdatePluginListingMutation, UpdatePluginListingMutationVariables>(UpdatePluginListingDocument, baseOptions);
    }
export type UpdatePluginListingMutationHookResult = ReturnType<typeof useUpdatePluginListingMutation>;
export type UpdatePluginListingMutationResult = ApolloReactCommon.MutationResult<UpdatePluginListingMutation>;
export type UpdatePluginListingMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdatePluginListingMutation, UpdatePluginListingMutationVariables>;
export const UpdatePluginPrivacyAndComplianceDocument: DocumentNode = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdatePluginPrivacyAndCompliance"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idPlugin"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"privacyUrl"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"apiKey"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"storesPersonalData"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatePlugin"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pluginId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idPlugin"}}},{"kind":"Argument","name":{"kind":"Name","value":"fields"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"privacyUrl"},"value":{"kind":"Variable","name":{"kind":"Name","value":"privacyUrl"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"storesPersonalData"},"value":{"kind":"Variable","name":{"kind":"Name","value":"storesPersonalData"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"apiKey"},"value":{"kind":"Variable","name":{"kind":"Name","value":"apiKey"}}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"},"arguments":[]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"privacyUrl"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"compliance"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"storesPersonalData"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"apiKey"},"arguments":[],"directives":[]}]}}]}}]};
export type UpdatePluginPrivacyAndComplianceMutationFn = ApolloReactCommon.MutationFunction<UpdatePluginPrivacyAndComplianceMutation, UpdatePluginPrivacyAndComplianceMutationVariables>;

    export function useUpdatePluginPrivacyAndComplianceMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdatePluginPrivacyAndComplianceMutation, UpdatePluginPrivacyAndComplianceMutationVariables>) {
      return ApolloReactHooks.useMutation<UpdatePluginPrivacyAndComplianceMutation, UpdatePluginPrivacyAndComplianceMutationVariables>(UpdatePluginPrivacyAndComplianceDocument, baseOptions);
    }
export type UpdatePluginPrivacyAndComplianceMutationHookResult = ReturnType<typeof useUpdatePluginPrivacyAndComplianceMutation>;
export type UpdatePluginPrivacyAndComplianceMutationResult = ApolloReactCommon.MutationResult<UpdatePluginPrivacyAndComplianceMutation>;
export type UpdatePluginPrivacyAndComplianceMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdatePluginPrivacyAndComplianceMutation, UpdatePluginPrivacyAndComplianceMutationVariables>;
export const AtlassianAccountOnboardingDocument: DocumentNode = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AtlassianAccountOnboarding"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"member"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"},"arguments":[]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"aaId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"email"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"aaEmail"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"aaEnrolledDate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isAaMastered"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fullName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"enterprises"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"EnumValue","value":"owned"}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"displayName"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"logins"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"primary"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"email"},"arguments":[],"directives":[]}]}}]}}]}}]};

    export function useAtlassianAccountOnboardingQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AtlassianAccountOnboardingQuery, AtlassianAccountOnboardingQueryVariables>) {
      return ApolloReactHooks.useQuery<AtlassianAccountOnboardingQuery, AtlassianAccountOnboardingQueryVariables>(AtlassianAccountOnboardingDocument, baseOptions);
    }
      export function useAtlassianAccountOnboardingLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AtlassianAccountOnboardingQuery, AtlassianAccountOnboardingQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<AtlassianAccountOnboardingQuery, AtlassianAccountOnboardingQueryVariables>(AtlassianAccountOnboardingDocument, baseOptions);
      }
      
export type AtlassianAccountOnboardingQueryHookResult = ReturnType<typeof useAtlassianAccountOnboardingQuery>;
export type AtlassianAccountOnboardingQueryResult = ApolloReactCommon.QueryResult<AtlassianAccountOnboardingQuery, AtlassianAccountOnboardingQueryVariables>;
export const PrepMemberForAtlassianAccountOnboardingDocument: DocumentNode = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"PrepMemberForAtlassianAccountOnboarding"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"aaLoginId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"nonAaLoginIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"prepMemberForAtlassianAccountOnboarding"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"memberId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}}},{"kind":"Argument","name":{"kind":"Name","value":"aaLoginId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"aaLoginId"}}},{"kind":"Argument","name":{"kind":"Name","value":"nonAaLoginIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"nonAaLoginIds"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"},"arguments":[]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"aaId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"email"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"aaEmail"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isAaMastered"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"logins"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"primary"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"email"},"arguments":[],"directives":[]}]}}]}}]}}]};
export type PrepMemberForAtlassianAccountOnboardingMutationFn = ApolloReactCommon.MutationFunction<PrepMemberForAtlassianAccountOnboardingMutation, PrepMemberForAtlassianAccountOnboardingMutationVariables>;

    export function usePrepMemberForAtlassianAccountOnboardingMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<PrepMemberForAtlassianAccountOnboardingMutation, PrepMemberForAtlassianAccountOnboardingMutationVariables>) {
      return ApolloReactHooks.useMutation<PrepMemberForAtlassianAccountOnboardingMutation, PrepMemberForAtlassianAccountOnboardingMutationVariables>(PrepMemberForAtlassianAccountOnboardingDocument, baseOptions);
    }
export type PrepMemberForAtlassianAccountOnboardingMutationHookResult = ReturnType<typeof usePrepMemberForAtlassianAccountOnboardingMutation>;
export type PrepMemberForAtlassianAccountOnboardingMutationResult = ApolloReactCommon.MutationResult<PrepMemberForAtlassianAccountOnboardingMutation>;
export type PrepMemberForAtlassianAccountOnboardingMutationOptions = ApolloReactCommon.BaseMutationOptions<PrepMemberForAtlassianAccountOnboardingMutation, PrepMemberForAtlassianAccountOnboardingMutationVariables>;
export const BoardSelectorDocument: DocumentNode = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BoardSelector"},"variableDefinitions":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"member"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"StringValue","value":"me","block":false}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"},"arguments":[]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"boards"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"EnumValue","value":"open"}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"idOrganization"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"prefs"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"background"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"backgroundColor"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"backgroundImageScaled"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"width"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"height"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"memberships"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idMember"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"memberType"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"organizations"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"displayName"},"arguments":[],"directives":[]}]}}]}}]}}]};

    export function useBoardSelectorQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<BoardSelectorQuery, BoardSelectorQueryVariables>) {
      return ApolloReactHooks.useQuery<BoardSelectorQuery, BoardSelectorQueryVariables>(BoardSelectorDocument, baseOptions);
    }
      export function useBoardSelectorLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BoardSelectorQuery, BoardSelectorQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<BoardSelectorQuery, BoardSelectorQueryVariables>(BoardSelectorDocument, baseOptions);
      }
      
export type BoardSelectorQueryHookResult = ReturnType<typeof useBoardSelectorQuery>;
export type BoardSelectorQueryResult = ApolloReactCommon.QueryResult<BoardSelectorQuery, BoardSelectorQueryVariables>;
export const CardBackBannerDocument: DocumentNode = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CardBackBanner"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idCard"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"card"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idCard"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"},"arguments":[]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"closed"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isTemplate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"list"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"closed"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"cover"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idAttachment"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"color"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"idUploadedBackground"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"stickers"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]}]}}]}}]}}]};

    export function useCardBackBannerQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CardBackBannerQuery, CardBackBannerQueryVariables>) {
      return ApolloReactHooks.useQuery<CardBackBannerQuery, CardBackBannerQueryVariables>(CardBackBannerDocument, baseOptions);
    }
      export function useCardBackBannerLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CardBackBannerQuery, CardBackBannerQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<CardBackBannerQuery, CardBackBannerQueryVariables>(CardBackBannerDocument, baseOptions);
      }
      
export type CardBackBannerQueryHookResult = ReturnType<typeof useCardBackBannerQuery>;
export type CardBackBannerQueryResult = ApolloReactCommon.QueryResult<CardBackBannerQuery, CardBackBannerQueryVariables>;
export const SearchUnsplashDocument: DocumentNode = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SearchUnsplash"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"page"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"perPage"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unsplashPhotos"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}},{"kind":"Argument","name":{"kind":"Name","value":"page"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page"}}},{"kind":"Argument","name":{"kind":"Name","value":"perPage"},"value":{"kind":"Variable","name":{"kind":"Name","value":"perPage"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"},"arguments":[]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"urls"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"thumb"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"raw"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"links"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"download_location"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"links"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"html"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]}]}}]}}]}}]};

    export function useSearchUnsplashQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SearchUnsplashQuery, SearchUnsplashQueryVariables>) {
      return ApolloReactHooks.useQuery<SearchUnsplashQuery, SearchUnsplashQueryVariables>(SearchUnsplashDocument, baseOptions);
    }
      export function useSearchUnsplashLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SearchUnsplashQuery, SearchUnsplashQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<SearchUnsplashQuery, SearchUnsplashQueryVariables>(SearchUnsplashDocument, baseOptions);
      }
      
export type SearchUnsplashQueryHookResult = ReturnType<typeof useSearchUnsplashQuery>;
export type SearchUnsplashQueryResult = ApolloReactCommon.QueryResult<SearchUnsplashQuery, SearchUnsplashQueryVariables>;
export const SelectCoverDocument: DocumentNode = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SelectCover"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cardId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"card"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cardId"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"},"arguments":[]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"cover"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idAttachment"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"idUploadedBackground"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"color"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"edgeColor"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"scaled"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scaled"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"width"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"height"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"idAttachmentCover"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"attachments"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"edgeColor"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"previews"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scaled"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"width"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"height"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[],"directives":[]}]}}]}}]}}]}}]};

    export function useSelectCoverQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SelectCoverQuery, SelectCoverQueryVariables>) {
      return ApolloReactHooks.useQuery<SelectCoverQuery, SelectCoverQueryVariables>(SelectCoverDocument, baseOptions);
    }
      export function useSelectCoverLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SelectCoverQuery, SelectCoverQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<SelectCoverQuery, SelectCoverQueryVariables>(SelectCoverDocument, baseOptions);
      }
      
export type SelectCoverQueryHookResult = ReturnType<typeof useSelectCoverQuery>;
export type SelectCoverQueryResult = ApolloReactCommon.QueryResult<SelectCoverQuery, SelectCoverQueryVariables>;
export const UpdateCardCoverDocument: DocumentNode = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateCardCover"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cardId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cover"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"InputCover"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateCardCover"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"cardId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cardId"}}},{"kind":"Argument","name":{"kind":"Name","value":"cover"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cover"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"},"arguments":[]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"idAttachmentCover"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"cover"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idAttachment"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"idUploadedBackground"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"color"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"scaled"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"width"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"height"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"scaled"},"arguments":[],"directives":[]}]}}]}}]}}]}}]};
export type UpdateCardCoverMutationFn = ApolloReactCommon.MutationFunction<UpdateCardCoverMutation, UpdateCardCoverMutationVariables>;

    export function useUpdateCardCoverMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateCardCoverMutation, UpdateCardCoverMutationVariables>) {
      return ApolloReactHooks.useMutation<UpdateCardCoverMutation, UpdateCardCoverMutationVariables>(UpdateCardCoverDocument, baseOptions);
    }
export type UpdateCardCoverMutationHookResult = ReturnType<typeof useUpdateCardCoverMutation>;
export type UpdateCardCoverMutationResult = ApolloReactCommon.MutationResult<UpdateCardCoverMutation>;
export type UpdateCardCoverMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateCardCoverMutation, UpdateCardCoverMutationVariables>;
export const UploadCoverDocument: DocumentNode = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UploadCover"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cardId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"file"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FileUpload"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uploadCardCover"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"cardId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cardId"}}},{"kind":"Argument","name":{"kind":"Name","value":"file"},"value":{"kind":"Variable","name":{"kind":"Name","value":"file"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"},"arguments":[]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"previews"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[],"directives":[]}]}}]}}]}}]};
export type UploadCoverMutationFn = ApolloReactCommon.MutationFunction<UploadCoverMutation, UploadCoverMutationVariables>;

    export function useUploadCoverMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UploadCoverMutation, UploadCoverMutationVariables>) {
      return ApolloReactHooks.useMutation<UploadCoverMutation, UploadCoverMutationVariables>(UploadCoverDocument, baseOptions);
    }
export type UploadCoverMutationHookResult = ReturnType<typeof useUploadCoverMutation>;
export type UploadCoverMutationResult = ApolloReactCommon.MutationResult<UploadCoverMutation>;
export type UploadCoverMutationOptions = ApolloReactCommon.BaseMutationOptions<UploadCoverMutation, UploadCoverMutationVariables>;
export const CardTemplateDocument: DocumentNode = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CardTemplate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cardId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"card"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cardId"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"},"arguments":[]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"idBoard"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"shortLink"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isTemplate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"closed"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"idList"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"idChecklists"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"attachments"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"stickers"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"idLabels"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"idMembers"},"arguments":[],"directives":[]}]}}]}}]};

    export function useCardTemplateQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CardTemplateQuery, CardTemplateQueryVariables>) {
      return ApolloReactHooks.useQuery<CardTemplateQuery, CardTemplateQueryVariables>(CardTemplateDocument, baseOptions);
    }
      export function useCardTemplateLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CardTemplateQuery, CardTemplateQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<CardTemplateQuery, CardTemplateQueryVariables>(CardTemplateDocument, baseOptions);
      }
      
export type CardTemplateQueryHookResult = ReturnType<typeof useCardTemplateQuery>;
export type CardTemplateQueryResult = ApolloReactCommon.QueryResult<CardTemplateQuery, CardTemplateQueryVariables>;
export const CardTemplatesDocument: DocumentNode = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CardTemplates"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"boardId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"board"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"boardId"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"},"arguments":[]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"members"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"initials"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"cards"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"EnumValue","value":"template"}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"idBoard"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"shortLink"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isTemplate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"closed"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"idList"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"idChecklists"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"attachments"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"stickers"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"top"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"left"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"rotate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"zIndex"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"image"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"imageScaled"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"width"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"height"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"scaled"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"idLabels"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"labels"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"color"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"idBoard"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"idMembers"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"cover"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scaled"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"width"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"height"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"scaled"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"edgeColor"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"badges"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attachments"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"checkItems"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"attachmentsByType"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"trello"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"board"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"card"},"arguments":[],"directives":[]}]}}]}}]}}]}}]}}]}}]};

    export function useCardTemplatesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CardTemplatesQuery, CardTemplatesQueryVariables>) {
      return ApolloReactHooks.useQuery<CardTemplatesQuery, CardTemplatesQueryVariables>(CardTemplatesDocument, baseOptions);
    }
      export function useCardTemplatesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CardTemplatesQuery, CardTemplatesQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<CardTemplatesQuery, CardTemplatesQueryVariables>(CardTemplatesDocument, baseOptions);
      }
      
export type CardTemplatesQueryHookResult = ReturnType<typeof useCardTemplatesQuery>;
export type CardTemplatesQueryResult = ApolloReactCommon.QueryResult<CardTemplatesQuery, CardTemplatesQueryVariables>;
export const CreateCardFromTemplateListsDocument: DocumentNode = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CreateCardFromTemplateLists"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"boardId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"board"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"boardId"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"},"arguments":[]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lists"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"EnumValue","value":"open"}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"closed"},"arguments":[],"directives":[]}]}}]}}]}}]};

    export function useCreateCardFromTemplateListsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CreateCardFromTemplateListsQuery, CreateCardFromTemplateListsQueryVariables>) {
      return ApolloReactHooks.useQuery<CreateCardFromTemplateListsQuery, CreateCardFromTemplateListsQueryVariables>(CreateCardFromTemplateListsDocument, baseOptions);
    }
      export function useCreateCardFromTemplateListsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CreateCardFromTemplateListsQuery, CreateCardFromTemplateListsQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<CreateCardFromTemplateListsQuery, CreateCardFromTemplateListsQueryVariables>(CreateCardFromTemplateListsDocument, baseOptions);
      }
      
export type CreateCardFromTemplateListsQueryHookResult = ReturnType<typeof useCreateCardFromTemplateListsQuery>;
export type CreateCardFromTemplateListsQueryResult = ApolloReactCommon.QueryResult<CreateCardFromTemplateListsQuery, CreateCardFromTemplateListsQueryVariables>;
export const CreateCardFromTemplateDocument: DocumentNode = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateCardFromTemplate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idCardSource"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idList"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"keepFromSource"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"copyCard"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"idCardSource"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idCardSource"}}},{"kind":"Argument","name":{"kind":"Name","value":"idList"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idList"}}},{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"Argument","name":{"kind":"Name","value":"keepFromSource"},"value":{"kind":"Variable","name":{"kind":"Name","value":"keepFromSource"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"},"arguments":[]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"shortLink"},"arguments":[],"directives":[]}]}}]}}]};
export type CreateCardFromTemplateMutationFn = ApolloReactCommon.MutationFunction<CreateCardFromTemplateMutation, CreateCardFromTemplateMutationVariables>;

    export function useCreateCardFromTemplateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateCardFromTemplateMutation, CreateCardFromTemplateMutationVariables>) {
      return ApolloReactHooks.useMutation<CreateCardFromTemplateMutation, CreateCardFromTemplateMutationVariables>(CreateCardFromTemplateDocument, baseOptions);
    }
export type CreateCardFromTemplateMutationHookResult = ReturnType<typeof useCreateCardFromTemplateMutation>;
export type CreateCardFromTemplateMutationResult = ApolloReactCommon.MutationResult<CreateCardFromTemplateMutation>;
export type CreateCardFromTemplateMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateCardFromTemplateMutation, CreateCardFromTemplateMutationVariables>;
export const CreateCardTemplateDocument: DocumentNode = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateCardTemplate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"listId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"closed"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createCardTemplate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"listId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"listId"}}},{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"Argument","name":{"kind":"Name","value":"closed"},"value":{"kind":"Variable","name":{"kind":"Name","value":"closed"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"},"arguments":[]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"idBoard"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"shortLink"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isTemplate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"closed"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"idList"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"idChecklists"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"attachments"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"stickers"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"top"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"left"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"rotate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"zIndex"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"image"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"imageScaled"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"width"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"height"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"scaled"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"idLabels"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"labels"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"color"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"idBoard"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"idMembers"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"cover"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scaled"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"width"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"height"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"scaled"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"edgeColor"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"badges"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attachments"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"checkItems"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"attachmentsByType"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"trello"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"board"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"card"},"arguments":[],"directives":[]}]}}]}}]}}]}}]}}]};
export type CreateCardTemplateMutationFn = ApolloReactCommon.MutationFunction<CreateCardTemplateMutation, CreateCardTemplateMutationVariables>;

    export function useCreateCardTemplateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateCardTemplateMutation, CreateCardTemplateMutationVariables>) {
      return ApolloReactHooks.useMutation<CreateCardTemplateMutation, CreateCardTemplateMutationVariables>(CreateCardTemplateDocument, baseOptions);
    }
export type CreateCardTemplateMutationHookResult = ReturnType<typeof useCreateCardTemplateMutation>;
export type CreateCardTemplateMutationResult = ApolloReactCommon.MutationResult<CreateCardTemplateMutation>;
export type CreateCardTemplateMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateCardTemplateMutation, CreateCardTemplateMutationVariables>;
export const DeleteCardTemplateDocument: DocumentNode = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteCardTemplate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idCard"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteCard"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"idCard"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idCard"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"},"arguments":[]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"},"arguments":[],"directives":[]}]}}]}}]};
export type DeleteCardTemplateMutationFn = ApolloReactCommon.MutationFunction<DeleteCardTemplateMutation, DeleteCardTemplateMutationVariables>;

    export function useDeleteCardTemplateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteCardTemplateMutation, DeleteCardTemplateMutationVariables>) {
      return ApolloReactHooks.useMutation<DeleteCardTemplateMutation, DeleteCardTemplateMutationVariables>(DeleteCardTemplateDocument, baseOptions);
    }
export type DeleteCardTemplateMutationHookResult = ReturnType<typeof useDeleteCardTemplateMutation>;
export type DeleteCardTemplateMutationResult = ApolloReactCommon.MutationResult<DeleteCardTemplateMutation>;
export type DeleteCardTemplateMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteCardTemplateMutation, DeleteCardTemplateMutationVariables>;
export const EmailSniperLinkQueryDocument: DocumentNode = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EmailSniperLinkQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emailProvider"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"},"arguments":[]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[],"directives":[]}]}}]}}]};

    export function useEmailSniperLinkQueryQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<EmailSniperLinkQueryQuery, EmailSniperLinkQueryQueryVariables>) {
      return ApolloReactHooks.useQuery<EmailSniperLinkQueryQuery, EmailSniperLinkQueryQueryVariables>(EmailSniperLinkQueryDocument, baseOptions);
    }
      export function useEmailSniperLinkQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EmailSniperLinkQueryQuery, EmailSniperLinkQueryQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<EmailSniperLinkQueryQuery, EmailSniperLinkQueryQueryVariables>(EmailSniperLinkQueryDocument, baseOptions);
      }
      
export type EmailSniperLinkQueryQueryHookResult = ReturnType<typeof useEmailSniperLinkQueryQuery>;
export type EmailSniperLinkQueryQueryResult = ApolloReactCommon.QueryResult<EmailSniperLinkQueryQuery, EmailSniperLinkQueryQueryVariables>;
export const ClaimOrganizationDocument: DocumentNode = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ClaimOrganization"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idEnterprise"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idOrganization"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"claimOrganization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"idEnterprise"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idEnterprise"}}},{"kind":"Argument","name":{"kind":"Name","value":"idOrganization"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idOrganization"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"},"arguments":[]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]}]}}]}}]};
export type ClaimOrganizationMutationFn = ApolloReactCommon.MutationFunction<ClaimOrganizationMutation, ClaimOrganizationMutationVariables>;

    export function useClaimOrganizationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ClaimOrganizationMutation, ClaimOrganizationMutationVariables>) {
      return ApolloReactHooks.useMutation<ClaimOrganizationMutation, ClaimOrganizationMutationVariables>(ClaimOrganizationDocument, baseOptions);
    }
export type ClaimOrganizationMutationHookResult = ReturnType<typeof useClaimOrganizationMutation>;
export type ClaimOrganizationMutationResult = ApolloReactCommon.MutationResult<ClaimOrganizationMutation>;
export type ClaimOrganizationMutationOptions = ApolloReactCommon.BaseMutationOptions<ClaimOrganizationMutation, ClaimOrganizationMutationVariables>;
export const ClaimableOrganizationAdminsDocument: DocumentNode = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ClaimableOrganizationAdmins"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"members"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"},"arguments":[]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"username"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"avatarSource"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"avatarHash"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"initials"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fullName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"products"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nonPublic"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"initials"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fullName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"avatarHash"},"arguments":[],"directives":[]}]}}]}}]}}]};

    export function useClaimableOrganizationAdminsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ClaimableOrganizationAdminsQuery, ClaimableOrganizationAdminsQueryVariables>) {
      return ApolloReactHooks.useQuery<ClaimableOrganizationAdminsQuery, ClaimableOrganizationAdminsQueryVariables>(ClaimableOrganizationAdminsDocument, baseOptions);
    }
      export function useClaimableOrganizationAdminsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ClaimableOrganizationAdminsQuery, ClaimableOrganizationAdminsQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<ClaimableOrganizationAdminsQuery, ClaimableOrganizationAdminsQueryVariables>(ClaimableOrganizationAdminsDocument, baseOptions);
      }
      
export type ClaimableOrganizationAdminsQueryHookResult = ReturnType<typeof useClaimableOrganizationAdminsQuery>;
export type ClaimableOrganizationAdminsQueryResult = ApolloReactCommon.QueryResult<ClaimableOrganizationAdminsQuery, ClaimableOrganizationAdminsQueryVariables>;
export const ClaimableOrganizationTransferrableDataDocument: DocumentNode = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ClaimableOrganizationTransferrableData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idOrganization"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idEnterprise"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enterprise"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idEnterprise"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"},"arguments":[]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"transferrableData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"idOrganization"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idOrganization"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"transferrable"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"newBillableMembers"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"username"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"initials"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"avatarHash"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"restrictedMembers"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"username"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"initials"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"avatarHash"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"},"arguments":[],"directives":[]}]}}]}}]}}]}}]};

    export function useClaimableOrganizationTransferrableDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ClaimableOrganizationTransferrableDataQuery, ClaimableOrganizationTransferrableDataQueryVariables>) {
      return ApolloReactHooks.useQuery<ClaimableOrganizationTransferrableDataQuery, ClaimableOrganizationTransferrableDataQueryVariables>(ClaimableOrganizationTransferrableDataDocument, baseOptions);
    }
      export function useClaimableOrganizationTransferrableDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ClaimableOrganizationTransferrableDataQuery, ClaimableOrganizationTransferrableDataQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<ClaimableOrganizationTransferrableDataQuery, ClaimableOrganizationTransferrableDataQueryVariables>(ClaimableOrganizationTransferrableDataDocument, baseOptions);
      }
      
export type ClaimableOrganizationTransferrableDataQueryHookResult = ReturnType<typeof useClaimableOrganizationTransferrableDataQuery>;
export type ClaimableOrganizationTransferrableDataQueryResult = ApolloReactCommon.QueryResult<ClaimableOrganizationTransferrableDataQuery, ClaimableOrganizationTransferrableDataQueryVariables>;
export const ClaimableOrganizationsDocument: DocumentNode = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ClaimableOrganizations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enterprise"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"},"arguments":[]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"licenses"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maxMembers"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"totalMembers"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"claimableOrganizations"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organizations"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"products"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"displayName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"idActiveAdmins"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"activeMembershipCount"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"count"},"arguments":[],"directives":[]}]}}]}}]}}]};

    export function useClaimableOrganizationsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ClaimableOrganizationsQuery, ClaimableOrganizationsQueryVariables>) {
      return ApolloReactHooks.useQuery<ClaimableOrganizationsQuery, ClaimableOrganizationsQueryVariables>(ClaimableOrganizationsDocument, baseOptions);
    }
      export function useClaimableOrganizationsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ClaimableOrganizationsQuery, ClaimableOrganizationsQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<ClaimableOrganizationsQuery, ClaimableOrganizationsQueryVariables>(ClaimableOrganizationsDocument, baseOptions);
      }
      
export type ClaimableOrganizationsQueryHookResult = ReturnType<typeof useClaimableOrganizationsQuery>;
export type ClaimableOrganizationsQueryResult = ApolloReactCommon.QueryResult<ClaimableOrganizationsQuery, ClaimableOrganizationsQueryVariables>;
export const DismissBannerDocument: DocumentNode = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DismissBanner"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"messageId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addOneTimeMessagesDismissed"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"memberId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}}},{"kind":"Argument","name":{"kind":"Name","value":"messageId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"messageId"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"},"arguments":[]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"oneTimeMessagesDismissed"},"arguments":[],"directives":[]}]}}]}}]};
export type DismissBannerMutationFn = ApolloReactCommon.MutationFunction<DismissBannerMutation, DismissBannerMutationVariables>;

    export function useDismissBannerMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DismissBannerMutation, DismissBannerMutationVariables>) {
      return ApolloReactHooks.useMutation<DismissBannerMutation, DismissBannerMutationVariables>(DismissBannerDocument, baseOptions);
    }
export type DismissBannerMutationHookResult = ReturnType<typeof useDismissBannerMutation>;
export type DismissBannerMutationResult = ApolloReactCommon.MutationResult<DismissBannerMutation>;
export type DismissBannerMutationOptions = ApolloReactCommon.BaseMutationOptions<DismissBannerMutation, DismissBannerMutationVariables>;
export const FreeTeamLimitDocument: DocumentNode = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FreeTeamLimit"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"member"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"},"arguments":[]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"email"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"oneTimeMessagesDismissed"},"arguments":[],"directives":[]}]}}]}}]};

    export function useFreeTeamLimitQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<FreeTeamLimitQuery, FreeTeamLimitQueryVariables>) {
      return ApolloReactHooks.useQuery<FreeTeamLimitQuery, FreeTeamLimitQueryVariables>(FreeTeamLimitDocument, baseOptions);
    }
      export function useFreeTeamLimitLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FreeTeamLimitQuery, FreeTeamLimitQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<FreeTeamLimitQuery, FreeTeamLimitQueryVariables>(FreeTeamLimitDocument, baseOptions);
      }
      
export type FreeTeamLimitQueryHookResult = ReturnType<typeof useFreeTeamLimitQuery>;
export type FreeTeamLimitQueryResult = ApolloReactCommon.QueryResult<FreeTeamLimitQuery, FreeTeamLimitQueryVariables>;
export const LanguagePickerDocument: DocumentNode = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LanguagePicker"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"member"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"},"arguments":[]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"prefs"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locale"},"arguments":[],"directives":[]}]}}]}}]}}]};

    export function useLanguagePickerQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<LanguagePickerQuery, LanguagePickerQueryVariables>) {
      return ApolloReactHooks.useQuery<LanguagePickerQuery, LanguagePickerQueryVariables>(LanguagePickerDocument, baseOptions);
    }
      export function useLanguagePickerLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<LanguagePickerQuery, LanguagePickerQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<LanguagePickerQuery, LanguagePickerQueryVariables>(LanguagePickerDocument, baseOptions);
      }
      
export type LanguagePickerQueryHookResult = ReturnType<typeof useLanguagePickerQuery>;
export type LanguagePickerQueryResult = ApolloReactCommon.QueryResult<LanguagePickerQuery, LanguagePickerQueryVariables>;
export const UpdateUserLocaleDocument: DocumentNode = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateUserLocale"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locale"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateUserLocale"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"memberId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}}},{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locale"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"},"arguments":[]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"prefs"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locale"},"arguments":[],"directives":[]}]}}]}}]}}]};
export type UpdateUserLocaleMutationFn = ApolloReactCommon.MutationFunction<UpdateUserLocaleMutation, UpdateUserLocaleMutationVariables>;

    export function useUpdateUserLocaleMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateUserLocaleMutation, UpdateUserLocaleMutationVariables>) {
      return ApolloReactHooks.useMutation<UpdateUserLocaleMutation, UpdateUserLocaleMutationVariables>(UpdateUserLocaleDocument, baseOptions);
    }
export type UpdateUserLocaleMutationHookResult = ReturnType<typeof useUpdateUserLocaleMutation>;
export type UpdateUserLocaleMutationResult = ApolloReactCommon.MutationResult<UpdateUserLocaleMutation>;
export type UpdateUserLocaleMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateUserLocaleMutation, UpdateUserLocaleMutationVariables>;
export const MemberAvatarDocument: DocumentNode = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MemberAvatar"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"member"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"},"arguments":[]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"username"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"avatarSource"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"avatarHash"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"initials"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fullName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"products"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nonPublic"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"initials"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fullName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"avatarHash"},"arguments":[],"directives":[]}]}}]}}]}}]};

    export function useMemberAvatarQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<MemberAvatarQuery, MemberAvatarQueryVariables>) {
      return ApolloReactHooks.useQuery<MemberAvatarQuery, MemberAvatarQueryVariables>(MemberAvatarDocument, baseOptions);
    }
      export function useMemberAvatarLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MemberAvatarQuery, MemberAvatarQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<MemberAvatarQuery, MemberAvatarQueryVariables>(MemberAvatarDocument, baseOptions);
      }
      
export type MemberAvatarQueryHookResult = ReturnType<typeof useMemberAvatarQuery>;
export type MemberAvatarQueryResult = ApolloReactCommon.QueryResult<MemberAvatarQuery, MemberAvatarQueryVariables>;
export const MemberBillingViewDocument: DocumentNode = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MemberBillingView"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"member"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"},"arguments":[]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"products"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"paidAccount"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"standing"},"arguments":[],"directives":[]}]}}]}}]}}]};

    export function useMemberBillingViewQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<MemberBillingViewQuery, MemberBillingViewQueryVariables>) {
      return ApolloReactHooks.useQuery<MemberBillingViewQuery, MemberBillingViewQueryVariables>(MemberBillingViewDocument, baseOptions);
    }
      export function useMemberBillingViewLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MemberBillingViewQuery, MemberBillingViewQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<MemberBillingViewQuery, MemberBillingViewQueryVariables>(MemberBillingViewDocument, baseOptions);
      }
      
export type MemberBillingViewQueryHookResult = ReturnType<typeof useMemberBillingViewQuery>;
export type MemberBillingViewQueryResult = ApolloReactCommon.QueryResult<MemberBillingViewQuery, MemberBillingViewQueryVariables>;
export const MoonshotBillingDocument: DocumentNode = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MoonshotBilling"},"variableDefinitions":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"member"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"StringValue","value":"me","block":false}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"},"arguments":[]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"confirmed"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"email"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"organizations"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"activeBillableMemberCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"billableCollaboratorCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"billableMemberCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"displayName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"logoHash"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"memberships"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idMember"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"unconfirmed"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"paidAccount"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"billingDates"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"contactFullName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"contactEmail"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"contactLocale"},"arguments":[],"directives":[]}]}}]}}]}}]}}]};

    export function useMoonshotBillingQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<MoonshotBillingQuery, MoonshotBillingQueryVariables>) {
      return ApolloReactHooks.useQuery<MoonshotBillingQuery, MoonshotBillingQueryVariables>(MoonshotBillingDocument, baseOptions);
    }
      export function useMoonshotBillingLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MoonshotBillingQuery, MoonshotBillingQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<MoonshotBillingQuery, MoonshotBillingQueryVariables>(MoonshotBillingDocument, baseOptions);
      }
      
export type MoonshotBillingQueryHookResult = ReturnType<typeof useMoonshotBillingQuery>;
export type MoonshotBillingQueryResult = ApolloReactCommon.QueryResult<MoonshotBillingQuery, MoonshotBillingQueryVariables>;
export const MoonshotUpdateCampaignDocument: DocumentNode = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MoonshotUpdateCampaign"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"currentStep"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dateDismissed"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isDismissed"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateCampaign"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"campaignId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"currentStep"},"value":{"kind":"Variable","name":{"kind":"Name","value":"currentStep"}}},{"kind":"Argument","name":{"kind":"Name","value":"dateDismissed"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dateDismissed"}}},{"kind":"Argument","name":{"kind":"Name","value":"isDismissed"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isDismissed"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"},"arguments":[]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"dateDismissed"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"currentStep"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]}]}}]}}]};
export type MoonshotUpdateCampaignMutationFn = ApolloReactCommon.MutationFunction<MoonshotUpdateCampaignMutation, MoonshotUpdateCampaignMutationVariables>;

    export function useMoonshotUpdateCampaignMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<MoonshotUpdateCampaignMutation, MoonshotUpdateCampaignMutationVariables>) {
      return ApolloReactHooks.useMutation<MoonshotUpdateCampaignMutation, MoonshotUpdateCampaignMutationVariables>(MoonshotUpdateCampaignDocument, baseOptions);
    }
export type MoonshotUpdateCampaignMutationHookResult = ReturnType<typeof useMoonshotUpdateCampaignMutation>;
export type MoonshotUpdateCampaignMutationResult = ApolloReactCommon.MutationResult<MoonshotUpdateCampaignMutation>;
export type MoonshotUpdateCampaignMutationOptions = ApolloReactCommon.BaseMutationOptions<MoonshotUpdateCampaignMutation, MoonshotUpdateCampaignMutationVariables>;
export const MoonshotCampaignDocument: DocumentNode = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MoonshotCampaign"},"variableDefinitions":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"member"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"StringValue","value":"me","block":false}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"},"arguments":[]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idOrganizations"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"organizations"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"campaigns"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"currentStep"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"dateDismissed"},"arguments":[],"directives":[]}]}}]}}]}}]};

    export function useMoonshotCampaignQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<MoonshotCampaignQuery, MoonshotCampaignQueryVariables>) {
      return ApolloReactHooks.useQuery<MoonshotCampaignQuery, MoonshotCampaignQueryVariables>(MoonshotCampaignDocument, baseOptions);
    }
      export function useMoonshotCampaignLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MoonshotCampaignQuery, MoonshotCampaignQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<MoonshotCampaignQuery, MoonshotCampaignQueryVariables>(MoonshotCampaignDocument, baseOptions);
      }
      
export type MoonshotCampaignQueryHookResult = ReturnType<typeof useMoonshotCampaignQuery>;
export type MoonshotCampaignQueryResult = ApolloReactCommon.QueryResult<MoonshotCampaignQuery, MoonshotCampaignQueryVariables>;
export const MoonshotCopyBoardDocument: DocumentNode = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MoonshotCopyBoard"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"boardId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"copyBoardToOrg"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"boardId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"boardId"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"},"arguments":[]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]}]}}]}}]};
export type MoonshotCopyBoardMutationFn = ApolloReactCommon.MutationFunction<MoonshotCopyBoardMutation, MoonshotCopyBoardMutationVariables>;

    export function useMoonshotCopyBoardMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<MoonshotCopyBoardMutation, MoonshotCopyBoardMutationVariables>) {
      return ApolloReactHooks.useMutation<MoonshotCopyBoardMutation, MoonshotCopyBoardMutationVariables>(MoonshotCopyBoardDocument, baseOptions);
    }
export type MoonshotCopyBoardMutationHookResult = ReturnType<typeof useMoonshotCopyBoardMutation>;
export type MoonshotCopyBoardMutationResult = ApolloReactCommon.MutationResult<MoonshotCopyBoardMutation>;
export type MoonshotCopyBoardMutationOptions = ApolloReactCommon.BaseMutationOptions<MoonshotCopyBoardMutation, MoonshotCopyBoardMutationVariables>;
export const MoonshotCreateTeamSubmitDocument: DocumentNode = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MoonshotCreateTeamSubmit"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"displayName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"type"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"desc"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"enterprise"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"allAdminsEnabled"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createOrganization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"displayName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"displayName"}}},{"kind":"Argument","name":{"kind":"Name","value":"type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"type"}}},{"kind":"Argument","name":{"kind":"Name","value":"desc"},"value":{"kind":"Variable","name":{"kind":"Name","value":"desc"}}},{"kind":"Argument","name":{"kind":"Name","value":"enterprise"},"value":{"kind":"Variable","name":{"kind":"Name","value":"enterprise"}}},{"kind":"Argument","name":{"kind":"Name","value":"allAdminsEnabled"},"value":{"kind":"Variable","name":{"kind":"Name","value":"allAdminsEnabled"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"},"arguments":[]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]}]}}]}}]};
export type MoonshotCreateTeamSubmitMutationFn = ApolloReactCommon.MutationFunction<MoonshotCreateTeamSubmitMutation, MoonshotCreateTeamSubmitMutationVariables>;

    export function useMoonshotCreateTeamSubmitMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<MoonshotCreateTeamSubmitMutation, MoonshotCreateTeamSubmitMutationVariables>) {
      return ApolloReactHooks.useMutation<MoonshotCreateTeamSubmitMutation, MoonshotCreateTeamSubmitMutationVariables>(MoonshotCreateTeamSubmitDocument, baseOptions);
    }
export type MoonshotCreateTeamSubmitMutationHookResult = ReturnType<typeof useMoonshotCreateTeamSubmitMutation>;
export type MoonshotCreateTeamSubmitMutationResult = ApolloReactCommon.MutationResult<MoonshotCreateTeamSubmitMutation>;
export type MoonshotCreateTeamSubmitMutationOptions = ApolloReactCommon.BaseMutationOptions<MoonshotCreateTeamSubmitMutation, MoonshotCreateTeamSubmitMutationVariables>;
export const MoonshotCreateTeamDocument: DocumentNode = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MoonshotCreateTeam"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"member"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"},"arguments":[]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"},"arguments":[],"directives":[]}]}}]}}]};

    export function useMoonshotCreateTeamQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<MoonshotCreateTeamQuery, MoonshotCreateTeamQueryVariables>) {
      return ApolloReactHooks.useQuery<MoonshotCreateTeamQuery, MoonshotCreateTeamQueryVariables>(MoonshotCreateTeamDocument, baseOptions);
    }
      export function useMoonshotCreateTeamLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MoonshotCreateTeamQuery, MoonshotCreateTeamQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<MoonshotCreateTeamQuery, MoonshotCreateTeamQueryVariables>(MoonshotCreateTeamDocument, baseOptions);
      }
      
export type MoonshotCreateTeamQueryHookResult = ReturnType<typeof useMoonshotCreateTeamQuery>;
export type MoonshotCreateTeamQueryResult = ApolloReactCommon.QueryResult<MoonshotCreateTeamQuery, MoonshotCreateTeamQueryVariables>;
export const MoonshotEmailVerificationAddEmailDocument: DocumentNode = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MoonshotEmailVerificationAddEmail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addMemberEmail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"},"arguments":[]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"},"arguments":[],"directives":[]}]}}]}}]};
export type MoonshotEmailVerificationAddEmailMutationFn = ApolloReactCommon.MutationFunction<MoonshotEmailVerificationAddEmailMutation, MoonshotEmailVerificationAddEmailMutationVariables>;

    export function useMoonshotEmailVerificationAddEmailMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<MoonshotEmailVerificationAddEmailMutation, MoonshotEmailVerificationAddEmailMutationVariables>) {
      return ApolloReactHooks.useMutation<MoonshotEmailVerificationAddEmailMutation, MoonshotEmailVerificationAddEmailMutationVariables>(MoonshotEmailVerificationAddEmailDocument, baseOptions);
    }
export type MoonshotEmailVerificationAddEmailMutationHookResult = ReturnType<typeof useMoonshotEmailVerificationAddEmailMutation>;
export type MoonshotEmailVerificationAddEmailMutationResult = ApolloReactCommon.MutationResult<MoonshotEmailVerificationAddEmailMutation>;
export type MoonshotEmailVerificationAddEmailMutationOptions = ApolloReactCommon.BaseMutationOptions<MoonshotEmailVerificationAddEmailMutation, MoonshotEmailVerificationAddEmailMutationVariables>;
export const MoonshotEmailVerificationResendEmailDocument: DocumentNode = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MoonshotEmailVerificationResendEmail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resendVerificationEmail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"},"arguments":[]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"},"arguments":[],"directives":[]}]}}]}}]};
export type MoonshotEmailVerificationResendEmailMutationFn = ApolloReactCommon.MutationFunction<MoonshotEmailVerificationResendEmailMutation, MoonshotEmailVerificationResendEmailMutationVariables>;

    export function useMoonshotEmailVerificationResendEmailMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<MoonshotEmailVerificationResendEmailMutation, MoonshotEmailVerificationResendEmailMutationVariables>) {
      return ApolloReactHooks.useMutation<MoonshotEmailVerificationResendEmailMutation, MoonshotEmailVerificationResendEmailMutationVariables>(MoonshotEmailVerificationResendEmailDocument, baseOptions);
    }
export type MoonshotEmailVerificationResendEmailMutationHookResult = ReturnType<typeof useMoonshotEmailVerificationResendEmailMutation>;
export type MoonshotEmailVerificationResendEmailMutationResult = ApolloReactCommon.MutationResult<MoonshotEmailVerificationResendEmailMutation>;
export type MoonshotEmailVerificationResendEmailMutationOptions = ApolloReactCommon.BaseMutationOptions<MoonshotEmailVerificationResendEmailMutation, MoonshotEmailVerificationResendEmailMutationVariables>;
export const MoonshotInviteTeamMembersDocument: DocumentNode = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MoonshotInviteTeamMembers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"users"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MemberOrEmail"}}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"invitationMessage"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addMembersToOrg"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orgId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}}},{"kind":"Argument","name":{"kind":"Name","value":"users"},"value":{"kind":"Variable","name":{"kind":"Name","value":"users"}}},{"kind":"Argument","name":{"kind":"Name","value":"invitationMessage"},"value":{"kind":"Variable","name":{"kind":"Name","value":"invitationMessage"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"},"arguments":[]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"error"},"arguments":[],"directives":[]}]}}]}}]};
export type MoonshotInviteTeamMembersMutationFn = ApolloReactCommon.MutationFunction<MoonshotInviteTeamMembersMutation, MoonshotInviteTeamMembersMutationVariables>;

    export function useMoonshotInviteTeamMembersMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<MoonshotInviteTeamMembersMutation, MoonshotInviteTeamMembersMutationVariables>) {
      return ApolloReactHooks.useMutation<MoonshotInviteTeamMembersMutation, MoonshotInviteTeamMembersMutationVariables>(MoonshotInviteTeamMembersDocument, baseOptions);
    }
export type MoonshotInviteTeamMembersMutationHookResult = ReturnType<typeof useMoonshotInviteTeamMembersMutation>;
export type MoonshotInviteTeamMembersMutationResult = ApolloReactCommon.MutationResult<MoonshotInviteTeamMembersMutation>;
export type MoonshotInviteTeamMembersMutationOptions = ApolloReactCommon.BaseMutationOptions<MoonshotInviteTeamMembersMutation, MoonshotInviteTeamMembersMutationVariables>;
export const MoonshotInviteTeamMembersGetOrgDocument: DocumentNode = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MoonshotInviteTeamMembersGetOrg"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"},"arguments":[]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"displayName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"logoHash"},"arguments":[],"directives":[]}]}}]}}]};

    export function useMoonshotInviteTeamMembersGetOrgQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<MoonshotInviteTeamMembersGetOrgQuery, MoonshotInviteTeamMembersGetOrgQueryVariables>) {
      return ApolloReactHooks.useQuery<MoonshotInviteTeamMembersGetOrgQuery, MoonshotInviteTeamMembersGetOrgQueryVariables>(MoonshotInviteTeamMembersGetOrgDocument, baseOptions);
    }
      export function useMoonshotInviteTeamMembersGetOrgLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MoonshotInviteTeamMembersGetOrgQuery, MoonshotInviteTeamMembersGetOrgQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<MoonshotInviteTeamMembersGetOrgQuery, MoonshotInviteTeamMembersGetOrgQueryVariables>(MoonshotInviteTeamMembersGetOrgDocument, baseOptions);
      }
      
export type MoonshotInviteTeamMembersGetOrgQueryHookResult = ReturnType<typeof useMoonshotInviteTeamMembersGetOrgQuery>;
export type MoonshotInviteTeamMembersGetOrgQueryResult = ApolloReactCommon.QueryResult<MoonshotInviteTeamMembersGetOrgQuery, MoonshotInviteTeamMembersGetOrgQueryVariables>;
export const MoonshotPopoverDocument: DocumentNode = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MoonshotPopover"},"variableDefinitions":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"member"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"StringValue","value":"me","block":false}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"},"arguments":[]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"boards"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"idOrganization"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"shortLink"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"organizations"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"memberships"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idMember"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"products"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"campaigns"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"dateDismissed"},"arguments":[],"directives":[]}]}}]}}]}}]};

    export function useMoonshotPopoverQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<MoonshotPopoverQuery, MoonshotPopoverQueryVariables>) {
      return ApolloReactHooks.useQuery<MoonshotPopoverQuery, MoonshotPopoverQueryVariables>(MoonshotPopoverDocument, baseOptions);
    }
      export function useMoonshotPopoverLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MoonshotPopoverQuery, MoonshotPopoverQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<MoonshotPopoverQuery, MoonshotPopoverQueryVariables>(MoonshotPopoverDocument, baseOptions);
      }
      
export type MoonshotPopoverQueryHookResult = ReturnType<typeof useMoonshotPopoverQuery>;
export type MoonshotPopoverQueryResult = ApolloReactCommon.QueryResult<MoonshotPopoverQuery, MoonshotPopoverQueryVariables>;
export const MoonshotSuccessDocument: DocumentNode = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MoonshotSuccess"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"member"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"},"arguments":[]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organizations"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"displayName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[],"directives":[]}]}}]}}]}}]};

    export function useMoonshotSuccessQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<MoonshotSuccessQuery, MoonshotSuccessQueryVariables>) {
      return ApolloReactHooks.useQuery<MoonshotSuccessQuery, MoonshotSuccessQueryVariables>(MoonshotSuccessDocument, baseOptions);
    }
      export function useMoonshotSuccessLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MoonshotSuccessQuery, MoonshotSuccessQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<MoonshotSuccessQuery, MoonshotSuccessQueryVariables>(MoonshotSuccessDocument, baseOptions);
      }
      
export type MoonshotSuccessQueryHookResult = ReturnType<typeof useMoonshotSuccessQuery>;
export type MoonshotSuccessQueryResult = ApolloReactCommon.QueryResult<MoonshotSuccessQuery, MoonshotSuccessQueryVariables>;
export const MoveCardPopoverDocument: DocumentNode = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MoveCardPopover"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"boardId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"board"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"boardId"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"},"arguments":[]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lists"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"EnumValue","value":"open"}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"cards"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"EnumValue","value":"visible"}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"idList"},"arguments":[],"directives":[]}]}}]}}]}}]};

    export function useMoveCardPopoverQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<MoveCardPopoverQuery, MoveCardPopoverQueryVariables>) {
      return ApolloReactHooks.useQuery<MoveCardPopoverQuery, MoveCardPopoverQueryVariables>(MoveCardPopoverDocument, baseOptions);
    }
      export function useMoveCardPopoverLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MoveCardPopoverQuery, MoveCardPopoverQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<MoveCardPopoverQuery, MoveCardPopoverQueryVariables>(MoveCardPopoverDocument, baseOptions);
      }
      
export type MoveCardPopoverQueryHookResult = ReturnType<typeof useMoveCardPopoverQuery>;
export type MoveCardPopoverQueryResult = ApolloReactCommon.QueryResult<MoveCardPopoverQuery, MoveCardPopoverQueryVariables>;
export const DeleteOneTimeMessagesDismissedDocument: DocumentNode = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteOneTimeMessagesDismissed"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"message"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteOneTimeMessagesDismissed"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"memberId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}}},{"kind":"Argument","name":{"kind":"Name","value":"message"},"value":{"kind":"Variable","name":{"kind":"Name","value":"message"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"},"arguments":[]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"oneTimeMessagesDismissed"},"arguments":[],"directives":[]}]}}]}}]};
export type DeleteOneTimeMessagesDismissedMutationFn = ApolloReactCommon.MutationFunction<DeleteOneTimeMessagesDismissedMutation, DeleteOneTimeMessagesDismissedMutationVariables>;

    export function useDeleteOneTimeMessagesDismissedMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteOneTimeMessagesDismissedMutation, DeleteOneTimeMessagesDismissedMutationVariables>) {
      return ApolloReactHooks.useMutation<DeleteOneTimeMessagesDismissedMutation, DeleteOneTimeMessagesDismissedMutationVariables>(DeleteOneTimeMessagesDismissedDocument, baseOptions);
    }
export type DeleteOneTimeMessagesDismissedMutationHookResult = ReturnType<typeof useDeleteOneTimeMessagesDismissedMutation>;
export type DeleteOneTimeMessagesDismissedMutationResult = ApolloReactCommon.MutationResult<DeleteOneTimeMessagesDismissedMutation>;
export type DeleteOneTimeMessagesDismissedMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteOneTimeMessagesDismissedMutation, DeleteOneTimeMessagesDismissedMutationVariables>;
export const OneTimeMessagesDismissedDocument: DocumentNode = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OneTimeMessagesDismissed"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"member"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"},"arguments":[]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"oneTimeMessagesDismissed"},"arguments":[],"directives":[]}]}}]}}]};

    export function useOneTimeMessagesDismissedQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<OneTimeMessagesDismissedQuery, OneTimeMessagesDismissedQueryVariables>) {
      return ApolloReactHooks.useQuery<OneTimeMessagesDismissedQuery, OneTimeMessagesDismissedQueryVariables>(OneTimeMessagesDismissedDocument, baseOptions);
    }
      export function useOneTimeMessagesDismissedLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OneTimeMessagesDismissedQuery, OneTimeMessagesDismissedQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<OneTimeMessagesDismissedQuery, OneTimeMessagesDismissedQueryVariables>(OneTimeMessagesDismissedDocument, baseOptions);
      }
      
export type OneTimeMessagesDismissedQueryHookResult = ReturnType<typeof useOneTimeMessagesDismissedQuery>;
export type OneTimeMessagesDismissedQueryResult = ApolloReactCommon.QueryResult<OneTimeMessagesDismissedQuery, OneTimeMessagesDismissedQueryVariables>;
export const EnablePluginDocument: DocumentNode = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"EnablePlugin"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"boardId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pluginId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enablePlugin"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"boardId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"boardId"}}},{"kind":"Argument","name":{"kind":"Name","value":"pluginId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pluginId"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"},"arguments":[]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"error"},"arguments":[],"directives":[]}]}}]}}]};
export type EnablePluginMutationFn = ApolloReactCommon.MutationFunction<EnablePluginMutation, EnablePluginMutationVariables>;

    export function useEnablePluginMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<EnablePluginMutation, EnablePluginMutationVariables>) {
      return ApolloReactHooks.useMutation<EnablePluginMutation, EnablePluginMutationVariables>(EnablePluginDocument, baseOptions);
    }
export type EnablePluginMutationHookResult = ReturnType<typeof useEnablePluginMutation>;
export type EnablePluginMutationResult = ApolloReactCommon.MutationResult<EnablePluginMutation>;
export type EnablePluginMutationOptions = ApolloReactCommon.BaseMutationOptions<EnablePluginMutation, EnablePluginMutationVariables>;
export const PowerUpDirectoryCategoriesDocument: DocumentNode = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PowerUpDirectoryCategories"},"variableDefinitions":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pluginCategories"},"arguments":[],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"},"arguments":[]}]}]}}]};

    export function usePowerUpDirectoryCategoriesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<PowerUpDirectoryCategoriesQuery, PowerUpDirectoryCategoriesQueryVariables>) {
      return ApolloReactHooks.useQuery<PowerUpDirectoryCategoriesQuery, PowerUpDirectoryCategoriesQueryVariables>(PowerUpDirectoryCategoriesDocument, baseOptions);
    }
      export function usePowerUpDirectoryCategoriesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PowerUpDirectoryCategoriesQuery, PowerUpDirectoryCategoriesQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<PowerUpDirectoryCategoriesQuery, PowerUpDirectoryCategoriesQueryVariables>(PowerUpDirectoryCategoriesDocument, baseOptions);
      }
      
export type PowerUpDirectoryCategoriesQueryHookResult = ReturnType<typeof usePowerUpDirectoryCategoriesQuery>;
export type PowerUpDirectoryCategoriesQueryResult = ApolloReactCommon.QueryResult<PowerUpDirectoryCategoriesQuery, PowerUpDirectoryCategoriesQueryVariables>;
export const PublicPluginDocument: DocumentNode = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PublicPlugin"},"variableDefinitions":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicPlugins"},"arguments":[],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"},"arguments":[]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"idOrganizationOwner"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"author"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"categories"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"privacyUrl"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"public"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"moderatedState"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tags"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isCompliantWithPrivacyStandards"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"icon"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"listing"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"overview"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"usageBrackets"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"boards"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"heroImageUrl"},"arguments":[],"directives":[]}]}}]}}]};

    export function usePublicPluginQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<PublicPluginQuery, PublicPluginQueryVariables>) {
      return ApolloReactHooks.useQuery<PublicPluginQuery, PublicPluginQueryVariables>(PublicPluginDocument, baseOptions);
    }
      export function usePublicPluginLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PublicPluginQuery, PublicPluginQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<PublicPluginQuery, PublicPluginQueryVariables>(PublicPluginDocument, baseOptions);
      }
      
export type PublicPluginQueryHookResult = ReturnType<typeof usePublicPluginQuery>;
export type PublicPluginQueryResult = ApolloReactCommon.QueryResult<PublicPluginQuery, PublicPluginQueryVariables>;
export const AnnouncementsDocument: DocumentNode = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Announcements"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"announcements"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"},"arguments":[]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"html"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"locale"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"type"},"arguments":[],"directives":[]}]}}]}}]};

    export function useAnnouncementsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AnnouncementsQuery, AnnouncementsQueryVariables>) {
      return ApolloReactHooks.useQuery<AnnouncementsQuery, AnnouncementsQueryVariables>(AnnouncementsDocument, baseOptions);
    }
      export function useAnnouncementsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AnnouncementsQuery, AnnouncementsQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<AnnouncementsQuery, AnnouncementsQueryVariables>(AnnouncementsDocument, baseOptions);
      }
      
export type AnnouncementsQueryHookResult = ReturnType<typeof useAnnouncementsQuery>;
export type AnnouncementsQueryResult = ApolloReactCommon.QueryResult<AnnouncementsQuery, AnnouncementsQueryVariables>;
export const DismissAnnouncementDocument: DocumentNode = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DismissAnnouncement"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"announcementId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dismissAnnouncement"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"announcementId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"announcementId"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"},"arguments":[]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"},"arguments":[],"directives":[]}]}}]}}]};
export type DismissAnnouncementMutationFn = ApolloReactCommon.MutationFunction<DismissAnnouncementMutation, DismissAnnouncementMutationVariables>;

    export function useDismissAnnouncementMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DismissAnnouncementMutation, DismissAnnouncementMutationVariables>) {
      return ApolloReactHooks.useMutation<DismissAnnouncementMutation, DismissAnnouncementMutationVariables>(DismissAnnouncementDocument, baseOptions);
    }
export type DismissAnnouncementMutationHookResult = ReturnType<typeof useDismissAnnouncementMutation>;
export type DismissAnnouncementMutationResult = ApolloReactCommon.MutationResult<DismissAnnouncementMutation>;
export type DismissAnnouncementMutationOptions = ApolloReactCommon.BaseMutationOptions<DismissAnnouncementMutation, DismissAnnouncementMutationVariables>;
export const TeamBillingViewDocument: DocumentNode = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TeamBillingView"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"member"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"},"arguments":[]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"idPremOrgsAdmin"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"memberType"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"},"arguments":[]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"idEnterprise"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"activeBillableMemberCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"billableCollaboratorCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"billableMemberCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"enterprise"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"idAdmins"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"memberships"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"idMember"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"memberType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"unconfirmed"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"deactivated"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"paidAccount"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"standing"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"billingDates"},"arguments":[],"directives":[]}]}}]}}]}}]};

    export function useTeamBillingViewQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TeamBillingViewQuery, TeamBillingViewQueryVariables>) {
      return ApolloReactHooks.useQuery<TeamBillingViewQuery, TeamBillingViewQueryVariables>(TeamBillingViewDocument, baseOptions);
    }
      export function useTeamBillingViewLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TeamBillingViewQuery, TeamBillingViewQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<TeamBillingViewQuery, TeamBillingViewQueryVariables>(TeamBillingViewDocument, baseOptions);
      }
      
export type TeamBillingViewQueryHookResult = ReturnType<typeof useTeamBillingViewQuery>;
export type TeamBillingViewQueryResult = ApolloReactCommon.QueryResult<TeamBillingViewQuery, TeamBillingViewQueryVariables>;
export const ByCardStatusDocument: DocumentNode = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ByCardStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dueDateSince"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dueDateUntil"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"refreshTime"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idMembers"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idBoards"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idLabels"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"},"arguments":[]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"stats"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cards"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"dueDateSince"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dueDateSince"}}},{"kind":"Argument","name":{"kind":"Name","value":"dueDateUntil"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dueDateUntil"}}},{"kind":"Argument","name":{"kind":"Name","value":"refreshTime"},"value":{"kind":"Variable","name":{"kind":"Name","value":"refreshTime"}}},{"kind":"Argument","name":{"kind":"Name","value":"idMembers"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idMembers"}}},{"kind":"Argument","name":{"kind":"Name","value":"idBoards"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idBoards"}}},{"kind":"Argument","name":{"kind":"Name","value":"idLabels"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idLabels"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"incomplete"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"stats"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"overdue"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ids"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"upcoming"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ids"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"done"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"noDueDate"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"},"arguments":[],"directives":[]}]}}]}}]}}]}}]}}]}}]};

    export function useByCardStatusQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ByCardStatusQuery, ByCardStatusQueryVariables>) {
      return ApolloReactHooks.useQuery<ByCardStatusQuery, ByCardStatusQueryVariables>(ByCardStatusDocument, baseOptions);
    }
      export function useByCardStatusLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ByCardStatusQuery, ByCardStatusQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<ByCardStatusQuery, ByCardStatusQueryVariables>(ByCardStatusDocument, baseOptions);
      }
      
export type ByCardStatusQueryHookResult = ReturnType<typeof useByCardStatusQuery>;
export type ByCardStatusQueryResult = ApolloReactCommon.QueryResult<ByCardStatusQuery, ByCardStatusQueryVariables>;
export const ByMemberDocument: DocumentNode = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ByMember"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"refreshTime"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idMembers"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idBoards"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idLabels"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"},"arguments":[]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stats"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cards"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"groupBy"},"value":{"kind":"EnumValue","value":"member"}},{"kind":"Argument","name":{"kind":"Name","value":"refreshTime"},"value":{"kind":"Variable","name":{"kind":"Name","value":"refreshTime"}}},{"kind":"Argument","name":{"kind":"Name","value":"idMembers"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idMembers"}}},{"kind":"Argument","name":{"kind":"Name","value":"idBoards"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idBoards"}}},{"kind":"Argument","name":{"kind":"Name","value":"idLabels"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idLabels"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"incomplete"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"stats"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idMember"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"overdue"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"upcoming"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"done"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"noDueDate"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"},"arguments":[],"directives":[]}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"members"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fullName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"avatarHash"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"initials"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"username"},"arguments":[],"directives":[]}]}}]}}]}}]};

    export function useByMemberQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ByMemberQuery, ByMemberQueryVariables>) {
      return ApolloReactHooks.useQuery<ByMemberQuery, ByMemberQueryVariables>(ByMemberDocument, baseOptions);
    }
      export function useByMemberLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ByMemberQuery, ByMemberQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<ByMemberQuery, ByMemberQueryVariables>(ByMemberDocument, baseOptions);
      }
      
export type ByMemberQueryHookResult = ReturnType<typeof useByMemberQuery>;
export type ByMemberQueryResult = ApolloReactCommon.QueryResult<ByMemberQuery, ByMemberQueryVariables>;
export const InitialMembersDocument: DocumentNode = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"InitialMembers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"},"arguments":[]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"members"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fullName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"username"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"avatarHash"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"initials"},"arguments":[],"directives":[]}]}}]}}]}}]};

    export function useInitialMembersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<InitialMembersQuery, InitialMembersQueryVariables>) {
      return ApolloReactHooks.useQuery<InitialMembersQuery, InitialMembersQueryVariables>(InitialMembersDocument, baseOptions);
    }
      export function useInitialMembersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<InitialMembersQuery, InitialMembersQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<InitialMembersQuery, InitialMembersQueryVariables>(InitialMembersDocument, baseOptions);
      }
      
export type InitialMembersQueryHookResult = ReturnType<typeof useInitialMembersQuery>;
export type InitialMembersQueryResult = ApolloReactCommon.QueryResult<InitialMembersQuery, InitialMembersQueryVariables>;
export const TeamReportBoardsDocument: DocumentNode = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TeamReportBoards"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startIndex"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"count"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"},"arguments":[]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"boards"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"EnumValue","value":"open"}},{"kind":"Argument","name":{"kind":"Name","value":"startIndex"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startIndex"}}},{"kind":"Argument","name":{"kind":"Name","value":"count"},"value":{"kind":"Variable","name":{"kind":"Name","value":"count"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"prefs"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"backgroundColor"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"backgroundTile"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"backgroundImage"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"backgroundImageScaled"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"width"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"height"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"permissionLevel"},"arguments":[],"directives":[]}]}}]}}]}}]}}]};

    export function useTeamReportBoardsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TeamReportBoardsQuery, TeamReportBoardsQueryVariables>) {
      return ApolloReactHooks.useQuery<TeamReportBoardsQuery, TeamReportBoardsQueryVariables>(TeamReportBoardsDocument, baseOptions);
    }
      export function useTeamReportBoardsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TeamReportBoardsQuery, TeamReportBoardsQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<TeamReportBoardsQuery, TeamReportBoardsQueryVariables>(TeamReportBoardsDocument, baseOptions);
      }
      
export type TeamReportBoardsQueryHookResult = ReturnType<typeof useTeamReportBoardsQuery>;
export type TeamReportBoardsQueryResult = ApolloReactCommon.QueryResult<TeamReportBoardsQuery, TeamReportBoardsQueryVariables>;
export const TeamReportBoardsSearchDocument: DocumentNode = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TeamReportBoardsSearch"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idOrganizations"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"search"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}},{"kind":"Argument","name":{"kind":"Name","value":"idOrganizations"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idOrganizations"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"boards"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"prefs"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"backgroundColor"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"backgroundTile"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"backgroundImage"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"backgroundImageScaled"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"width"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"height"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[],"directives":[]}]}}]}}]}}]}}]}}]};

    export function useTeamReportBoardsSearchQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TeamReportBoardsSearchQuery, TeamReportBoardsSearchQueryVariables>) {
      return ApolloReactHooks.useQuery<TeamReportBoardsSearchQuery, TeamReportBoardsSearchQueryVariables>(TeamReportBoardsSearchDocument, baseOptions);
    }
      export function useTeamReportBoardsSearchLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TeamReportBoardsSearchQuery, TeamReportBoardsSearchQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<TeamReportBoardsSearchQuery, TeamReportBoardsSearchQueryVariables>(TeamReportBoardsSearchDocument, baseOptions);
      }
      
export type TeamReportBoardsSearchQueryHookResult = ReturnType<typeof useTeamReportBoardsSearchQuery>;
export type TeamReportBoardsSearchQueryResult = ApolloReactCommon.QueryResult<TeamReportBoardsSearchQuery, TeamReportBoardsSearchQueryVariables>;
export const TeamReportByLabelDocument: DocumentNode = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TeamReportByLabel"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"refreshTime"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idMembers"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idBoards"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idLabels"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"},"arguments":[]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"stats"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cards"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"groupBy"},"value":{"kind":"EnumValue","value":"labelName"}},{"kind":"Argument","name":{"kind":"Name","value":"refreshTime"},"value":{"kind":"Variable","name":{"kind":"Name","value":"refreshTime"}}},{"kind":"Argument","name":{"kind":"Name","value":"idMembers"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idMembers"}}},{"kind":"Argument","name":{"kind":"Name","value":"idBoards"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idBoards"}}},{"kind":"Argument","name":{"kind":"Name","value":"idLabels"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idLabels"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"incomplete"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"stats"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"labelName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"overdue"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"upcoming"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"done"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"noDueDate"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"},"arguments":[],"directives":[]}]}}]}}]}}]}}]}}]}}]};

    export function useTeamReportByLabelQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TeamReportByLabelQuery, TeamReportByLabelQueryVariables>) {
      return ApolloReactHooks.useQuery<TeamReportByLabelQuery, TeamReportByLabelQueryVariables>(TeamReportByLabelDocument, baseOptions);
    }
      export function useTeamReportByLabelLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TeamReportByLabelQuery, TeamReportByLabelQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<TeamReportByLabelQuery, TeamReportByLabelQueryVariables>(TeamReportByLabelDocument, baseOptions);
      }
      
export type TeamReportByLabelQueryHookResult = ReturnType<typeof useTeamReportByLabelQuery>;
export type TeamReportByLabelQueryResult = ApolloReactCommon.QueryResult<TeamReportByLabelQuery, TeamReportByLabelQueryVariables>;
export const TeamReportCardsDocument: DocumentNode = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TeamReportCards"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cards"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"},"arguments":[]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"board"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"prefs"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"backgroundBottomColor"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"backgroundColor"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"backgroundImage"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"backgroundBrightness"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"list"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"due"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"dueComplete"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]}]}}]}}]};

    export function useTeamReportCardsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TeamReportCardsQuery, TeamReportCardsQueryVariables>) {
      return ApolloReactHooks.useQuery<TeamReportCardsQuery, TeamReportCardsQueryVariables>(TeamReportCardsDocument, baseOptions);
    }
      export function useTeamReportCardsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TeamReportCardsQuery, TeamReportCardsQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<TeamReportCardsQuery, TeamReportCardsQueryVariables>(TeamReportCardsDocument, baseOptions);
      }
      
export type TeamReportCardsQueryHookResult = ReturnType<typeof useTeamReportCardsQuery>;
export type TeamReportCardsQueryResult = ApolloReactCommon.QueryResult<TeamReportCardsQuery, TeamReportCardsQueryVariables>;
export const TeamReportLabelNamesDocument: DocumentNode = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TeamReportLabelNames"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"},"arguments":[]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"stats"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"labelNames"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"incomplete"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"stats"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ids"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"totalUses"},"arguments":[],"directives":[]}]}}]}}]}}]}}]}}]};

    export function useTeamReportLabelNamesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TeamReportLabelNamesQuery, TeamReportLabelNamesQueryVariables>) {
      return ApolloReactHooks.useQuery<TeamReportLabelNamesQuery, TeamReportLabelNamesQueryVariables>(TeamReportLabelNamesDocument, baseOptions);
    }
      export function useTeamReportLabelNamesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TeamReportLabelNamesQuery, TeamReportLabelNamesQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<TeamReportLabelNamesQuery, TeamReportLabelNamesQueryVariables>(TeamReportLabelNamesDocument, baseOptions);
      }
      
export type TeamReportLabelNamesQueryHookResult = ReturnType<typeof useTeamReportLabelNamesQuery>;
export type TeamReportLabelNamesQueryResult = ApolloReactCommon.QueryResult<TeamReportLabelNamesQuery, TeamReportLabelNamesQueryVariables>;
export const TeamReportOrganizationDocument: DocumentNode = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TeamReportOrganization"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"},"arguments":[]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]}]}}]}}]};

    export function useTeamReportOrganizationQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TeamReportOrganizationQuery, TeamReportOrganizationQueryVariables>) {
      return ApolloReactHooks.useQuery<TeamReportOrganizationQuery, TeamReportOrganizationQueryVariables>(TeamReportOrganizationDocument, baseOptions);
    }
      export function useTeamReportOrganizationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TeamReportOrganizationQuery, TeamReportOrganizationQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<TeamReportOrganizationQuery, TeamReportOrganizationQueryVariables>(TeamReportOrganizationDocument, baseOptions);
      }
      
export type TeamReportOrganizationQueryHookResult = ReturnType<typeof useTeamReportOrganizationQuery>;
export type TeamReportOrganizationQueryResult = ApolloReactCommon.QueryResult<TeamReportOrganizationQuery, TeamReportOrganizationQueryVariables>;
export const TeamfulCollaborationAddBoardsDocument: DocumentNode = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TeamfulCollaborationAddBoards"},"variableDefinitions":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"member"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"StringValue","value":"me","block":false}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"},"arguments":[]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"enterprises"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"boards"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"EnumValue","value":"open"}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enterpriseOwned"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"idOrganization"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"memberships"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idMember"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"memberType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"unconfirmed"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"prefs"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"backgroundColor"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"backgroundImage"},"arguments":[],"directives":[]}]}}]}}]}}]}}]};

    export function useTeamfulCollaborationAddBoardsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TeamfulCollaborationAddBoardsQuery, TeamfulCollaborationAddBoardsQueryVariables>) {
      return ApolloReactHooks.useQuery<TeamfulCollaborationAddBoardsQuery, TeamfulCollaborationAddBoardsQueryVariables>(TeamfulCollaborationAddBoardsDocument, baseOptions);
    }
      export function useTeamfulCollaborationAddBoardsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TeamfulCollaborationAddBoardsQuery, TeamfulCollaborationAddBoardsQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<TeamfulCollaborationAddBoardsQuery, TeamfulCollaborationAddBoardsQueryVariables>(TeamfulCollaborationAddBoardsDocument, baseOptions);
      }
      
export type TeamfulCollaborationAddBoardsQueryHookResult = ReturnType<typeof useTeamfulCollaborationAddBoardsQuery>;
export type TeamfulCollaborationAddBoardsQueryResult = ApolloReactCommon.QueryResult<TeamfulCollaborationAddBoardsQuery, TeamfulCollaborationAddBoardsQueryVariables>;
export const TeamfulCollaborationMoveBoardToOrgDocument: DocumentNode = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"TeamfulCollaborationMoveBoardToOrg"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"boardId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateBoardOrg"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"boardId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"boardId"}}},{"kind":"Argument","name":{"kind":"Name","value":"orgId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"},"arguments":[]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]}]}}]}}]};
export type TeamfulCollaborationMoveBoardToOrgMutationFn = ApolloReactCommon.MutationFunction<TeamfulCollaborationMoveBoardToOrgMutation, TeamfulCollaborationMoveBoardToOrgMutationVariables>;

    export function useTeamfulCollaborationMoveBoardToOrgMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<TeamfulCollaborationMoveBoardToOrgMutation, TeamfulCollaborationMoveBoardToOrgMutationVariables>) {
      return ApolloReactHooks.useMutation<TeamfulCollaborationMoveBoardToOrgMutation, TeamfulCollaborationMoveBoardToOrgMutationVariables>(TeamfulCollaborationMoveBoardToOrgDocument, baseOptions);
    }
export type TeamfulCollaborationMoveBoardToOrgMutationHookResult = ReturnType<typeof useTeamfulCollaborationMoveBoardToOrgMutation>;
export type TeamfulCollaborationMoveBoardToOrgMutationResult = ApolloReactCommon.MutationResult<TeamfulCollaborationMoveBoardToOrgMutation>;
export type TeamfulCollaborationMoveBoardToOrgMutationOptions = ApolloReactCommon.BaseMutationOptions<TeamfulCollaborationMoveBoardToOrgMutation, TeamfulCollaborationMoveBoardToOrgMutationVariables>;
export const TeamfulCollaborationAddPeopleToOrgDocument: DocumentNode = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"TeamfulCollaborationAddPeopleToOrg"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"users"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MemberOrEmail"}}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addMembersToOrg"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orgId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}}},{"kind":"Argument","name":{"kind":"Name","value":"users"},"value":{"kind":"Variable","name":{"kind":"Name","value":"users"}}},{"kind":"Argument","name":{"kind":"Name","value":"invitationMessage"},"value":{"kind":"StringValue","value":"","block":false}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"},"arguments":[]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"error"},"arguments":[],"directives":[]}]}}]}}]};
export type TeamfulCollaborationAddPeopleToOrgMutationFn = ApolloReactCommon.MutationFunction<TeamfulCollaborationAddPeopleToOrgMutation, TeamfulCollaborationAddPeopleToOrgMutationVariables>;

    export function useTeamfulCollaborationAddPeopleToOrgMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<TeamfulCollaborationAddPeopleToOrgMutation, TeamfulCollaborationAddPeopleToOrgMutationVariables>) {
      return ApolloReactHooks.useMutation<TeamfulCollaborationAddPeopleToOrgMutation, TeamfulCollaborationAddPeopleToOrgMutationVariables>(TeamfulCollaborationAddPeopleToOrgDocument, baseOptions);
    }
export type TeamfulCollaborationAddPeopleToOrgMutationHookResult = ReturnType<typeof useTeamfulCollaborationAddPeopleToOrgMutation>;
export type TeamfulCollaborationAddPeopleToOrgMutationResult = ApolloReactCommon.MutationResult<TeamfulCollaborationAddPeopleToOrgMutation>;
export type TeamfulCollaborationAddPeopleToOrgMutationOptions = ApolloReactCommon.BaseMutationOptions<TeamfulCollaborationAddPeopleToOrgMutation, TeamfulCollaborationAddPeopleToOrgMutationVariables>;
export const TeamfulCollaborationAddPeopleDocument: DocumentNode = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TeamfulCollaborationAddPeople"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"},"arguments":[]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"boards"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"memberships"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idMember"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"unconfirmed"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"members"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]}]}}]}}]}}]};

    export function useTeamfulCollaborationAddPeopleQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TeamfulCollaborationAddPeopleQuery, TeamfulCollaborationAddPeopleQueryVariables>) {
      return ApolloReactHooks.useQuery<TeamfulCollaborationAddPeopleQuery, TeamfulCollaborationAddPeopleQueryVariables>(TeamfulCollaborationAddPeopleDocument, baseOptions);
    }
      export function useTeamfulCollaborationAddPeopleLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TeamfulCollaborationAddPeopleQuery, TeamfulCollaborationAddPeopleQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<TeamfulCollaborationAddPeopleQuery, TeamfulCollaborationAddPeopleQueryVariables>(TeamfulCollaborationAddPeopleDocument, baseOptions);
      }
      
export type TeamfulCollaborationAddPeopleQueryHookResult = ReturnType<typeof useTeamfulCollaborationAddPeopleQuery>;
export type TeamfulCollaborationAddPeopleQueryResult = ApolloReactCommon.QueryResult<TeamfulCollaborationAddPeopleQuery, TeamfulCollaborationAddPeopleQueryVariables>;
export const TeamfulCollaborationAddPeopleSortDocument: DocumentNode = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TeamfulCollaborationAddPeopleSort"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"memberIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"members"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"memberIds"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"},"arguments":[]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fullName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nonPublic"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"},"arguments":[],"directives":[]}]}}]}}]}}]};

    export function useTeamfulCollaborationAddPeopleSortQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TeamfulCollaborationAddPeopleSortQuery, TeamfulCollaborationAddPeopleSortQueryVariables>) {
      return ApolloReactHooks.useQuery<TeamfulCollaborationAddPeopleSortQuery, TeamfulCollaborationAddPeopleSortQueryVariables>(TeamfulCollaborationAddPeopleSortDocument, baseOptions);
    }
      export function useTeamfulCollaborationAddPeopleSortLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TeamfulCollaborationAddPeopleSortQuery, TeamfulCollaborationAddPeopleSortQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<TeamfulCollaborationAddPeopleSortQuery, TeamfulCollaborationAddPeopleSortQueryVariables>(TeamfulCollaborationAddPeopleSortDocument, baseOptions);
      }
      
export type TeamfulCollaborationAddPeopleSortQueryHookResult = ReturnType<typeof useTeamfulCollaborationAddPeopleSortQuery>;
export type TeamfulCollaborationAddPeopleSortQueryResult = ApolloReactCommon.QueryResult<TeamfulCollaborationAddPeopleSortQuery, TeamfulCollaborationAddPeopleSortQueryVariables>;
export const TeamfulCollaborationSuccessMessageDocument: DocumentNode = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TeamfulCollaborationSuccessMessage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"},"arguments":[]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"displayName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"members"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"username"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"avatarSource"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"avatarHash"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"initials"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fullName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"products"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nonPublic"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"initials"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fullName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"avatarHash"},"arguments":[],"directives":[]}]}}]}}]}}]}}]};

    export function useTeamfulCollaborationSuccessMessageQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TeamfulCollaborationSuccessMessageQuery, TeamfulCollaborationSuccessMessageQueryVariables>) {
      return ApolloReactHooks.useQuery<TeamfulCollaborationSuccessMessageQuery, TeamfulCollaborationSuccessMessageQueryVariables>(TeamfulCollaborationSuccessMessageDocument, baseOptions);
    }
      export function useTeamfulCollaborationSuccessMessageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TeamfulCollaborationSuccessMessageQuery, TeamfulCollaborationSuccessMessageQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<TeamfulCollaborationSuccessMessageQuery, TeamfulCollaborationSuccessMessageQueryVariables>(TeamfulCollaborationSuccessMessageDocument, baseOptions);
      }
      
export type TeamfulCollaborationSuccessMessageQueryHookResult = ReturnType<typeof useTeamfulCollaborationSuccessMessageQuery>;
export type TeamfulCollaborationSuccessMessageQueryResult = ApolloReactCommon.QueryResult<TeamfulCollaborationSuccessMessageQuery, TeamfulCollaborationSuccessMessageQueryVariables>;
export const TeamlessCollaborationCreateTeamAddMembersDocument: DocumentNode = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"TeamlessCollaborationCreateTeamAddMembers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"users"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MemberOrEmail"}}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addMembersToOrg"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orgId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}}},{"kind":"Argument","name":{"kind":"Name","value":"users"},"value":{"kind":"Variable","name":{"kind":"Name","value":"users"}}},{"kind":"Argument","name":{"kind":"Name","value":"invitationMessage"},"value":{"kind":"StringValue","value":"","block":false}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"},"arguments":[]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"error"},"arguments":[],"directives":[]}]}}]}}]};
export type TeamlessCollaborationCreateTeamAddMembersMutationFn = ApolloReactCommon.MutationFunction<TeamlessCollaborationCreateTeamAddMembersMutation, TeamlessCollaborationCreateTeamAddMembersMutationVariables>;

    export function useTeamlessCollaborationCreateTeamAddMembersMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<TeamlessCollaborationCreateTeamAddMembersMutation, TeamlessCollaborationCreateTeamAddMembersMutationVariables>) {
      return ApolloReactHooks.useMutation<TeamlessCollaborationCreateTeamAddMembersMutation, TeamlessCollaborationCreateTeamAddMembersMutationVariables>(TeamlessCollaborationCreateTeamAddMembersDocument, baseOptions);
    }
export type TeamlessCollaborationCreateTeamAddMembersMutationHookResult = ReturnType<typeof useTeamlessCollaborationCreateTeamAddMembersMutation>;
export type TeamlessCollaborationCreateTeamAddMembersMutationResult = ApolloReactCommon.MutationResult<TeamlessCollaborationCreateTeamAddMembersMutation>;
export type TeamlessCollaborationCreateTeamAddMembersMutationOptions = ApolloReactCommon.BaseMutationOptions<TeamlessCollaborationCreateTeamAddMembersMutation, TeamlessCollaborationCreateTeamAddMembersMutationVariables>;
export const TeamlessCollaborationCreateTeamMembersDocument: DocumentNode = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TeamlessCollaborationCreateTeamMembers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"boardId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"board"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"boardId"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"},"arguments":[]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"members"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"confirmed"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fullName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nonPublic"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"},"arguments":[],"directives":[]}]}}]}}]}}]}}]};

    export function useTeamlessCollaborationCreateTeamMembersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TeamlessCollaborationCreateTeamMembersQuery, TeamlessCollaborationCreateTeamMembersQueryVariables>) {
      return ApolloReactHooks.useQuery<TeamlessCollaborationCreateTeamMembersQuery, TeamlessCollaborationCreateTeamMembersQueryVariables>(TeamlessCollaborationCreateTeamMembersDocument, baseOptions);
    }
      export function useTeamlessCollaborationCreateTeamMembersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TeamlessCollaborationCreateTeamMembersQuery, TeamlessCollaborationCreateTeamMembersQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<TeamlessCollaborationCreateTeamMembersQuery, TeamlessCollaborationCreateTeamMembersQueryVariables>(TeamlessCollaborationCreateTeamMembersDocument, baseOptions);
      }
      
export type TeamlessCollaborationCreateTeamMembersQueryHookResult = ReturnType<typeof useTeamlessCollaborationCreateTeamMembersQuery>;
export type TeamlessCollaborationCreateTeamMembersQueryResult = ApolloReactCommon.QueryResult<TeamlessCollaborationCreateTeamMembersQuery, TeamlessCollaborationCreateTeamMembersQueryVariables>;
export const TeamlessCollaborationCreateTeamSubmitDocument: DocumentNode = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"TeamlessCollaborationCreateTeamSubmit"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"displayName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"type"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"desc"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"enterprise"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"allAdminsEnabled"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createOrganization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"displayName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"displayName"}}},{"kind":"Argument","name":{"kind":"Name","value":"type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"type"}}},{"kind":"Argument","name":{"kind":"Name","value":"desc"},"value":{"kind":"Variable","name":{"kind":"Name","value":"desc"}}},{"kind":"Argument","name":{"kind":"Name","value":"enterprise"},"value":{"kind":"Variable","name":{"kind":"Name","value":"enterprise"}}},{"kind":"Argument","name":{"kind":"Name","value":"allAdminsEnabled"},"value":{"kind":"Variable","name":{"kind":"Name","value":"allAdminsEnabled"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"},"arguments":[]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]}]}}]}}]};
export type TeamlessCollaborationCreateTeamSubmitMutationFn = ApolloReactCommon.MutationFunction<TeamlessCollaborationCreateTeamSubmitMutation, TeamlessCollaborationCreateTeamSubmitMutationVariables>;

    export function useTeamlessCollaborationCreateTeamSubmitMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<TeamlessCollaborationCreateTeamSubmitMutation, TeamlessCollaborationCreateTeamSubmitMutationVariables>) {
      return ApolloReactHooks.useMutation<TeamlessCollaborationCreateTeamSubmitMutation, TeamlessCollaborationCreateTeamSubmitMutationVariables>(TeamlessCollaborationCreateTeamSubmitDocument, baseOptions);
    }
export type TeamlessCollaborationCreateTeamSubmitMutationHookResult = ReturnType<typeof useTeamlessCollaborationCreateTeamSubmitMutation>;
export type TeamlessCollaborationCreateTeamSubmitMutationResult = ApolloReactCommon.MutationResult<TeamlessCollaborationCreateTeamSubmitMutation>;
export type TeamlessCollaborationCreateTeamSubmitMutationOptions = ApolloReactCommon.BaseMutationOptions<TeamlessCollaborationCreateTeamSubmitMutation, TeamlessCollaborationCreateTeamSubmitMutationVariables>;
export const TeamlessCollaborationPromptDocument: DocumentNode = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TeamlessCollaborationPrompt"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"boardId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"board"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"boardId"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"},"arguments":[]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"idOrganization"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"members"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"confirmed"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"memberships"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idMember"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"memberType"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"member"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"StringValue","value":"me","block":false}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"},"arguments":[]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"enterprises"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]}]}}]}}]}}]};

    export function useTeamlessCollaborationPromptQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TeamlessCollaborationPromptQuery, TeamlessCollaborationPromptQueryVariables>) {
      return ApolloReactHooks.useQuery<TeamlessCollaborationPromptQuery, TeamlessCollaborationPromptQueryVariables>(TeamlessCollaborationPromptDocument, baseOptions);
    }
      export function useTeamlessCollaborationPromptLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TeamlessCollaborationPromptQuery, TeamlessCollaborationPromptQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<TeamlessCollaborationPromptQuery, TeamlessCollaborationPromptQueryVariables>(TeamlessCollaborationPromptDocument, baseOptions);
      }
      
export type TeamlessCollaborationPromptQueryHookResult = ReturnType<typeof useTeamlessCollaborationPromptQuery>;
export type TeamlessCollaborationPromptQueryResult = ApolloReactCommon.QueryResult<TeamlessCollaborationPromptQuery, TeamlessCollaborationPromptQueryVariables>;
export const TemplateBackgroundImageScaleDocument: DocumentNode = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TemplateBackgroundImageScale"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idBoard"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"board"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idBoard"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"},"arguments":[]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"prefs"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"backgroundImageScaled"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"width"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"height"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[],"directives":[]}]}}]}}]}}]}}]};

    export function useTemplateBackgroundImageScaleQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TemplateBackgroundImageScaleQuery, TemplateBackgroundImageScaleQueryVariables>) {
      return ApolloReactHooks.useQuery<TemplateBackgroundImageScaleQuery, TemplateBackgroundImageScaleQueryVariables>(TemplateBackgroundImageScaleDocument, baseOptions);
    }
      export function useTemplateBackgroundImageScaleLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TemplateBackgroundImageScaleQuery, TemplateBackgroundImageScaleQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<TemplateBackgroundImageScaleQuery, TemplateBackgroundImageScaleQueryVariables>(TemplateBackgroundImageScaleDocument, baseOptions);
      }
      
export type TemplateBackgroundImageScaleQueryHookResult = ReturnType<typeof useTemplateBackgroundImageScaleQuery>;
export type TemplateBackgroundImageScaleQueryResult = ApolloReactCommon.QueryResult<TemplateBackgroundImageScaleQuery, TemplateBackgroundImageScaleQueryVariables>;
export const TemplateCategoriesDocument: DocumentNode = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TemplateCategories"},"variableDefinitions":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"templateCategories"},"arguments":[],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"},"arguments":[]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"},"arguments":[],"directives":[]}]}}]}}]};

    export function useTemplateCategoriesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TemplateCategoriesQuery, TemplateCategoriesQueryVariables>) {
      return ApolloReactHooks.useQuery<TemplateCategoriesQuery, TemplateCategoriesQueryVariables>(TemplateCategoriesDocument, baseOptions);
    }
      export function useTemplateCategoriesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TemplateCategoriesQuery, TemplateCategoriesQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<TemplateCategoriesQuery, TemplateCategoriesQueryVariables>(TemplateCategoriesDocument, baseOptions);
      }
      
export type TemplateCategoriesQueryHookResult = ReturnType<typeof useTemplateCategoriesQuery>;
export type TemplateCategoriesQueryResult = ApolloReactCommon.QueryResult<TemplateCategoriesQuery, TemplateCategoriesQueryVariables>;
export const TemplateGalleryDocument: DocumentNode = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TemplateGallery"},"variableDefinitions":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"templateGallery"},"arguments":[],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"},"arguments":[]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"desc"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"idOrganization"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"shortLink"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"prefs"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"background"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"backgroundColor"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"backgroundImage"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"backgroundImageScaled"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"width"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"height"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"templateGallery"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"avatarShape"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"byline"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"category"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"precedence"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"blurb"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"featured"},"arguments":[],"directives":[]}]}}]}}]}}]};

    export function useTemplateGalleryQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TemplateGalleryQuery, TemplateGalleryQueryVariables>) {
      return ApolloReactHooks.useQuery<TemplateGalleryQuery, TemplateGalleryQueryVariables>(TemplateGalleryDocument, baseOptions);
    }
      export function useTemplateGalleryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TemplateGalleryQuery, TemplateGalleryQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<TemplateGalleryQuery, TemplateGalleryQueryVariables>(TemplateGalleryDocument, baseOptions);
      }
      
export type TemplateGalleryQueryHookResult = ReturnType<typeof useTemplateGalleryQuery>;
export type TemplateGalleryQueryResult = ApolloReactCommon.QueryResult<TemplateGalleryQuery, TemplateGalleryQueryVariables>;
export const TemplatesStoryDocument: DocumentNode = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TemplatesStory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"boardId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"board"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"boardId"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"},"arguments":[]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"desc"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"members"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"avatarHash"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fullName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"initials"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"organization"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"logoHash"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"plugins"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"EnumValue","value":"enabled"}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"icon"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"listing"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"overview"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"prefs"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isTemplate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"background"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"backgroundColor"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"backgroundImage"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"shortUrl"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"templateGallery"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"avatarShape"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"byline"},"arguments":[],"directives":[]}]}}]}}]}}]};

    export function useTemplatesStoryQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TemplatesStoryQuery, TemplatesStoryQueryVariables>) {
      return ApolloReactHooks.useQuery<TemplatesStoryQuery, TemplatesStoryQueryVariables>(TemplatesStoryDocument, baseOptions);
    }
      export function useTemplatesStoryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TemplatesStoryQuery, TemplatesStoryQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<TemplatesStoryQuery, TemplatesStoryQueryVariables>(TemplatesStoryDocument, baseOptions);
      }
      
export type TemplatesStoryQueryHookResult = ReturnType<typeof useTemplatesStoryQuery>;
export type TemplatesStoryQueryResult = ApolloReactCommon.QueryResult<TemplatesStoryQuery, TemplatesStoryQueryVariables>;
export const UpgradePromptDismissMessageDocument: DocumentNode = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpgradePromptDismissMessage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"messageId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addOneTimeMessagesDismissed"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"memberId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}}},{"kind":"Argument","name":{"kind":"Name","value":"messageId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"messageId"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"},"arguments":[]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"oneTimeMessagesDismissed"},"arguments":[],"directives":[]}]}}]}}]};
export type UpgradePromptDismissMessageMutationFn = ApolloReactCommon.MutationFunction<UpgradePromptDismissMessageMutation, UpgradePromptDismissMessageMutationVariables>;

    export function useUpgradePromptDismissMessageMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpgradePromptDismissMessageMutation, UpgradePromptDismissMessageMutationVariables>) {
      return ApolloReactHooks.useMutation<UpgradePromptDismissMessageMutation, UpgradePromptDismissMessageMutationVariables>(UpgradePromptDismissMessageDocument, baseOptions);
    }
export type UpgradePromptDismissMessageMutationHookResult = ReturnType<typeof useUpgradePromptDismissMessageMutation>;
export type UpgradePromptDismissMessageMutationResult = ApolloReactCommon.MutationResult<UpgradePromptDismissMessageMutation>;
export type UpgradePromptDismissMessageMutationOptions = ApolloReactCommon.BaseMutationOptions<UpgradePromptDismissMessageMutation, UpgradePromptDismissMessageMutationVariables>;
export const UpgradePromptDocument: DocumentNode = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UpgradePrompt"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"member"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"},"arguments":[]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"oneTimeMessagesDismissed"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"},"arguments":[]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"products"},"arguments":[],"directives":[]}]}}]}}]};

    export function useUpgradePromptQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<UpgradePromptQuery, UpgradePromptQueryVariables>) {
      return ApolloReactHooks.useQuery<UpgradePromptQuery, UpgradePromptQueryVariables>(UpgradePromptDocument, baseOptions);
    }
      export function useUpgradePromptLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UpgradePromptQuery, UpgradePromptQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<UpgradePromptQuery, UpgradePromptQueryVariables>(UpgradePromptDocument, baseOptions);
      }
      
export type UpgradePromptQueryHookResult = ReturnType<typeof useUpgradePromptQuery>;
export type UpgradePromptQueryResult = ApolloReactCommon.QueryResult<UpgradePromptQuery, UpgradePromptQueryVariables>;